// Generated by scripts/gen_more_airports.py from OurAirports (public domain,
// https://ourairports.com/data/). Do not edit by hand: rerun the script.
import type { Airport } from './airports';

const COUNTRIES: Record<string, string> = {
    AE: 'United Arab Emirates',
    AF: 'Afghanistan',
    AG: 'Antigua and Barbuda',
    AI: 'Anguilla',
    AL: 'Albania',
    AM: 'Armenia',
    AO: 'Angola',
    AR: 'Argentina',
    AS: 'American Samoa',
    AT: 'Austria',
    AU: 'Australia',
    AW: 'Aruba',
    AZ: 'Azerbaijan',
    BA: 'Bosnia and Herzegovina',
    BB: 'Barbados',
    BD: 'Bangladesh',
    BE: 'Belgium',
    BF: 'Burkina Faso',
    BG: 'Bulgaria',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'Saint Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei',
    BO: 'Bolivia',
    BQ: 'Caribbean Netherlands',
    BR: 'Brazil',
    BS: 'Bahamas',
    BT: 'Bhutan',
    BW: 'Botswana',
    BY: 'Belarus',
    BZ: 'Belize',
    CA: 'Canada',
    CC: 'Cocos (Keeling) Islands',
    CD: 'Democratic Republic of the Congo',
    CF: 'Central African Republic',
    CG: 'Republic of the Congo',
    CH: 'Switzerland',
    CI: 'Côte d\'Ivoire',
    CK: 'Cook Islands',
    CL: 'Chile',
    CM: 'Cameroon',
    CN: 'China',
    CO: 'Colombia',
    CR: 'Costa Rica',
    CU: 'Cuba',
    CV: 'Cape Verde',
    CW: 'Curaçao',
    CX: 'Christmas Island',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DE: 'Germany',
    DJ: 'Djibouti',
    DK: 'Denmark',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    DZ: 'Algeria',
    EC: 'Ecuador',
    EE: 'Estonia',
    EG: 'Egypt',
    EH: 'Western Sahara (disputed territory)',
    ER: 'Eritrea',
    ES: 'Spain',
    ET: 'Ethiopia',
    FI: 'Finland',
    FJ: 'Fiji',
    FK: 'Falkland Islands',
    FM: 'Micronesia',
    FO: 'Faroe Islands',
    FR: 'France',
    GA: 'Gabon',
    GB: 'United Kingdom',
    GD: 'Grenada',
    GE: 'Georgia',
    GF: 'French Guiana',
    GG: 'Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Greenland',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Equatorial Guinea',
    GR: 'Greece',
    GT: 'Guatemala',
    GU: 'Guam',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HN: 'Honduras',
    HR: 'Croatia',
    HT: 'Haiti',
    HU: 'Hungary',
    ID: 'Indonesia',
    IE: 'Ireland',
    IL: 'Israel',
    IM: 'Isle of Man',
    IN: 'India',
    IQ: 'Iraq',
    IR: 'Iran',
    IS: 'Iceland',
    IT: 'Italy',
    JE: 'Jersey',
    JM: 'Jamaica',
    JO: 'Jordan',
    JP: 'Japan',
    KE: 'Kenya',
    KG: 'Kyrgyzstan',
    KH: 'Cambodia',
    KI: 'Kiribati',
    KM: 'Comoros',
    KN: 'Saint Kitts and Nevis',
    KP: 'North Korea',
    KR: 'South Korea',
    KW: 'Kuwait',
    KY: 'Cayman Islands',
    KZ: 'Kazakhstan',
    LA: 'Laos',
    LB: 'Lebanon',
    LC: 'Saint Lucia',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    LY: 'Libya',
    MA: 'Morocco',
    MD: 'Moldova',
    ME: 'Montenegro',
    MF: 'Saint Martin',
    MG: 'Madagascar',
    MH: 'Marshall Islands',
    MK: 'North Macedonia',
    ML: 'Mali',
    MM: 'Myanmar',
    MN: 'Mongolia',
    MO: 'Macau',
    MP: 'Northern Mariana Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MS: 'Montserrat',
    MU: 'Mauritius',
    MV: 'Maldives',
    MW: 'Malawi',
    MX: 'Mexico',
    MY: 'Malaysia',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NC: 'New Caledonia',
    NE: 'Niger',
    NF: 'Norfolk Island',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Netherlands',
    NO: 'Norway',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'New Zealand',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'French Polynesia',
    PG: 'Papua New Guinea',
    PH: 'Philippines',
    PK: 'Pakistan',
    PL: 'Poland',
    PM: 'Saint Pierre and Miquelon',
    PR: 'Puerto Rico',
    PT: 'Portugal',
    PW: 'Palau',
    PY: 'Paraguay',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Romania',
    RS: 'Serbia',
    RU: 'Russia',
    RW: 'Rwanda',
    SA: 'Saudi Arabia',
    SB: 'Solomon Islands',
    SC: 'Seychelles',
    SD: 'Sudan',
    SE: 'Sweden',
    SG: 'Singapore',
    SH: 'Saint Helena, Ascension and Tristan da Cunha',
    SI: 'Slovenia',
    SK: 'Slovakia',
    SL: 'Sierra Leone',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Suriname',
    SS: 'South Sudan',
    ST: 'São Tomé and Principe',
    SV: 'El Salvador',
    SX: 'Sint Maarten',
    SY: 'Syria',
    SZ: 'Eswatini',
    TC: 'Turks and Caicos Islands',
    TD: 'Chad',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tajikistan',
    TL: 'Timor-Leste',
    TM: 'Turkmenistan',
    TN: 'Tunisia',
    TO: 'Tonga',
    TR: 'Turkey',
    TT: 'Trinidad and Tobago',
    TV: 'Tuvalu',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    UG: 'Uganda',
    UM: 'United States Minor Outlying Islands',
    US: 'United States',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VC: 'Saint Vincent and the Grenadines',
    VE: 'Venezuela',
    VG: 'British Virgin Islands',
    VI: 'U.S. Virgin Islands',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis and Futuna',
    WS: 'Samoa',
    XK: 'Kosovo',
    YE: 'Yemen',
    YT: 'Mayotte',
    ZA: 'South Africa',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
};

// code|name|city|region|country code|lat|lon|size (L large, M medium: read by the
// trip-intake playbook's nearest-airport fallback, not used here)
const ROWS = `
AAA|Anaa Airport|Anaa||PF|-17.3526|-145.5100|M
AAC|El Arish International Airport|El Arish|North Sinai Governorate|EG|31.0553|33.8280|L
AAE|Annaba Rabah Bitat Airport|Annaba|Annaba Province|DZ|36.8268|7.8133|L
AAL|Aalborg Airport|Aalborg|North Jutland|DK|57.0948|9.8499|L
AAN|Al Ain International Airport|Al Ain|Abu Dhabi Emirate|AE|24.2617|55.6092|L
AAP|Aji Pangeran Tumenggung Pranoto International Airport|Samarinda|Kalimantan Timur (East Kalimantan)|ID|-0.3745|117.2501|M
AAR|Aarhus Airport|Aarhus|Central Jutland|DK|56.3033|10.6183|L
AAT|Altay Xuedu Airport|Altay|Xinjiang Autonomous Region|CN|47.7499|88.0858|M
AAX|Romeu Zema Airport|Araxá|Minas Gerais|BR|-19.5632|-46.9604|M
AAY|Al Ghaydah International Airport|Al Ghaydah|Al Mahrah Governorate|YE|16.1933|52.1742|M
ABA|Abakan International Airport|Abakan|Republic of Khakassia|RU|53.7400|91.3850|L
ABB|Asaba International Airport|Asaba|Delta State|NG|6.2042|6.6653|L
ABD|Abadan Ayatollah Jami International Airport|Abadan|Khuzestan Province|IR|30.3679|48.2301|L
ABE|Lehigh Valley International Airport|Allentown/Bethlehem|Pennsylvania|US|40.6518|-75.4428|M
ABI|Abilene Regional Airport|Abilene|Texas|US|32.4113|-99.6819|M
ABJ|Félix-Houphouët-Boigny International Airport|Abidjan|Abidjan (autonomous district)|CI|5.2614|-3.9263|L
ABK|Kebri Dahar Airport|Kebri Dahar|Somali Region|ET|6.7326|44.2413|M
ABL|Ambler Airport|Ambler|Alaska|US|67.1055|-157.8553|M
ABQ|Albuquerque International Sunport|Albuquerque|New Mexico|US|35.0400|-106.6089|L
ABR|Aberdeen Regional Airport|Aberdeen|South Dakota|US|45.4491|-98.4218|M
ABS|Abu Simbel Airport|Abu Simbel|Aswan Governorate|EG|22.3759|31.6117|M
ABT|King Saud Bin Abdulaziz (Al Baha) Airport|Al-Baha|Al Batah Region|SA|20.2985|41.6362|M
ABV|Nnamdi Azikiwe International Airport|Abuja|Abuja Capital Territory|NG|9.0068|7.2632|L
ABX|Albury Airport|East Albury|New South Wales|AU|-36.0668|146.9591|M
ABY|Southwest Georgia Regional Airport|Albany|Georgia|US|31.5329|-84.1962|M
ABZ|Aberdeen International Airport|Aberdeen|Scotland|GB|57.2019|-2.1978|L
ACA|General Juan N. Álvarez International Airport|Acapulco|Guerrero|MX|16.7571|-99.7531|L
ACE|César Manrique-Lanzarote Airport|San Bartolomé|Canary Islands|ES|28.9455|-13.6052|L
ACH|Sankt Gallen Altenrhein Airport|St. Gallen|St. Gallen|CH|47.4850|9.5608|M
ACI|Alderney Airport|Saint Anne|Alderney|GG|49.7061|-2.2147|M
ACK|Nantucket Memorial Airport|Nantucket|Massachusetts|US|41.2531|-70.0602|M
ACT|Waco Regional Airport|Waco|Texas|US|31.6113|-97.2305|M
ACV|California Redwood Coast-Humboldt County Airport|Arcata/Eureka|California|US|40.9781|-124.1090|M
ACX|Xingyi Wanfenglin Airport|Xingyi|Guizhou Province|CN|25.0834|104.9608|M
ACY|Atlantic City International Airport|Atlantic City|New Jersey|US|39.4562|-74.5775|M
ADB|Adnan Menderes International Airport|Gaziemir|İzmir Province|TR|38.2924|27.1570|L
ADE|Aden International Airport|Aden|Aden Governorate|YE|12.8296|45.0300|L
ADF|Adıyaman Airport|Adıyaman|Adıyaman Province|TR|37.7314|38.4689|M
ADJ|Marka International (Amman Civil) Airport|Amman|Amman Governorate|JO|31.9727|35.9916|L
ADK|Adak Airport|Adak|Alaska|US|51.8836|-176.6428|M
ADL|Adelaide International Airport|Adelaide|South Australia|AU|-34.9475|138.5334|L
ADQ|Kodiak Airport|Kodiak|Alaska|US|57.7500|-152.4940|M
ADU|Ardabil Airport|Ardabil|Ardabil Province|IR|38.3257|48.4244|M
ADZ|Gustavo Rojas Pinilla International Airport|San Andrés|San Andrés, Providencia y Santa Catalina Department|CO|12.5836|-81.7112|L
AEB|Baise (Bose) Bama Airport|Baise (Tianyang)|Guangxi Autonomous Region|CN|23.7206|106.9600|M
AEP|Aeroparque Jorge Newbery|Buenos Aires|Buenos Aires (Autonomous City)|AR|-34.5594|-58.4155|L
AER|Sochi International Airport|Sochi|Krasnodar Krai|RU|43.4499|39.9566|L
AES|Ålesund Airport|Ålesund|Møre og Romsdal|NO|62.5604|6.1108|L
AEU|Abu Musa Island Airport|Abu Musa|Hormozgan Province|IR|25.8757|55.0330|M
AEX|Alexandria International Airport|Alexandria|Louisiana|US|31.3258|-92.5467|M
AEY|Akureyri International Airport|Akureyri|Northeastern Region|IS|65.6566|-18.0720|L
AFA|Suboficial Ay Santiago Germano Airport|San Rafael|Mendoza Province|AR|-34.5883|-68.4039|M
AFL|Piloto Osvaldo Marques Dias Airport|Alta Floresta|Mato Grosso|BR|-9.8664|-56.1063|M
AFZ|Sabzevar National Airport|Sabzevar|Razavi Khorasan Province|IR|36.1681|57.5952|M
AGA|Al Massira Airport|Agadir (Temsia)|Souss-Massa Region|MA|30.3225|-9.4120|L
AGH|Ängelholm-Helsingborg Airport|Ängelholm|Skåne län|SE|56.2961|12.8471|M
AGR|Agra Airport / Agra Air Force Station|Agra|Uttar Pradesh|IN|27.1580|77.9610|M
AGS|Augusta Regional At Bush Field|Augusta|Georgia|US|33.3699|-81.9645|M
AGT|Guaraní International Airport|Ciudad del Este|Alto Paraná Department|PY|-25.4555|-54.8436|L
AGU|Aguascalientes International Airport|Aguascalientes|Aguascalientes|MX|21.6996|-102.3184|L
AGX|Agatti Airport|Agatti|Lakshadweep|IN|10.8237|72.1760|M
AHA|Maa Mahamaya Airport|Ambikapur|Chhattisgarh|IN|22.9875|83.1961|M
AHB|Abha International Airport|Abha|Asir Region|SA|18.2404|42.6566|L
AHE|Ahe Airport|Ahe Atoll||PF|-14.4281|-146.2570|M
AHO|Alghero-Fertilia Airport|Alghero|Sardinia|IT|40.6321|8.2908|M
AHU|Cherif Al Idrissi Airport|Al Hoceima|Tanger-Tétouan-Al Hoceïma Region|MA|35.1771|-3.8395|M
AIA|Alliance Municipal Airport|Alliance|Nebraska|US|42.0525|-102.8040|M
AIN|Wainwright Airport|Wainwright|Alaska|US|70.6380|-159.9950|M
AJA|Ajaccio Napoléon Bonaparte airport|Ajaccio|Corsica|FR|41.9236|8.8029|M
AJF|Al-Jawf International Airport|Al-Jawf|Al Jawf Region|SA|29.7833|40.1009|L
AJI|Ağrı Airport|Ağrı|Ağrı Province|TR|39.6556|43.0257|M
AJL|Lengpui Airport|Aizawl (Lengpui)|Mizoram|IN|23.8406|92.6197|M
AJN|Ouani Airport|Ouani|Anjouan (Ndzouani)|KM|-12.1310|44.4300|M
AJR|Arvidsjaur Airport|Arvidsjaur|Norrbottena län|SE|65.5903|19.2819|M
AJU|Aracaju - Santa Maria Airport|Aracaju|Sergipe|BR|-10.9839|-37.0729|M
AKF|Kufra Airport|Kufra|Al Kufrah District|LY|24.1787|23.3140|M
AKJ|Asahikawa Airport|Higashikagura|Hokkaidō Prefecture|JP|43.6708|142.4470|M
AKN|King Salmon Airport|King Salmon|Alaska|US|58.6778|-156.6520|M
AKP|Anaktuvuk Pass Airport|Anaktuvuk Pass|Alaska|US|68.1336|-151.7430|M
AKR|Akure Airport|Akure|Ondo State|NG|7.2467|5.3010|M
AKU|Aksu Hongqipo Airport|Aksu (Onsu)|Xinjiang Autonomous Region|CN|41.2625|80.2917|M
AKX|Aktobe International Airport|Aktobe|Aktobe Region|KZ|50.2481|57.2041|L
AKY|Sittwe Airport|Sittwe|Rakhine State|MM|20.1332|92.8707|M
ALB|Albany International Airport|Albany|New York|US|42.7483|-73.8017|L
ALC|Alicante-Elche Miguel Hernández Airport|Alicante|Valencia (community)|ES|38.2822|-0.5582|L
ALF|Alta Airport|Alta|Finnmark|NO|69.9761|23.3717|M
ALG|Houari Boumediene Airport|Algiers|Algiers Province|DZ|36.6939|3.2145|L
ALH|Albany Airport|Albany|Western Australia|AU|-34.9433|117.8089|M
ALO|Waterloo Regional Airport|Waterloo|Iowa|US|42.5571|-92.4003|M
ALP|Aleppo International Airport|Aleppo|Aleppo Governorate|SY|36.1813|37.2269|L
ALS|San Luis Valley Regional Airport/Bergman Field|Alamosa|Colorado|US|37.4349|-105.8670|M
ALW|Walla Walla Regional Airport|Walla Walla|Washington|US|46.0949|-118.2880|M
AMA|Rick Husband Amarillo International Airport|Amarillo|Texas|US|35.2179|-101.7064|M
AMD|Sardar Vallabh Patel International Airport|Ahmedabad|Gujarat|IN|23.0772|72.6347|L
AMH|Arba Minch Airport|Arba Minch|Southern Nations, Nationalities, and Peoples' Region|ET|6.0394|37.5905|M
AMQ|Pattimura International Airport|Ambon|Maluku|ID|-3.7103|128.0890|L
AMV|Amderma Airport|Amderma|Nenets Autonomous Okrug|RU|69.7637|61.5567|M
ANC|Ted Stevens Anchorage International Airport|Anchorage|Alaska|US|61.1790|-149.9926|L
ANF|Andrés Sabella Gálvez International Airport|Antofagasta|Antofagasta Region|CL|-23.4453|-70.4452|L
ANI|Aniak Airport|Aniak|Alaska|US|61.5816|-159.5430|M
ANR|Antwerp International Airport (Deurne)|Antwerp|Antwerp Province|BE|51.1907|4.4632|M
ANU|V. C. Bird International Airport|Osbourn|Saint George Parish|AG|17.1367|-61.7927|L
ANV|Anvik Airport|Anvik|Alaska|US|62.6467|-160.1910|M
ANX|Andøya Airport, Andenes|Andenes|Nordland|NO|69.2952|16.1394|M
AOE|Hasan Polatkan Airport|Eskişehir|Eskişehir Province|TR|39.8116|30.5193|L
AOG|Anshan Teng'ao Airport / Anshan Air Base|Anshan|Liaoning Province|CN|41.1053|122.8540|M
AOI|Marche Airport|Falconara Marittima (AN)|Marche|IT|43.6163|13.3623|M
AOJ|Aomori Airport|Aomori|Aomori Prefecture|JP|40.7338|140.6895|L
AOK|Karpathos Airport|Karpathos Island|South Aegean|GR|35.4214|27.1460|M
AOO|Altoona Blair County Airport|Altoona|Pennsylvania|US|40.2964|-78.3200|M
AOR|Sultan Abdul Halim Airport|Alor Satar|Kedah|MY|6.1897|100.3980|M
APL|Nampula Airport|Nampula|Nampula Province|MZ|-15.1056|39.2818|L
APN|Alpena County Regional Airport|Alpena|Michigan|US|45.0781|-83.5603|M
APO|Antonio Roldán Betancur Airport|Carepa|Antioquía Department|CO|7.8120|-76.7164|M
APW|Faleolo International Airport|Apia|A'ana District|WS|-13.8300|-172.0080|L
AQA|Araraquara Airport|Araraquara|São Paulo|BR|-21.8120|-48.1330|M
AQG|Anqing Tianzhushan Airport / Anqing North Air Base|Anqing|Anhui Province|CN|30.5822|117.0500|M
AQI|Qaisumah–Hafar Al-Batin International Airport|Qaisumah|Ash Sharqiyah Region|SA|28.3357|46.1271|L
AQJ|King Hussein International Airport|Aqaba|Al 'Aqaba Governorate|JO|29.6116|35.0181|L
AQP|Rodríguez Ballón International Airport|Arequipa|Arequipa Region|PE|-16.3408|-71.5695|L
ARC|Arctic Village Airport|Arctic Village|Alaska|US|68.1147|-145.5790|M
ARH|Talagi Airport|Archangelsk|Arkhangelsk Oblast|RU|64.6003|40.7167|M
ARI|Chacalluta International Airport|Arica|Arica and Parinacota Region|CL|-18.3485|-70.3387|M
ARK|Arusha Airport|Arusha|Arusha Region|TZ|-3.3678|36.6333|M
ARM|Armidale Airport|Armidale|New South Wales|AU|-30.5281|151.6170|M
ART|Watertown International Airport|Watertown|New York|US|43.9919|-76.0217|M
ARU|Araçatuba Airport|Araçatuba|São Paulo|BR|-21.1415|-50.4246|M
ARW|Arad International Airport|Arad|Arad County|RO|46.1761|21.2643|M
ASB|Ashgabat International Airport|Ashgabat|Ashgabat (city)|TM|37.9868|58.3610|L
ASD|Andros Town Airport|Andros Town|North Andros|BS|24.6979|-77.7956|M
ASE|Aspen-Pitkin County Airport (Sardy Field)|Aspen|Colorado|US|39.2232|-106.8690|M
ASF|Astrakhan Narimanovo Boris M. Kustodiev International Airport|Astrakhan|Astrakhan Oblast|RU|46.2828|48.0105|L
ASI|RAF Ascension Island|Cat Hill|Ascension|SH|-7.9702|-14.3927|M
ASJ|Amami Airport|Amami|Kagoshima Prefecture|JP|28.4306|129.7130|M
ASM|Asmara International Airport|Asmara|Northern Red Sea Region|ER|15.2919|38.9107|M
ASO|Asosa Airport|Asosa|Benishangul-Gumuz Region|ET|10.0185|34.5863|M
ASP|Alice Springs Airport|Alice Springs|Northern Territory|AU|-23.8066|133.9034|M
ASR|Kayseri Erkilet International Airport|Kayseri|Kayseri Province|TR|38.7704|35.4954|L
ASU|Silvio Pettirossi International Airport|Asunción|Central Department|PY|-25.2402|-57.5192|L
ASV|Amboseli Airport|Ol Tukai|Kajiado County|KE|-2.6448|37.2529|M
ASW|Aswan International Airport|Aswan|Aswan Governorate|EG|23.9611|32.8204|L
ATC|Arthur's Town Airport|Arthur's Town|Cat Island|BS|24.6294|-75.6738|M
ATK|Atqasuk Edward Burnell Sr Memorial Airport|Atqasuk|Alaska|US|70.4670|-157.4360|M
ATM|Altamira Interstate Airport|Altamira|Pará|BR|-3.2531|-52.2539|M
ATQ|Sri Guru Ram Das Ji International Airport|Amritsar|Punjab|IN|31.7096|74.7973|L
ATW|Appleton International Airport|Appleton|Wisconsin|US|44.2585|-88.5190|M
ATY|Watertown Regional Airport|Watertown|South Dakota|US|44.9140|-97.1547|M
ATZ|Asyut International Airport|Asyut|Asyut Governorate|EG|27.0460|31.0128|L
AUA|Queen Beatrix International Airport|Oranjestad||AW|12.5011|-70.0143|L
AUC|Santiago Perez Airport|Arauca|Arauca Department|CO|7.0689|-70.7369|M
AUG|Augusta State Airport|Augusta|Maine|US|44.3206|-69.7973|M
AUQ|Hiva Oa-Atuona Airport|Hiva Oa Island||PF|-9.7688|-139.0110|M
AUR|Aurillac airport|Aurillac|Auvergne-Rhône-Alpes|FR|44.8914|2.4219|M
AUX|Araguaína Airport|Araguaína|Tocantins|BR|-7.2279|-48.2405|M
AVA|Anshun Huangguoshu Airport|Anshun (Xixiu)|Guizhou Province|CN|26.2606|105.8733|M
AVK|Arvaikheer Airport|Arvaikheer|Övörkhangai Province|MN|46.2503|102.8020|M
AVL|Asheville Regional Airport|Asheville|North Carolina|US|35.4355|-82.5419|M
AVN|Avignon Caumont airport|Avignon|Provence-Alpes-Côte-d'Azur|FR|43.9073|4.9018|M
AVP|Wilkes-Barre/Scranton International Airport|Wilkes-Barre/Scranton|Pennsylvania|US|41.3371|-75.7242|M
AVR|Amravati Airport|Amravati|Maharashtra|IN|20.8146|77.7178|M
AVV|Melbourne Avalon International Airport|Geelong/Melbourne|Victoria|AU|-38.0403|144.4672|L
AWA|Hawassa International Airport|Hawassa|Sidama Region|ET|7.1006|38.3965|L
AWK|Wake Island Airfield|Wake Island|Wake Island|UM|19.2824|166.6366|M
AWZ|Qasem Soleimani International Airport|Ahvaz|Khuzestan Province|IR|31.3364|48.7638|L
AXA|Clayton J. Lloyd International Airport|The Valley||AI|18.2048|-63.0538|M
AXD|Alexandroupoli Democritus Airport|Alexandroupolis|Eastern Macedonia and Thrace|GR|40.8559|25.9563|M
AXF|Alxa Left Banner Bayanhot Airport|Bayanhot|Inner Mongolia Autonomous Region|CN|38.7483|105.5842|M
AXJ|Amakusa Airport|Amakusa|Kumamoto Prefecture|JP|32.4825|130.1590|M
AXM|El Eden Airport|Armenia|Quindio Department|CO|4.4528|-75.7664|M
AXP|Spring Point Airport|Spring Point|Acklins|BS|22.4418|-73.9709|M
AXT|Akita Airport|Akita|Akita Prefecture|JP|39.6156|140.2190|M
AXU|Axum Airport|Axum|Tigray Region|ET|14.1468|38.7728|M
AYJ|Maharshi Valmiki International Airport|Faizabad|Uttar Pradesh|IN|26.7477|82.1637|M
AYP|Air Force Colonel Alfredo Mendivil Duarte Airport|Ayacucho|Ayacucho Region|PE|-13.1548|-74.2044|M
AYQ|Ayers Rock Connellan Airport|Yulara|Northern Territory|AU|-25.1859|130.9770|M
AZA|Mesa Gateway Airport|Mesa|Arizona|US|33.3078|-111.6550|M
AZD|Shahid Sadooghi Airport|Yazd|Yazd Province|IR|31.9049|54.2765|M
AZN|Andijan International Airport|Andijan|Andijan Region|UZ|40.7277|72.2940|M
AZO|Kalamazoo/Battle Creek International Airport|Kalamazoo|Michigan|US|42.2321|-85.5496|M
AZR|Touat-Cheikh Sidi Mohamed Belkebir Airport|Adrar|Adrar Province|DZ|27.8376|-0.1864|M
AZS|Samaná El Catey International Airport|Samana|Samaná Province|DO|19.2693|-69.7374|M
BAH|Bahrain International Airport|Manama|Muharraq Governorate|BH|26.2673|50.6376|L
BAL|Batman Airport|Batman|Batman Province|TR|37.9290|41.1166|M
BAQ|Ernesto Cortissoz International Airport|Barranquilla|Atlántico Department|CO|10.8896|-74.7808|L
BAR|Qionghai Bo'ao Airport|Qionghai (Basuo)|Hainan Province|CN|19.1410|110.4528|M
BAV|Baotou Donghe International Airport|Baotou|Inner Mongolia Autonomous Region|CN|40.5600|109.9970|L
BAX|Barnaul Gherman Titov International Airport|Barnaul|Altai Krai|RU|53.3613|83.5397|L
BAY|Maramureș International Airport|Tăuții-Măgherăuș|Maramureş County|RO|47.6584|23.4644|M
BBA|Balmaceda Airport|Balmaceda|Aysén Region|CL|-45.9160|-71.6895|M
BBI|Biju Patnaik International Airport|Bhubaneswar|Odisha|IN|20.2510|85.8147|L
BBK|Kasane International Airport|Kasane|Chobe District|BW|-17.8317|25.1662|L
BBM|Battambang Airport|Battambang|Battambang province|KH|13.0956|103.2240|M
BBN|Bario Airport|Bario|Sarawak|MY|3.7346|115.4785|M
BBO|Berbera Airport|Berbera|Maroodi Jeex|SO|10.3850|44.9367|M
BBQ|Burton-Nibbs International Airport|Codrington|Barbuda Dependency|AG|17.6212|-61.7983|M
BBU|Bucharest Băneasa Aurel Vlaicu International Airport|Bucharest|Bucharest (municipality)|RO|44.5031|26.1029|L
BCA|Gustavo Rizo Airport|Baracoa|Guantánamo Province|CU|20.3653|-74.5062|M
BCD|Bacolod-Silay International Airport|Bacolod City|Negros Occidental Province|PH|10.7762|123.0189|L
BCH|Baucau Airport|Baucau|Baucau|TL|-8.4865|126.4000|M
BCI|Barcaldine Airport|Barcaldine|Queensland|AU|-23.5663|145.3021|M
BCM|Bacău George Enescu International Airport|Bacău|Bacău County|RO|46.5219|26.9103|L
BCO|Jinka Airport|Jinka|Southern Nations, Nationalities, and Peoples' Region|ET|5.7497|36.5602|M
BCU|Sir Abubakar Tafawa Balewa Bauchi State International Airport|Bauchi|Bauchi State|NG|10.4828|9.7440|L
BDA|L.F. Wade International Airport|Hamilton||BM|32.3638|-64.6782|L
BDB|Bundaberg Airport|Bundaberg|Queensland|AU|-24.9050|152.3226|M
BDH|Bandar Lengeh International Airport|Bandar Lengeh|Hormozgan Province|IR|26.5323|54.8248|M
BDJ|Syamsudin Noor International Airport|Banjarbaru|Kalimantan Selatan (South Kalimantan)|ID|-3.4401|114.7612|L
BDL|Bradley International Airport|Hartford|Connecticut|US|41.9386|-72.6880|L
BDO|Husein Sastranegara International Airport|Bandung|Jawa Barat (West Java)|ID|-6.9006|107.5760|M
BDQ|Vadodara International Airport|Vadodara|Gujarat|IN|22.3362|73.2263|L
BDS|Brindisi Airport|Brindisi|Apulia|IT|40.6576|17.9470|L
BDT|Gbadolite Airport|Gbadolite|Nord-Ubangi Province|CD|4.2527|20.9753|M
BDU|Bardufoss Airport|Målselv|Troms|NO|69.0558|18.5404|M
BEB|Benbecula Airport|Balivanich|Scotland|GB|57.4811|-7.3628|M
BED|Laurence G Hanscom Field|Bedford|Massachusetts|US|42.4700|-71.2890|M
BEF|Bluefields Airport|Bluefields|South Caribbean Coast Autonomous Region|NI|11.9910|-83.7741|M
BEJ|Kalimarau Airport|Tanjung Redeb - Borneo Island|Kalimantan Timur (East Kalimantan)|ID|2.1478|117.4307|M
BEK|Bareilly Air Force Station|Bareilly|Uttar Pradesh|IN|28.4221|79.4508|M
BEL|Val de Cans/Júlio Cezar Ribeiro International Airport|Belém|Pará|BR|-1.3793|-48.4762|L
BEM|Beni Mellal Airport|Oulad Yaich|Béni Mellal-Khénifra Region|MA|32.4019|-6.3159|L
BEN|Benina International Airport|Benina|Benghazi District|LY|32.0968|20.2695|L
BES|Brest Bretagne airport|Brest|Brittany|FR|48.4479|-4.4185|L
BET|Bethel Airport|Bethel|Alaska|US|60.7798|-161.8380|M
BEU|Bedourie Airport|Bedourie|Queensland|AU|-24.3461|139.4600|M
BEW|Beira International Airport|Beira|Sofala Province|MZ|-19.7964|34.9076|L
BEY|Beirut Rafic Hariri International Airport|Beirut|Mount Lebanon Governorate|LB|33.8198|35.4874|L
BFD|Bradford Regional Airport|Bradford|Pennsylvania|US|41.8031|-78.6401|M
BFF|Western Neb. Rgnl/William B. Heilig Airport|Scottsbluff|Nebraska|US|41.8740|-103.5960|M
BFI|King County International Airport - Boeing Field|Seattle|Washington|US|47.5270|-122.2999|M
BFJ|Bijie Feixiong Airport|Bijie|Guizhou Province|CN|27.2671|105.4721|M
BFL|Meadows Field|Bakersfield|California|US|35.4336|-119.0570|M
BFN|Bram Fischer International Airport|Bloemfontein|Free State|ZA|-29.0927|26.3024|L
BFS|Belfast International Airport|Belfast|Northern Ireland|GB|54.6575|-6.2158|L
BFV|Buri Ram Airport|Buriram|Buriram Province|TH|15.2295|103.2530|M
BFY|Bengbu Tenghu Airport|Bengbu|Anhui Province|CN|33.1663|117.0583|M
BGA|Palonegro Airport|Bucaramanga|Santander Department|CO|7.1265|-73.1848|M
BGC|Bragança Airport|Bragança|Bragança District|PT|41.8578|-6.7071|M
BGF|Bangui M'Poko International Airport|Bangui|Ombella-M'Poko|CF|4.3985|18.5188|L
BGG|Bingöl Airport|Bingöl|Bingöl Province|TR|38.8601|40.5945|M
BGI|Grantley Adams International Airport|Bridgetown|Christ Church|BB|13.0747|-59.4910|L
BGM|Greater Binghamton/Edwin A Link field|Binghamton|New York|US|42.2087|-75.9798|M
BGR|Bangor International Airport|Bangor|Maine|US|44.8064|-68.8267|M
BGW|Baghdad International Airport / New Al Muthana Air Base|Baghdad|Baghdad Governorate|IQ|33.2625|44.2346|L
BGY|Il Caravaggio International Airport|Orio al Serio (BG)|Lombardy|IT|45.6694|9.7089|L
BHB|Hancock County-Bar Harbor Airport|Bar Harbor|Maine|US|44.4500|-68.3615|M
BHD|George Best Belfast City Airport|Belfast|Northern Ireland|GB|54.6181|-5.8725|M
BHE|Woodbourne Airport|Blenheim|Marlborough Region|NZ|-41.5183|173.8700|M
BHH|Bisha Airport|Bisha|Asir Region|SA|19.9844|42.6209|M
BHI|Comandante Espora Airport|Bahía Blanca|Buenos Aires Province|AR|-38.7250|-62.1693|M
BHJ|Bhuj Airport|Bhuj|Gujarat|IN|23.2878|69.6702|M
BHK|Bukhara International Airport|Bukhara|Bukhara Region|UZ|39.7753|64.4823|L
BHM|Birmingham-Shuttlesworth International Airport|Birmingham|Alabama|US|33.5629|-86.7507|L
BHO|Raja Bhoj International Airport|Bhopal|Madhya Pradesh|IN|23.2875|77.3374|L
BHQ|Broken Hill Airport|Broken Hill|New South Wales|AU|-32.0014|141.4720|M
BHS|Bathurst Airport|Bathurst|New South Wales|AU|-33.4068|149.6512|M
BHU|Bhavnagar Airport|Bhavnagar|Gujarat|IN|21.7522|72.1852|M
BHV|Bahawalpur Airport|Bahawalpur|Punjab|PK|29.3481|71.7180|M
BHX|Birmingham Airport|Birmingham, West Midlands|England|GB|52.4539|-1.7480|L
BHY|Beihai Fucheng Airport|Beihai|Guangxi Autonomous Region|CN|21.5387|109.2937|M
BIA|Bastia-Poretta International airport|Bastia|Corsica|FR|42.5527|9.4837|L
BIH|Eastern Sierra Regional Airport|Bishop|California|US|37.3731|-118.3640|M
BIK|Frans Kaisiepo Airport|Biak|Papua|ID|-1.1900|136.1080|M
BIL|Billings Logan International Airport|Billings|Montana|US|45.8089|-108.5412|M
BIM|South Bimini Airport|South Bimini|Bimini|BS|25.6999|-79.2647|M
BIO|Bilbao Airport|Bilbao|Basque Country|ES|43.3011|-2.9106|L
BIQ|Biarritz Pays Basque airport|Biarritz|Nouvelle-Aquitaine|FR|43.4684|-1.5232|M
BIR|Biratnagar Airport|Biratnagar|Koshi Province|NP|26.4815|87.2640|M
BIS|Bismarck Municipal Airport|Bismarck|North Dakota|US|46.7727|-100.7469|M
BJA|Soummam–Abane Ramdane Airport|Béjaïa|Béjaïa Province|DZ|36.7125|5.0699|L
BJB|Bojnord Airport|Bojnord|North Khorasan Province|IR|37.4930|57.3082|M
BJC|Rocky Mountain Metropolitan Airport|Denver|Colorado|US|39.9088|-105.1170|M
BJF|Båtsfjord Airport|Båtsfjord|Finnmark|NO|70.6003|29.6926|M
BJL|Banjul International Airport|Banjul (Yundum)|Western Division|GM|13.3380|-16.6522|L
BJM|Bujumbura Melchior Ndadaye International Airport|Bujumbura|Bujumbura Mairie Province|BI|-3.3240|29.3185|L
BJR|Bahir Dar Airport|Bahir Dar|Amhara Region|ET|11.6081|37.3216|M
BJV|Milas Bodrum International Airport|Bodrum|Muğla Province|TR|37.2493|27.6640|L
BJX|Guanajuato International Airport|Silao|Guanajuato|MX|20.9927|-101.4803|L
BJZ|Badajoz Airport|Badajoz|Extremadura|ES|38.8913|-6.8213|M
BKG|Branson Airport|Branson|Missouri|US|36.5321|-93.2005|M
BKI|Kota Kinabalu International Airport|Kota Kinabalu|Sabah|MY|5.9327|116.0493|L
BKN|Balkanabat International Airport|Balkanabat|Balkan Region|TM|39.6811|54.2060|M
BKO|Modibo Keita International Airport|Bamako|Koulikoro Region|ML|12.5335|-7.9499|L
BKQ|Blackall Airport|Blackall|Queensland|AU|-24.4317|145.4297|M
BKS|Fatmawati Soekarno Airport|Bengkulu|Bengkulu|ID|-3.8637|102.3390|M
BKW|Raleigh County Memorial Airport|Beaver|West Virginia|US|37.7873|-81.1242|M
BLA|General José Antonio Anzoategui International Airport|Barcelona|Anzoátegui State|VE|10.1111|-64.6922|L
BLD|Boulder City Municipal Airport|Boulder City|Nevada|US|35.9472|-114.8588|M
BLE|Dala Airport|Borlange|Dalarnas län|SE|60.4220|15.5152|M
BLI|Bellingham International Airport|Bellingham|Washington|US|48.7928|-122.5380|M
BLJ|Batna Mostefa Ben Boulaid Airport|Batna|Batna Province|DZ|35.7521|6.3086|L
BLL|Billund Airport|Billund|South Denmark|DK|55.7403|9.1570|L
BLQ|Bologna Guglielmo Marconi Airport|Bologna|Emilia-Romagna|IT|44.5354|11.2887|L
BLV|Scott AFB/Midamerica Airport|Belleville|Illinois|US|38.5452|-89.8352|M
BLZ|Chileka International Airport|Blantyre|Blantyre District|MW|-15.6772|34.9723|L
BMA|Stockholm-Bromma Airport|Stockholm|Stockholms län|SE|59.3544|17.9417|M
BME|Broome International Airport|Broome|Western Australia|AU|-17.9492|122.2283|L
BMI|Central Illinois Regional Airport at Bloomington-Normal|Bloomington/Normal|Illinois|US|40.4771|-88.9159|M
BMU|Sultan Muhammad Salahuddin Airport|Bima|Nusa Tenggara Barat (West Nusa Tenggara)|ID|-8.5372|118.6850|M
BMV|Buon Ma Thuot Airport|Buon Ma Thuot|Central Highlands Region|VN|12.6683|108.1200|M
BMW|Bordj Badji Mokhtar Airport|Bordj Badji Mokhtar|Bordj Baji Mokhtar Province|DZ|21.3778|0.9270|M
BND|Bandar Abbas International Airport|Bandar Abbas|Hormozgan Province|IR|27.2183|56.3778|L
BNI|Benin Airport|Benin|Edo State|NG|6.3170|5.5995|M
BNK|Ballina Byron Gateway Airport|Ballina|New South Wales|AU|-28.8332|153.5615|M
BNN|Brønnøysund Airport, Brønnøy|Brønnøy|Nordland|NO|65.4611|12.2175|M
BNS|Barinas Airport|Barinas|Barinas State|VE|8.6150|-70.2142|M
BNX|Banja Luka International Airport|Mahovljani|Republika Srpska|BA|44.9414|17.2975|L
BOB|Bora Bora Airport|Motu Mute||PF|-16.4444|-151.7510|M
BOC|Bocas del Toro "Isla Colón" International Airport|Isla Colón|Bocas del Toro Province|PA|9.3408|-82.2508|M
BOD|Bordeaux–Mérignac Airport|Bordeaux|Nouvelle-Aquitaine|FR|44.8287|-0.7154|L
BOH|Bournemouth Airport|Bournemouth|England|GB|50.7805|-1.8396|M
BOI|Boise Air Terminal/Gowen Field|Boise|Idaho|US|43.5644|-116.2230|L
BOJ|Burgas Airport|Burgas|Burgas Province|BG|42.5699|27.5152|L
BON|Flamingo International Airport|Kralendijk|Bonaire|BQ|12.1310|-68.2685|L
BOO|Bodø Airport|Bodø|Nordland|NO|67.2692|14.3653|L
BOR|Bokeo International Airport|Ton Phueng|Bokeo Province|LA|20.3240|100.1654|M
BOY|Bobo Dioulasso Airport|Bobo Dioulasso|Houet Province|BF|11.1601|-4.3310|L
BPE|Qinhuangdao Beidaihe Airport|Qinhuangdao (Changli)|Hebei Province|CN|39.6664|119.0614|M
BPL|Bole Alashankou Airport|Bole|Xinjiang Autonomous Region|CN|44.8955|82.3001|M
BPN|Sultan Aji Muhammad Sulaiman Sepinggan International Airport|Balikpapan|Kalimantan Timur (East Kalimantan)|ID|-1.2683|116.8945|L
BPS|Porto Seguro International Airport|Porto Seguro|Bahia|BR|-16.4384|-39.0806|L
BPT|Jack Brooks Regional Airport|Beaumont/Port Arthur|Texas|US|29.9508|-94.0207|M
BPX|Qamdo Bangda Airport|Bangda|Tibet Autonomous Region|CN|30.5536|97.1083|M
BPY|Besalampy Airport|Besalampy|Mahajanga|MG|-16.7445|44.4825|M
BQK|Brunswick Golden Isles Airport|Brunswick|Georgia|US|31.2588|-81.4665|M
BQN|Rafael Hernández International Airport|Aguadilla||PR|18.4949|-67.1294|M
BQS|Ignatyevo Airport|Blagoveschensk|Amur Oblast|RU|50.4267|127.4155|M
BQT|Brest International Airport|Brest|Brest Region|BY|52.1081|23.8968|L
BQU|J F Mitchell Airport|Bequia|Grenadines|VC|12.9884|-61.2620|M
BRC|Teniente Luis Candelaria International Airport|San Carlos de Bariloche|Río Negro Province|AR|-41.1512|-71.1575|L
BRD|Brainerd Lakes Regional Airport|Brainerd|Minnesota|US|46.4029|-94.1297|M
BRE|Bremen Airport|Bremen|Bremen|DE|53.0468|8.7893|L
BRI|Bari Karol Wojtyła International Airport|Bari|Apulia|IT|41.1389|16.7606|L
BRL|Southeast Iowa Regional Airport|Burlington|Iowa|US|40.7832|-91.1255|M
BRM|Jacinto Lara International Airport|Barquisimeto|Lara State|VE|10.0427|-69.3586|L
BRN|Bern Airport|Bern|Bern|CH|46.9127|7.4988|M
BRO|Brownsville South Padre Island International Airport|Brownsville|Texas|US|25.9072|-97.4252|M
BRQ|Brno-Tuřany Airport|Brno|South Moravian Region|CZ|49.1513|16.6940|M
BRR|Barra Airport|Eoligarry|Scotland|GB|57.0228|-7.4431|M
BRS|Bristol Airport|Bristol|England|GB|51.3823|-2.7165|L
BRW|Wiley Post Will Rogers Memorial Airport|Utqiaġvik|Alaska|US|71.2854|-156.7660|M
BRX|Maria Montez International Airport|Barahona|Barahona Province|DO|18.2515|-71.1204|M
BSA|Bender Qassim International Airport|Bosaso|Bari|SO|11.2752|49.1392|L
BSB|Presidente Juscelino Kubitschek International Airport|Brasília|Distrito Federal|BR|-15.8692|-47.9208|L
BSC|José Celestino Mutis Airport|Bahía Solano|Chocó Department|CO|6.2029|-77.3947|M
BSD|Baoshan Yunrui Airport|Baoshan (Longyang)|Yunnan Province|CN|25.0533|99.1683|M
BSG|Bata International Airport|Bata|Litoral Province|GQ|1.9055|9.8057|L
BSK|Biskra - Mohamed Khider Airport|Biskra|Biskra Province|DZ|34.7932|5.7389|L
BSL|EuroAirport Basel–Mulhouse–Freiburg|Bâle / Mulhouse|Grand Est|FR|47.6007|7.5211|L
BSO|Basco Airport|Basco|Batanes Province|PH|20.4513|121.9800|M
BSR|Basra International Airport|Basra|Basra Governorate|IQ|30.5491|47.6621|L
BSZ|Manas International Airport|Bishkek|Chuy Region|KG|43.0613|74.4776|L
BTC|Batticaloa International Airport|Batticaloa|Eastern Province|LK|7.7051|81.6772|M
BTH|Hang Nadim International Airport|Batam|Kepulauan Riau (Riau Islands)|ID|1.1210|104.1190|L
BTI|Barter Island Long Range Radar Station Airport|Barter Island|Alaska|US|70.1340|-143.5820|M
BTJ|Sultan Iskandar Muda International Airport|Banda Aceh|Aceh|ID|5.5251|95.4200|L
BTK|Bratsk Airport|Bratsk|Irkutsk Oblast|RU|56.3696|101.7018|M
BTM|Bert Mooney Airport|Butte|Montana|US|45.9548|-112.4970|M
BTR|Baton Rouge Metropolitan Airport|Baton Rouge|Louisiana|US|30.5332|-91.1496|M
BTS|M. R. Štefánik Airport|Bratislava|Bratislava Region|SK|48.1702|17.2127|L
BTU|Bintulu Airport|Bintulu|Sarawak|MY|3.1239|113.0200|M
BTV|Patrick Leahy Burlington International Airport|Burlington|Vermont|US|44.4719|-73.1533|M
BUA|Buka Airport|Buka Island|Autonomous Region of Bougainville|PG|-5.4223|154.6727|M
BUF|Buffalo Niagara International Airport|Buffalo|New York|US|42.9405|-78.7322|L
BUN|Gerardo Tobar López Airport|Buenaventura|Valle del Cauca Department|CO|3.8196|-76.9898|M
BUQ|Joshua Mqabuko Nkomo International Airport|Bulawayo|Bulawayo Metropolitan Province|ZW|-20.0163|28.6229|L
BUR|Hollywood Burbank/Bob Hope Airport|Burbank|California|US|34.2028|-118.3581|L
BUS|Alexander Kartveli Batumi International Airport|Batumi|Autonomous Republic of Adjara|GE|41.6094|41.6003|L
BUX|Bunia Airport|Bunia|Ituri Province|CD|1.5657|30.2207|M
BUZ|Bushehr Airport|Bushehr|Bushehr Province|IR|28.9448|50.8346|M
BVA|Beauvais-Tillé airport|Beauvais|Hauts-de-France|FR|49.4544|2.1128|L
BVB|Atlas Brasil Cantanhede International Airport|Boa Vista|Roraima|BR|2.8462|-60.6906|L
BVC|Aristides Pereira International Airport|Rabil|Barlavento Islands|CV|16.1365|-22.8889|L
BVE|Brive Souillac airport|Brive|Nouvelle-Aquitaine|FR|45.0397|1.4856|M
BVG|Berlevåg Airport|Berlevåg|Finnmark|NO|70.8715|29.0341|M
BVH|Brigadeiro Camarão Airport|Vilhena|Rondônia|BR|-12.6944|-60.0983|M
BVJ|Bovanenkovo Airport|Bovanenkovo|Yamalo-Nenets Autonomous Okrug|RU|70.3153|68.3336|M
BWA|Gautam Buddha International Airport|Siddharthanagar (Bhairahawa)|Lumbini Province|NP|27.5046|83.4104|L
BWI|Baltimore/Washington International Thurgood Marshall Airport|Baltimore|Maryland|US|39.1754|-76.6683|L
BWK|Brač Airport|Gornji Humac|Split-Dalmatia County|HR|43.2845|16.6784|M
BWN|Brunei International Airport|Bandar Seri Begawan|Brunei-Muara District|BN|4.9442|114.9280|L
BWO|Balakovo Airport|Balakovo|Saratov Oblast|RU|51.8583|47.7456|M
BWT|Wynyard Airport|Burnie|Tasmania|AU|-40.9970|145.7260|M
BXH|Balkhash Airport|Balkhash|Karaganda Region|KZ|46.8942|75.0045|M
BXR|Bam Airport|Bam|Kerman Province|IR|29.0842|58.4500|M
BXU|Bancasi Airport|Butuan|Butuan City|PH|8.9515|125.4788|M
BXY|Baikonur Krayniy International Airport|Baikonur|Baikonur City|KZ|45.6220|63.2108|L
BYK|Bouaké Airport|Bouaké|Vallée du Bandama District|CI|7.7388|-5.0737|M
BYM|Carlos Manuel de Cespedes Airport|Bayamo|Granma Province|CU|20.3964|-76.6214|M
BYN|Bayankhongor Airport|Bayankhongor|Bayankhongor Province|MN|46.1633|100.7040|M
BZE|Philip S. W. Goldson International Airport|Belize City|Belize District|BZ|17.5400|-88.3036|L
BZG|Ignacy Jan Paderewski Bydgoszcz Airport|Bydgoszcz|Kuyavian-Pomeranian Voivodeship|PL|53.0968|17.9777|M
BZI|Balıkesir Airport|Balıkesir|Balıkesir Province|TR|39.6193|27.9260|M
BZL|Barisal Airport|Barisal|Barisal Division|BD|22.8010|90.3012|M
BZN|Bozeman Yellowstone International Airport|Bozeman|Montana|US|45.7789|-111.1537|M
BZO|Bolzano Airport|Bolzano (BZ)|Trentino-Alto Adige|IT|46.4592|11.3261|M
BZR|Béziers Vias airport|Béziers|Occitanie|FR|43.3235|3.3539|M
BZV|Maya-Maya International Airport|Brazzaville|Pool Department|CG|-4.2517|15.2530|L
BZX|Bazhong Enyang Airport|Bazhong|Sichuan Province|CN|31.7384|106.6449|M
CAB|Cabinda Airport|Cabinda|Cabinda Province|AO|-5.5984|12.1881|M
CAC|Coronel Adalberto Mendes da Silva Airport|Cascavel|Paraná|BR|-25.0003|-53.5012|M
CAE|Columbia Metropolitan Airport|Columbia|South Carolina|US|33.9382|-81.1230|M
CAG|Cagliari Elmas Airport|Cagliari|Sardinia|IT|39.2515|9.0543|L
CAH|Cà Mau Airport|Ca Mau City|Southwest Region|VN|9.1777|105.1778|M
CAJ|Canaima Airport|Canaima|Bolívar State|VE|6.2320|-62.8548|M
CAK|Akron Canton Regional Airport|Akron|Ohio|US|40.9161|-81.4422|M
CAL|Campbeltown Airport|Campbeltown|Scotland|GB|55.4372|-5.6864|M
CAP|Cap Haitien International Airport|Cap Haitien|Nord Department|HT|19.7255|-72.2007|L
CAT|Cascais Airport|Cascais|Lisbon District|PT|38.7250|-9.3552|M
CAW|Bartolomeu Lisandro Airport|Campos dos Goytacazes|Rio de Janeiro|BR|-21.6983|-41.3017|M
CAY|Cayenne – Félix Eboué Airport|Matoury|Cayenne|GF|4.8200|-52.3613|L
CBB|Jorge Wilsterman International Airport|Cochabamba|Cochabamba Department|BO|-17.4211|-66.1771|L
CBH|Béchar Boudghene Ben Ali Lotfi Airport|Béchar|Béchar Province|DZ|31.6457|-2.2699|M
CBO|Cotabato (Awang) Airport|Datu Odin Sinsuat|Maguindanao del Norte Province|PH|7.1648|124.2099|M
CBQ|Margaret Ekpo International Airport|Calabar|Cross River State|NG|4.9760|8.3472|M
CBR|Canberra Airport|Canberra|Australian Capital Territory|AU|-35.3069|149.1950|M
CBT|Catumbela Airport|Catumbela|Benguela Province|AO|-12.4792|13.4869|M
CCC|Jardines Del Rey Airport|Cayo Coco|Ciego de Ávila Province|CU|22.4610|-78.3284|M
CCE|Capital International Airport|New Cairo|Cairo Governorate|EG|30.0647|31.8400|M
CCF|Carcassonne Salvaza Airport|Carcassonne|Occitanie|FR|43.2160|2.3063|M
CCJ|Calicut International Airport|Calicut|Kerala|IN|11.1360|75.9552|L
CCK|Cocos (Keeling) Islands Airport|West Island||CC|-12.1922|96.8341|L
CCP|Carriel Sur International Airport|Concepcion|Bío-Bío Region|CL|-36.7724|-73.0628|L
CCR|Buchanan Field|Concord|California|US|37.9897|-122.0570|M
CCS|Maiquetía Simón Bolívar International Airport|Maiquetía|La Guaira State|VE|10.6022|-66.9912|L
CCU|Netaji Subhash Chandra Bose International Airport|Kolkata|West Bengal|IN|22.6540|88.4476|L
CCZ|Chub Cay Airport|Chub Cay|North Andros|BS|25.4171|-77.8809|M
CDB|Cold Bay Airport|Cold Bay|Alaska|US|55.2079|-162.7250|M
CDC|Cedar City Regional Airport|Cedar City|Utah|US|37.7010|-113.0990|M
CDE|Chengde Puning Airport|Chengde|Hebei Province|CN|41.1225|118.0739|M
CDP|Kadapa Airport|Kadapa|Andhra Pradesh|IN|14.5132|78.7692|M
CDR|Chadron Municipal Airport|Chadron|Nebraska|US|42.8376|-103.0950|M
CDT|Castellón-Costa Azahar Airport|Castellón de la Plana|Valencia (community)|ES|40.2139|0.0733|M
CDV|Merle K (Mudhole) Smith Airport|Cordova|Alaska|US|60.4918|-145.4780|M
CEB|Mactan Cebu International Airport|Cebu City/Lapu-Lapu City|Cebu Province|PH|10.3093|123.9797|L
CEC|Jack Mc Namara Field Airport|Crescent City|California|US|41.7789|-124.2364|M
CEE|Cherepovets Airport|Cherepovets|Vologda Oblast|RU|59.2736|38.0158|M
CEI|Mae Fah Luang - Chiang Rai International Airport|Chiang Rai|Chiang Rai Province|TH|19.9523|99.8829|L
CEK|Kurchatov Chelyabinsk International Airport|Chelyabinsk|Chelyabinsk Oblast|RU|55.3031|61.5049|L
CEN|Ciudad Obregón International Airport|Ciudad Obregón|Sonora|MX|27.3926|-109.8330|M
CEZ|Cortez Municipal Airport|Cortez|Colorado|US|37.3030|-108.6280|M
CFE|Clermont-Ferrand Auvergne airport|Clermont-Ferrand|Auvergne-Rhône-Alpes|FR|45.7867|3.1692|L
CFG|Jaime Gonzalez Airport|Cienfuegos|Cienfuegos Province|CU|22.1500|-80.4142|M
CFK|Chlef Aboubakr Belkaid International Airport|Chlef|Chlef Province|DZ|36.2166|1.3411|L
CFN|Donegal Airport|Donegal|County Donegal|IE|55.0442|-8.3410|M
CFR|Caen Carpiquet airport|Caen|Normandy|FR|49.1768|-0.4549|M
CFS|Coffs Harbour Airport|Coffs Harbour|New South Wales|AU|-30.3206|153.1160|M
CFU|Corfu Ioannis Kapodistrias International Airport|Kerkyra (Corfu)|Ionian Islands|GR|39.6014|19.9122|L
CGB|Várzea Grande–Marechal Rondon International Airport|Cuiabá|Mato Grosso|BR|-15.6529|-56.1167|L
CGD|Changde Taohuayuan Airport|Changde (Dingcheng)|Hunan Province|CN|28.9189|111.6400|M
CGH|Congonhas–Deputado Freitas Nobre Airport|São Paulo|São Paulo|BR|-23.6277|-46.6546|L
CGI|Cape Girardeau Regional Airport|Cape Girardeau|Missouri|US|37.2253|-89.5708|M
CGM|Camiguin Airport|Mambajao|Camiguin Province|PH|9.2539|124.7091|M
CGN|Cologne Bonn Airport|Köln (Cologne)|North Rhine-Westphalia|DE|50.8659|7.1427|L
CGO|Zhengzhou Xinzheng International Airport|Zhengzhou|Henan Province|CN|34.5265|113.8492|L
CGP|Shah Amanat International Airport|Chattogram (Chittagong)|Chittagong Division|BD|22.2496|91.8133|L
CGQ|Changchun Longjia International Airport|Changchun|Jilin Province|CN|43.9962|125.6850|L
CGR|Campo Grande Airport|Campo Grande|Mato Grosso do Sul|BR|-20.4700|-54.6740|M
CGY|Laguindingan International Airport|Laguindingan|Misamis Oriental Province|PH|8.6122|124.4565|L
CHA|Chattanooga Metropolitan Airport (Lovell Field)|Chattanooga|Tennessee|US|35.0353|-85.2038|M
CHC|Christchurch International Airport|Christchurch|Canterbury Region|NZ|-43.4890|172.5321|L
CHG|Chaoyang Airport|Shuangta, Chaoyang|Liaoning Province|CN|41.5381|120.4350|M
CHH|Chachapoyas Airport|Chachapoyas|Amazonas Region|PE|-6.2019|-77.8562|M
CHM|FAP Lieutenant Jaime Andres de Montreuil Morales Airport|Chimbote|Ancash Region|PE|-9.1496|-78.5238|M
CHO|Charlottesville Albemarle Airport|Charlottesville|Virginia|US|38.1386|-78.4529|M
CHQ|Chania International Airport|Souda|Crete|GR|35.5312|24.1507|L
CHS|Charleston International Airport|Charleston|South Carolina|US|32.8962|-80.0382|L
CHT|Inia William Tuuta Memorial Airport|Te One|Wellington Region|NZ|-43.8119|-176.4651|M
CHX|Changuinola Captain Manuel Niño International Airport|Changuinola|Bocas del Toro Province|PA|9.4590|-82.5151|M
CIA|Ciampino–G. B. Pastine International Airport|Rome|Lazio|IT|41.7988|12.5953|L
CID|The Eastern Iowa Airport|Cedar Rapids|Iowa|US|41.8847|-91.7108|M
CIF|Chifeng Yulong Airport|Chifeng|Inner Mongolia Autonomous Region|CN|42.1597|118.8410|M
CIJ|Capitán Aníbal Arab Airport|Cobija|Pando Department|BO|-11.0391|-68.7828|M
CIT|Shymkent International Airport|Shymkent|Turkistan Region|KZ|42.3650|69.4756|L
CIU|Chippewa County International Airport|Kincheloe|Michigan|US|46.2420|-84.4621|M
CIW|Canouan Airport|Canouan|Grenadines|VC|12.6990|-61.3424|M
CIX|Capitán FAP José A. Quiñones González International Airport|Chiclayo|Lambayeque Region|PE|-6.7892|-79.8283|L
CIY|Comiso Airport|Comiso|Sicily|IT|36.9958|14.6089|M
CJA|Mayor General FAP Armando Revoredo Iglesias Airport|Cajamarca|Cajamarca Region|PE|-7.1392|-78.4894|M
CJB|Coimbatore International Airport|Coimbatore|Tamil Nadu|IN|11.0300|77.0434|L
CJC|El Loa Airport|Calama|Antofagasta Region|CL|-22.4982|-68.9036|M
CJJ|Cheongju International Airport/Cheongju Air Base (K-59/G-513)|Cheongju|Chungcheongbuk-do (North Chungcheong Province)|KR|36.7156|127.5003|L
CJL|Chitral Airport|Chitral|Khyber Pakhtunkhwa|PK|35.8862|71.7999|M
CJM|Chumphon Airport|Chumphon|Chumphon Province|TH|10.7112|99.3617|M
CJS|Abraham González International Airport|Ciudad Juárez|Chihuahua|MX|31.6367|-106.4285|L
CJU|Jeju International Airport|Jeju City|Jeju Teukbyeoljachi-do (Jeju Special Self-Governing Province)|KR|33.5121|126.4925|L
CKB|North Central West Virginia Airport|Bridgeport|West Virginia|US|39.2966|-80.2281|M
CKG|Chongqing Jiangbei International Airport|Chongqing|Chongqing Municipality|CN|29.7123|106.6519|L
CKH|Chokurdakh Airport|Chokurdah|Sakha (Yakutia) Republic|RU|70.6231|147.9020|M
CKS|Carajás Airport|Parauapebas|Pará|BR|-6.1178|-50.0034|M
CKY|Ahmed Sékou Touré International Airport|Conakry|Conakry Special Zone|GN|9.5769|-13.6120|L
CKZ|Çanakkale Airport|Çanakkale|Çanakkale Province|TR|40.1377|26.4268|M
CLD|McClellan-Palomar Airport|Carlsbad|California|US|33.1283|-117.2800|M
CLE|Cleveland Hopkins International Airport|Cleveland|Ohio|US|41.4117|-81.8498|L
CLJ|Avram Iancu Cluj International Airport|Cluj-Napoca|Cluj County|RO|46.7860|23.6857|L
CLL|Easterwood Field|College Station|Texas|US|30.5886|-96.3638|M
CLO|Alfonso Bonilla Aragon International Airport|Cali|Valle del Cauca Department|CO|3.5427|-76.3819|L
CLQ|Licenciado Miguel de la Madrid International Airport|Colima|Colima|MX|19.2770|-103.5770|M
CLY|Calvi Sainte Catherine Airport|Calvi|Corsica|FR|42.5304|8.7930|M
CME|Ciudad del Carmen International Airport|Ciudad del Carmen|Campeche|MX|18.6515|-91.7994|M
CMF|Chambéry Aix les Bains airport|Chambéry|Auvergne-Rhône-Alpes|FR|45.6381|5.8802|M
CMG|Corumbá International Airport|Corumbá|Mato Grosso do Sul|BR|-19.0119|-57.6728|M
CMH|John Glenn Columbus International Airport|Columbus|Ohio|US|39.9980|-82.8919|L
CMI|University of Illinois Willard Airport|Savoy|Illinois|US|40.0398|-88.2762|M
CMU|Chimbu Airport|Kundiawa|Chimbu Province|PG|-6.0243|144.9710|M
CMW|Ignacio Agramonte International Airport|Camaguey|Camagüey Province|CU|21.4199|-77.8480|L
CMX|Houghton County Memorial Airport|Hancock|Michigan|US|47.1684|-88.4891|M
CND|Mihail Kogălniceanu International Airport|Constanța|Constanţa County|RO|44.3622|28.4883|L
CNF|Tancredo Neves International Airport|Belo Horizonte|Minas Gerais|BR|-19.6357|-43.9669|L
CNJ|Cloncurry Airport|Cloncurry|Queensland|AU|-20.6686|140.5040|M
CNM|Cavern City Air Terminal|Carlsbad|New Mexico|US|32.3375|-104.2630|M
CNN|Kannur International Airport|Kannur|Kerala|IN|11.9163|75.5450|L
CNP|Neerlerit Inaat Airport|Neerlerit Inaat|Sermersooq Municipality|GL|70.7431|-22.6505|M
CNQ|Corrientes Airport|Corrientes|Corrientes Province|AR|-27.4455|-58.7619|M
CNS|Cairns International Airport|Cairns|Queensland|AU|-16.8789|145.7495|L
CNX|Chiang Mai International Airport|Chiang Mai|Chiang Mai Province|TH|18.7668|98.9626|L
CNY|Canyonlands Regional Airport|Moab|Utah|US|38.7550|-109.7550|M
COD|Yellowstone Regional Airport|Cody|Wyoming|US|44.5202|-109.0240|M
COK|Cochin International Airport|Kochi|Kerala|IN|10.1510|76.4008|L
COO|Cotonou Cadjehoun International Airport|Cotonou|Atlantique Department|BJ|6.3572|2.3843|L
COR|Ingeniero Aeronáutico Ambrosio L.V. Taravella International Airport|Cordoba|Córdoba Province|AR|-31.3123|-64.2083|L
COS|City of Colorado Springs Municipal Airport|Colorado Springs|Colorado|US|38.8058|-104.7010|L
COU|Columbia Regional Airport|Columbia|Missouri|US|38.8181|-92.2196|M
COV|Çukurova International Airport|Tarsus|Mersin Province|TR|36.8915|35.0712|L
CPC|Aviador C. Campos Airport|Chapelco/San Martin de los Andes|Neuquén Province|AR|-40.0754|-71.1373|M
CPD|Coober Pedy Airport|Coober Pedy|South Australia|AU|-29.0383|134.7222|M
CPE|Ingeniero Alberto Acuña Ongay International Airport|Campeche|Campeche|MX|19.8160|-90.5001|M
CPO|Desierto de Atacama Airport|Copiapo|Atacama Region|CL|-27.2612|-70.7792|M
CPR|Casper-Natrona County International Airport|Casper|Wyoming|US|42.9074|-106.4616|M
CPV|Presidente João Suassuna Airport|Campina Grande|Paraíba|BR|-7.2697|-35.8961|M
CPX|Benjamin Rivera Noriega Airport|Culebra||PR|18.3130|-65.3039|M
CQW|Chongqing Xiannüshan Airport|Wulong|Chongqing Municipality|CN|29.4657|107.6937|M
CRA|Craiova International Airport|Craiova|Dolj County|RO|44.3181|23.8886|L
CRD|General Enrique Mosconi International Airport|Comodoro Rivadavia|Chubut Province|AR|-45.7869|-67.4634|L
CRI|Colonel Hill Airport|Colonel Hill|Crooked Island and Long Cay|BS|22.7456|-74.1824|M
CRK|Clark International Airport / Clark Air Base|Mabalacat|Pampanga Province|PH|15.1860|120.5600|L
CRL|Brussels South Charleroi Airport|Charleroi|Hainaut Province|BE|50.4620|4.4596|L
CRM|Catarman National Airport|Catarman|Northern Samar Province|PH|12.5016|124.6353|M
CRP|Corpus Christi International Airport|Corpus Christi|Texas|US|27.7704|-97.5012|M
CRV|Crotone Sant'Anna Pythagoras Airport|Isola di Capo Rizzuto (KR)|Calabria|IT|38.9972|17.0802|M
CRW|Yeager Airport|Charleston|West Virginia|US|38.3731|-81.5932|M
CRZ|Türkmenabat International Airport|Türkmenabat|Lebap Region|TM|38.9307|63.5640|L
CSG|Columbus Airport|Columbus|Georgia|US|32.5164|-84.9396|M
CSK|Cap Skirring Airport|Cap Skirring|Ziguinchor Region|SN|12.3953|-16.7480|M
CSW|Cabo San Lucas International Airport|Cabo San Lucas|Baja California Sur|MX|22.9491|-109.9395|M
CSX|Changsha Huanghua International Airport|Changsha (Changsha)|Hunan Province|CN|28.1892|113.2200|L
CSY|Cheboksary Airport|Cheboksary|Chuvash Republic|RU|56.0903|47.3473|M
CTA|Catania-Fontanarossa Airport|Catania|Sicily|IT|37.4668|15.0664|L
CTC|Coronel Felipe Varela International Airport|Catamarca|Catamarca Province|AR|-28.5931|-65.7512|M
CTD|Alonso Valderrama Airport|Chitré|Herrera Province|PA|7.9878|-80.4098|M
CTG|Rafael Nuñez International Airport|Cartagena|Bolívar Department|CO|10.4424|-75.5130|L
CTL|Charleville Airport|Charleville|Queensland|AU|-26.4133|146.2620|M
CTM|Chetumal International Airport|Chetumal|Quintana Roo|MX|18.5050|-88.3280|M
CTS|New Chitose Airport|Sapporo|Hokkaidō Prefecture|JP|42.7748|141.6904|L
CTU|Chengdu Shuangliu International Airport|Chengdu (Shuangliu)|Sichuan Province|CN|30.5583|103.9460|L
CUC|Camilo Daza International Airport|Cúcuta|Norte de Santander Department|CO|7.9276|-72.5115|M
CUE|Mariscal Lamar Airport|Cuenca|Azuay Province|EC|-2.8895|-78.9844|M
CUF|Cuneo International Airport|Levaldigi (CN)|Piedmont|IT|44.5475|7.6230|M
CUK|Caye Caulker Airport|Caye Caulker|Belize District|BZ|17.7350|-88.0329|M
CUL|Bachigualato Federal International Airport|Culiacán|Sinaloa|MX|24.7650|-107.4752|L
CUM|Antonio José de Sucre Airport|Cumaná|Sucre State|VE|10.4503|-64.1305|M
CUP|General Francisco Bermúdez Airport|Carúpano|Sucre State|VE|10.6600|-63.2617|M
CUQ|Coen Airport|Coen|Queensland|AU|-13.7611|143.1133|M
CUR|Hato International Airport|Willemstad||CW|12.1889|-68.9598|L
CUU|General Roberto Fierro Villalobos International Airport|Chihuahua|Chihuahua|MX|28.7026|-105.9638|L
CUZ|Alejandro Velasco Astete International Airport|Cusco|Cuzco Region|PE|-13.5357|-71.9388|L
CVG|Cincinnati Northern Kentucky International Airport|Cincinnati / Covington|Kentucky|US|39.0488|-84.6678|L
CVM|General Pedro Jose Mendez International Airport|Ciudad Victoria|Tamaulipas|MX|23.7033|-98.9565|M
CVN|Clovis Municipal Airport|Clovis|New Mexico|US|34.4266|-103.0788|M
CVQ|Carnarvon Airport|Carnarvon|Western Australia|AU|-24.8843|113.6664|M
CWA|Central Wisconsin Airport|Mosinee|Wisconsin|US|44.7774|-89.6702|M
CWB|Curitiba-Afonso Pena International Airport|Curitiba|Paraná|BR|-25.5285|-49.1758|L
CWJ|Cangyuan Washan Airport|Lincang (Cangyuan)|Yunnan Province|CN|23.2763|99.3732|M
CWL|Cardiff International Airport|Cardiff|Wales|GB|51.3967|-3.3433|L
CXB|Cox's Bazar Airport|Cox's Bazar|Chittagong Division|BD|21.4575|91.9633|M
CXI|Cassidy International Airport|Kiritimati|Line Islands|KI|1.9863|-157.3500|L
CXJ|Hugo Cantergiani Regional Airport|Caxias Do Sul|Rio Grande do Sul|BR|-29.1972|-51.1876|M
CXP|Tunggul Wulung Airport|Cilacap|Jawa Tengah (Central Java)|ID|-7.6451|109.0340|M
CXR|Cam Ranh International Airport / Cam Ranh Air Base|Nha Trang/nha Trang aiurportCam Ranh|South Central Coast Region|VN|11.9982|109.2190|L
CYA|Antoine-Simon International Airport|Les Cayes|Sud Department|HT|18.2711|-73.7883|M
CYB|Charles Kirkconnell International Airport|West End|Cayman Brac|KY|19.6870|-79.8828|M
CYC|Caye Chapel Airport|Caye Chapel|Belize District|BZ|17.6838|-88.0450|M
CYI|Chiayi Airport|Shuishang|Chiayi County|TW|23.4626|120.3905|M
CYO|Vilo Acuña International Airport|Cayo Largo del Sur|Isla de la Juventud (special municipality)|CU|21.6165|-81.5460|M
CYP|Calbayog Airport|Calbayog City|Samar Province|PH|12.0726|124.5451|M
CYS|Cheyenne Regional Jerry Olson Field|Cheyenne|Wyoming|US|41.1557|-104.8120|M
CYX|Cherskiy Airport|Cherskiy|Sakha (Yakutia) Republic|RU|68.7406|161.3380|M
CYZ|Cauayan Airport|Cauayan City|Isabela Province|PH|16.9299|121.7530|M
CZE|José Leonardo Chirinos Airport|Coro|Falcón State|VE|11.4149|-69.6809|M
CZH|Corozal Airport|Corozal|Corozal District|BZ|18.3822|-88.4119|M
CZL|Mohamed Boudiaf International Airport|Constantine|Constantine Province|DZ|36.2760|6.6204|L
CZM|Cozumel International Airport|Cozumel|Quintana Roo|MX|20.5149|-86.9285|L
CZS|Cruzeiro do Sul Airport|Cruzeiro Do Sul|Acre|BR|-7.5999|-72.7695|M
CZU|Las Brujas Airport|Corozal|Sucre Department|CO|9.3327|-75.2856|M
CZX|Changzhou Benniu International Airport|Changzhou|Jiangsu Province|CN|31.9205|119.7755|M
DAB|Daytona Beach International Airport|Daytona Beach|Florida|US|29.1825|-81.0595|M
DAC|Hazrat Shahjalal International Airport|Dhaka|Dhaka Division|BD|23.8433|90.3978|L
DAD|Da Nang International Airport|Da Nang|South Central Coast Region|VN|16.0439|108.1990|L
DAL|Dallas Love Field|Dallas|Texas|US|32.8448|-96.8477|L
DAM|Damascus International Airport|Damascus|Damascus Governorate|SY|33.4115|36.5156|L
DAR|Julius Nyerere International Airport|Dar es Salaam|Dar-es-Salaam Region|TZ|-6.8735|39.2073|L
DAT|Datong Yungang International Airport|Datong|Shanxi Province|CN|40.0614|113.4805|L
DAU|Daru Airport|Daru|Western Province|PG|-9.0868|143.2080|M
DAV|Enrique Malek International Airport|David|Chiriquí Province|PA|8.3890|-82.4364|M
DAY|James M. Cox Dayton International Airport|Dayton|Ohio|US|39.9024|-84.2194|M
DBB|El Alamein International Airport|El Alamein|Matruh Governorate|EG|30.9243|28.4616|L
DBC|Baicheng Chang'an Airport|Baicheng|Jilin Province|CN|45.5053|123.0197|M
DBO|Dubbo City Regional Airport|Dubbo|New South Wales|AU|-32.2167|148.5750|M
DBQ|Dubuque Regional Airport|Dubuque|Iowa|US|42.4020|-90.7095|M
DBR|Darbhanga Airport|Darbhanga|Bihar|IN|26.1928|85.9169|M
DCF|Canefield Airport|Canefield|Saint Paul Parish|DM|15.3367|-61.3921|M
DCM|Castres Mazamet Airport|Castres|Occitanie|FR|43.5563|2.2892|M
DCY|Daocheng Yading Airport|Garzê (Daocheng)|Sichuan Province|CN|29.3163|100.0603|M
DDC|Dodge City Regional Airport|Dodge City|Kansas|US|37.7634|-99.9656|M
DDG|Dandong Langtou International Airport|Dandong (Zhenxing)|Liaoning Province|CN|40.0255|124.2867|M
DDR|Shigatse Tingri Airport|Xigazê (Dingri)|Tibet Autonomous Region|CN|28.6046|86.7980|M
DEA|Dera Ghazi Khan Airport|Dera Ghazi Khan|Punjab|PK|29.9610|70.4859|M
DEB|Debrecen International Airport|Debrecen|Hajdu-Bihar County|HU|47.4895|21.6163|L
DEC|Decatur Airport|Decatur|Illinois|US|39.8346|-88.8657|M
DED|Dehradun Jolly Grant Airport|Dehradun (Jauligrant)|Uttarakhand|IN|30.1892|78.1767|M
DEF|Dezful Airport|Dezful|Khuzestan Province|IR|32.4344|48.3976|M
DGA|Dangriga Airport|Dangriga|Stann Creek District|BZ|16.9825|-88.2310|M
DGO|General Guadalupe Victoria International Airport|Durango|Durango|MX|24.1255|-104.5279|M
DGT|Sibulan Airport|Dumaguete City|Negros Oriental Province|PH|9.3342|123.3019|M
DHM|Kangra Airport|Kangra|Himachal Pradesh|IN|32.1649|76.2630|M
DHN|Dothan Regional Airport|Dothan|Alabama|US|31.3213|-85.4496|M
DHX|Dhoho International Airport|Kediri|Jawa Timur (East Java)|ID|-7.7495|111.9468|M
DIA|Doha International Airport|Doha|Ad-Dawhah Municipality|QA|25.2594|51.5655|L
DIB|Dibrugarh Airport|Dibrugarh|Assam|IN|27.4839|95.0169|M
DIE|Arrachart Airport|Antisiranana|Antsiranana|MG|-12.3494|49.2917|M
DIG|Diqing Shangri-La Airport|Diqing (Shangri-La)|Yunnan Province|CN|27.7936|99.6772|M
DIK|Dickinson Theodore Roosevelt Regional Airport|Dickinson|North Dakota|US|46.7975|-102.8019|M
DIL|Presidente Nicolau Lobato International Airport|Dili|Dili|TL|-8.5466|125.5245|L
DIN|Dien Bien Phu Airport|Dien Bien Phu|Northwest Region|VN|21.3975|103.0080|M
DIR|Aba Tenna Dejazmach Yilma International Airport|Dire Dawa|Dire Dawa|ET|9.6235|41.8550|L
DIY|Diyarbakır Airport|Diyarbakır|Diyarbakır Province|TR|37.8939|40.2010|M
DJE|Djerba Zarzis International Airport|Mellita|Medenine Governorate|TN|33.8737|10.7773|L
DJG|Tiska Djanet Airport|Djanet|Djanet Province|DZ|24.2854|9.4637|L
DJJ|Dortheys Hiyo Eluay International Airport|Sentani|Papua|ID|-2.5796|140.5199|L
DJT|President Donald J. Trump International Airport|West Palm Beach|Florida|US|26.6832|-80.0956|L
DKA|Umaru Musa Yar'adua Airport|Katsina|Katsina State|NG|13.0078|7.6604|M
DLA|Douala International Airport|Douala|Littoral Region|CM|4.0061|9.7195|L
DLC|Dalian Zhoushuizi International Airport|Dalian (Ganjingzi)|Liaoning Province|CN|38.9657|121.5385|L
DLE|Dole Tavaux Airport|Dole|Bourgogne-Franche-Comté|FR|47.0390|5.4276|M
DLG|Dillingham Airport|Dillingham|Alaska|US|59.0447|-158.5050|M
DLH|Duluth International Airport|Duluth|Minnesota|US|46.8419|-92.1987|M
DLI|Lien Khuong Airport|Da Lat|Central Highlands Region|VN|11.7506|108.3670|M
DLM|Dalaman International Airport|Dalaman|Muğla Province|TR|36.7131|28.7925|L
DLU|Dali Fengyi Airport|Dali (Xiaguan)|Yunnan Province|CN|25.6494|100.3190|M
DLZ|Dalanzadgad Airport|Dalanzadgad|Ömnögovi Province|MN|43.6086|104.3677|M
DMB|Taraz International Airport|Taraz|Jambyl Region|KZ|42.8536|71.3036|L
DME|Domodedovo International Airport|Moscow|Moscow Oblast|RU|55.4088|37.9063|L
DMK|Don Mueang International Airport|Bangkok|Bangkok (special administrative area)|TH|13.9126|100.6070|L
DMM|King Fahd International Airport|Ad Dammam|Ash Sharqiyah Region|SA|26.4691|49.7982|L
DMU|Dimapur Airport|Dimapur|Nagaland|IN|25.8839|93.7711|M
DND|Dundee Airport|Dundee|Scotland|GB|56.4525|-3.0258|M
DNH|Dunhuang Mogao International Airport|Dunhuang|Gansu Province|CN|40.1620|94.8128|L
DNZ|Çardak Airport|Denizli|Denizli Province|TR|37.7856|29.7013|M
DOD|Dodoma Airport|Dodoma|Dodoma Region|TZ|-6.1706|35.7560|M
DOG|Dongola Airport|Dongola|Northern State|SD|19.1537|30.4301|M
DOL|Deauville Normandie airport|Deauville|Normandy|FR|49.3652|0.1545|M
DOM|Douglas-Charles Airport|Marigot|Saint Andrew Parish|DM|15.5467|-61.3011|M
DOV|Dover Civil Air Terminal/Dover Air Force Base|Dover|Delaware|US|39.1295|-75.4660|M
DOY|Dongying Shengli Airport|Dongying (Kenli)|Shandong Province|CN|37.5014|118.7899|M
DPL|Dipolog Airport|Dipolog|Zamboanga del Norte Province|PH|8.6020|123.3419|M
DPO|Devonport Airport|Devonport|Tasmania|AU|-41.1697|146.4300|M
DQM|Duqm International Airport|Duqm|Al Wusta Governorate|OM|19.5019|57.6342|L
DRG|Deering Airport|Deering|Alaska|US|66.0689|-162.7669|M
DRO|Durango La Plata County Airport|Durango|Colorado|US|37.1515|-107.7540|M
DRP|Bicol International Airport|Legazpi|Albay Province|PH|13.1119|123.6768|L
DRS|Dresden Airport|Dresden|Saxony|DE|51.1341|13.7678|L
DRW|Darwin International Airport / RAAF Darwin|Darwin|Northern Territory|AU|-12.4150|130.8818|L
DSI|Destin Executive Airport|Destin|Florida|US|30.4001|-86.4715|M
DSM|Des Moines International Airport|Des Moines|Iowa|US|41.5340|-93.6567|L
DSN|Ordos Ejin Horo International Airport|Ordos|Inner Mongolia Autonomous Region|CN|39.4935|109.8599|L
DSO|Sondok Airport|Sŏndŏng-ni|South Hamgyong Province|KP|39.7452|127.4740|M
DSS|Blaise Diagne International Airport|Dakar|Dakar Region|SN|14.6709|-17.0728|L
DSY|Dara Sakor International Airport|Ta Noun|Koh Kong province|KH|10.9142|103.2267|L
DTM|Dortmund Airport|Dortmund|North Rhine-Westphalia|DE|51.5183|7.6122|L
DTU|Wudalianchi Dedu Airport|Heihe|Heilongjiang Province|CN|48.4410|126.1284|M
DUD|Dunedin International Airport|Dunedin|Otago Region|NZ|-45.9290|170.1978|M
DUE|Dundo Airport|Chitato|Lunda Norte Province|AO|-7.4009|20.8185|M
DUJ|DuBois Regional Airport|Dubois|Pennsylvania|US|41.1783|-78.8987|M
DUM|Pinang Kampai Airport|Dumai|Riau|ID|1.6090|101.4335|M
DUR|King Shaka International Airport|Durban|Kwazulu-Natal|ZA|-29.6144|31.1197|L
DUT|Tom Madsen (Dutch Harbor) Airport|Unalaska|Alaska|US|53.8988|-166.5450|M
DVL|Devils Lake Regional Airport|Devils Lake|North Dakota|US|48.1155|-98.9088|M
DVO|Francisco Bangoy International Airport|Davao|Davao City|PH|7.1255|125.6460|L
DWC|Al Maktoum International Airport|Dubai(Jebel Ali)|Dubai Emirate|AE|24.8962|55.1624|L
DWD|Dawadmi Domestic Airport|Dawadmi|Riyadh Region|SA|24.4499|44.1212|M
DXN|Noida International Airport|Gautam Buddha Nagar|Uttar Pradesh|IN|28.1799|77.6118|L
DYG|Zhangjiajie Hehua International Airport|Zhangjiajie (Yongding)|Hunan Province|CN|29.1047|110.4428|L
DYR|Ugolny Yuri Ryktheu Airport|Anadyr|Chukotka Autonomous Okrug|RU|64.7349|177.7410|M
DYU|Dushanbe International Airport|Dushanbe|Dushanbe|TJ|38.5437|68.8230|L
DZA|Dzaoudzi Pamandzi International Airport|Dzaoudzi||YT|-12.8093|45.2818|L
DZH|Dazhou Jinya Airport|Dazhou (Dachuan)|Sichuan Province|CN|31.0488|107.4356|M
DZN|Zhezkazgan National Airport|Zhezkazgan|Ulytau Region|KZ|47.7090|67.7381|L
EAM|Najran Domestic Airport|Najran|Najran Region|SA|17.6114|44.4192|M
EAR|Kearney Regional Airport|Kearney|Nebraska|US|40.7270|-99.0068|M
EAS|San Sebastián Airport|Hondarribia|Basque Country|ES|43.3565|-1.7906|M
EAT|Pangborn Memorial Airport|Wenatchee|Washington|US|47.3989|-120.2070|M
EAU|Chippewa Valley Regional Airport|Eau Claire|Wisconsin|US|44.8658|-91.4843|M
EBA|Marina di Campo Airport|Campo nell'Elba (LI)|Tuscany|IT|42.7609|10.2398|M
EBB|Entebbe International Airport|Entebbe|Central Region|UG|0.0424|32.4435|L
EBD|El-Obeid Airport|El-Obeid|North Kurdufan State|SD|13.1532|30.2327|M
EBJ|Esbjerg Airport|Esbjerg|South Denmark|DK|55.5259|8.5534|M
EBL|Erbil International Airport|Arbil|Erbil Governorate|IQ|36.2360|43.9466|L
ECN|Ercan International Airport|Tymbou (Kirklar)|Nicosia District|CY|35.1531|33.5074|L
ECP|Northwest Florida Beaches International Airport|Panama City Beach|Florida|US|30.3571|-85.7954|M
EDL|Eldoret International Airport|Eldoret|Uasin Gishu County|KE|0.4045|35.2389|L
EDO|Balıkesir Koca Seyit Airport|Edremit|Balıkesir Province|TR|39.5525|27.0102|L
EFL|Kefalonia International Airport "Anna Pollatou"|Kefallinia Island|Ionian Islands|GR|38.1201|20.5005|L
EGC|Bergerac Dordogne-Périgord airport|Bergerac|Nouvelle-Aquitaine|FR|44.8253|0.5186|M
EGE|Eagle County Regional Airport|Eagle|Colorado|US|39.6426|-106.9180|M
EGS|Egilsstaðir Airport|Egilsstaðir|Eastern Region|IS|65.2833|-14.4014|M
EGX|Egegik Airport|Egegik|Alaska|US|58.1844|-157.3749|M
EHU|Ezhou Huahu International Airport|Ezhou|Hubei Province|CN|30.3412|115.0393|L
EIE|Yeniseysk Airport|Yeniseysk|Krasnoyarsk Krai|RU|58.4742|92.1125|M
EIN|Eindhoven Airport|Eindhoven|Noord-Brabant|NL|51.4501|5.3745|L
EIS|Terrance B. Lettsome International Airport|Beef Island||VG|18.4455|-64.5417|L
EJA|Yariguíes Airport|Barrancabermeja|Santander Department|CO|7.0243|-73.8068|M
EJH|Al Wajh Domestic Airport|Al Wajh|Tabuk Region|SA|26.1986|36.4764|M
EKO|Elko Regional Airport|Elko|Nevada|US|40.8249|-115.7920|M
ELC|Elcho Island Airport|Elcho Island|Northern Territory|AU|-12.0194|135.5710|M
ELD|South Arkansas Regional Airport at Goodwin Field|El Dorado|Arkansas|US|33.2210|-92.8133|M
ELF|El Fasher Airport|El Fasher|North Darfur State|SD|13.6149|25.3246|M
ELG|El Golea Airport|El Menia|El Menia Province|DZ|30.5807|2.8616|M
ELH|North Eleuthera Airport|North Eleuthera|Harbour Island|BS|25.4758|-76.6808|M
ELM|Elmira Corning Regional Airport|Elmira/Corning|New York|US|42.1599|-76.8916|M
ELP|El Paso International Airport|El Paso|Texas|US|31.8099|-106.3756|L
ELQ|Prince Naif bin Abdulaziz International Airport|Qassim|Al Qasim Region|SA|26.3028|43.7744|L
ELS|King Phalo Airport|East London|Eastern Cape|ZA|-33.0356|27.8259|L
ELU|Guemar Airport - مطار قمار بالوادي|Guemar|El Oued Province|DZ|33.5114|6.7768|M
EMA|East Midlands Airport|Nottingham, Leicestershire|England|GB|52.8311|-1.3281|L
EMD|Emerald Airport|Emerald|Queensland|AU|-23.5675|148.1790|M
EMK|Emmonak Airport|Emmonak|Alaska|US|62.7861|-164.4910|M
ENA|Kenai Municipal Airport|Kenai|Alaska|US|60.5709|-151.2452|M
ENF|Enontekio Airport|Enontekio|Lapland Region|FI|68.3626|23.4243|M
ENH|Enshi Xujiaping Airport|Enshi (Enshi)|Hubei Province|CN|30.3203|109.4850|M
ENO|Teniente Ramon A. Ayub Gonzalez International Airport|Encarnación|Itapúa Department|PY|-27.2275|-55.8376|L
ENU|Akanu Ibiam International Airport|Enegu|Enugu State|NG|6.4737|7.5605|L
ENY|Yan'an Nanniwan Airport|Yan'an (Baota)|Shaanxi Province|CN|36.4794|109.4641|M
EOH|Enrique Olaya Herrera Airport|Medellín|Antioquía Department|CO|6.2197|-75.5906|M
EOI|Eday Airport|Eday|Scotland|GB|59.1906|-2.7722|M
EPR|Esperance Airport|Esperance|Western Australia|AU|-33.6844|121.8230|M
EPU|Pärnu Airport|Pärnu|Pärnu County|EE|58.4190|24.4728|M
EQS|Esquel Brigadier Antonio Parodi International Airport|Esquel|Chubut Province|AR|-42.9080|-71.1395|M
ERC|Erzincan Airport|Erzincan|Erzincan Province|TR|39.7102|39.5270|M
ERF|Erfurt-Weimar Airport|Erfurt|Thuringia|DE|50.9783|10.9607|L
ERH|Moulay Ali Cherif Airport|Errachidia|Drâa-Tafilalet Region|MA|31.9475|-4.3983|M
ERI|Erie International Tom Ridge Field|Erie|Pennsylvania|US|42.0831|-80.1739|M
ERL|Erenhot Saiwusu International Airport|Erenhot|Inner Mongolia Autonomous Region|CN|43.4241|112.0911|M
ERS|Eros Airport|Windhoek|Khomas Region|NA|-22.6049|17.0790|M
ERZ|Erzurum International Airport|Erzurum|Erzurum Province|TR|39.9565|41.1702|M
ESB|Esenboğa International Airport|Ankara|Ankara Province|TR|40.1281|32.9951|L
ESC|Delta County Airport|Escanaba|Michigan|US|45.7232|-87.0886|M
ESD|Orcas Island Airport|Eastsound|Washington|US|48.7082|-122.9100|M
ESL|Elista Airport|Elista|Republic of Kalmykia|RU|46.3739|44.3309|M
ESM|Carlos Concha Torres International Airport|Tachina|Esmeraldas Province|EC|0.9785|-79.6266|L
ESR|Ricardo García Posada Airport|El Salvador|Atacama Region|CL|-26.3111|-69.7652|M
ESU|Essaouira-Mogador Airport|Essaouira|Marrakech-Safi Region|MA|31.3975|-9.6817|M
ETM|Ramon International Airport|Eilat|Southern District|IL|29.7270|35.0141|L
ETR|Santa Rosa - Artillery Colonel Victor Larrea International Airport|Santa Rosa|El Oro Province|EC|-3.4420|-79.9970|M
ETZ|Metz-Nancy-Lorraine Airport|Goin|Grand Est|FR|48.9821|6.2513|M
EUG|Eugene Airport|Eugene|Oregon|US|44.1246|-123.2120|M
EUN|Laayoune Hassan I International Airport|El Aaiún||EH|27.1425|-13.2249|L
EUX|F. D. Roosevelt Airport|Oranjestad|Sint Eustatius|BQ|17.4965|-62.9794|M
EVE|Harstad/Narvik Airport|Evenes|Nordland|NO|68.4913|16.6781|L
EVV|Evansville Regional Airport|Evansville|Indiana|US|38.0370|-87.5324|M
EWB|New Bedford Regional Airport|New Bedford|Massachusetts|US|41.6761|-70.9569|M
EWN|Coastal Carolina Regional Airport|New Bern|North Carolina|US|35.0730|-77.0429|M
EXT|Exeter International Airport|Exeter, Devon|England|GB|50.7343|-3.4140|M
EYP|El Alcaravan - Yopal Airport|Yopal|Casanare Department|CO|5.3191|-72.3840|M
EYW|Key West International Airport|Key West|Florida|US|24.5561|-81.7596|M
EZS|Elazığ Airport|Elazığ|Elazığ Province|TR|38.5980|39.2835|M
FAE|Vágar Airport|Vágar||FO|62.0633|-7.2758|L
FAI|Fairbanks International Airport|Fairbanks|Alaska|US|64.8151|-147.8560|M
FAO|Faro - Gago Coutinho International Airport|Faro|Faro District|PT|37.0159|-7.9709|L
FAR|Hector International Airport|Fargo|North Dakota|US|46.9207|-96.8158|M
FAT|Fresno Yosemite International Airport|Fresno|California|US|36.7758|-119.7180|L
FAY|Fayetteville Regional Airport - Grannis Field|Fayetteville|North Carolina|US|34.9912|-78.8803|M
FBM|Lubumbashi International Airport|Lubumbashi|Haut-Katanga Province|CD|-11.5915|27.5308|L
FCA|Glacier Park International Airport|Kalispell|Montana|US|48.3105|-114.2560|M
FCN|Sea-Airport Cuxhaven/Nordholz / Nordholz Naval Airbase|Wurster Nordseeküste|Lower Saxony|DE|53.7677|8.6592|M
FDF|Martinique Aimé Césaire International Airport|Fort-de-France||MQ|14.5910|-61.0032|L
FDH|Bodensee Airport Friedrichshafen|Friedrichshafen|Baden-Württemberg|DE|47.6713|9.5115|L
FDU|Bandundu Airport|Bandundu|Kwilu Province|CD|-3.3113|17.3817|M
FEG|Fergana International Airport|Fergana|Fergana Region|UZ|40.3588|71.7450|M
FEN|Fernando de Noronha Airport|Fernando de Noronha|Pernambuco|BR|-3.8545|-32.4230|M
FEZ|Fes Saïss International Airport|Saïss|Fès-Meknès Region|MA|33.9273|-4.9780|L
FGU|Fangatau Airport|Fangatau||PF|-15.8200|-140.8881|M
FIH|Ndjili International Airport|Kinshasa|Kinshasa Province|CD|-4.3857|15.4446|L
FJR|Fujairah International Airport|Fujairah|Fujairah Emirate|AE|25.1084|56.3281|L
FKB|Karlsruhe Baden-Baden Airport|Rheinmünster|Baden-Württemberg|DE|48.7794|8.0805|L
FKI|Bangoka International Airport|Kisangani|Tshopo Province|CD|0.4816|25.3380|L
FKQ|Fakfak Airport|Fakfak|Papua Barat (West Papua)|ID|-2.9205|132.2670|M
FKS|Fukushima Airport|Sukagawa|Fukushima Prefecture|JP|37.2274|140.4310|M
FLA|Gustavo Artunduaga Paredes Airport|Florencia|Caquetá Department|CO|1.5892|-75.5644|M
FLG|Flagstaff Pulliam Airport|Flagstaff|Arizona|US|35.1398|-111.6698|M
FLL|Fort Lauderdale Hollywood International Airport|Fort Lauderdale|Florida|US|26.0726|-80.1527|L
FLN|Hercílio Luz International Airport|Florianópolis|Santa Catarina|BR|-27.6703|-48.5525|L
FLO|Florence Regional Airport|Florence|South Carolina|US|34.1854|-79.7239|M
FLW|Flores Airport|Santa Cruz das Flores|Autonomous Region of Azores|PT|39.4553|-31.1314|M
FLZ|Dr. Ferdinand Lumban Tobing Airport|Sibolga (Pinangsori)|Sumatera Utara (North Sumatra)|ID|1.5571|98.8871|M
FMA|Formosa National Airport|Formosa|Formosa Province|AR|-26.2127|-58.2281|M
FMI|Kalemie Airport|Kalemie|Tanganyika Province|CD|-5.8756|29.2500|M
FMM|Memmingen Allgau Airport|Memmingen|Bavaria|DE|47.9881|10.2382|L
FMO|Münster Osnabrück Airport|Greven|North Rhine-Westphalia|DE|52.1338|7.6885|L
FNA|Lungi International Airport|Freetown (Lungi-Town)|Northern Province|SL|8.6164|-13.1955|L
FNC|Cristiano Ronaldo International Airport|Funchal|Autonomous Region of Madeira|PT|32.6978|-16.7746|L
FNI|Nîmes-Arles-Camargue Airport|Nîmes/Garons|Occitanie|FR|43.7574|4.4164|M
FNJ|Pyongyang Sunan International Airport|Pyongyang|Pyongyang (capital city)|KP|39.2241|125.6700|L
FNT|Bishop International Airport|Flint|Michigan|US|42.9693|-83.7434|M
FOC|Fuzhou Changle International Airport|Fuzhou (Changle)|Fujian Province|CN|25.9293|119.6725|L
FOD|Fort Dodge Regional Airport|Fort Dodge|Iowa|US|42.5526|-94.1912|M
FOG|Foggia Gino Lisa Airport|Foggia (FG)|Apulia|IT|41.4336|15.5346|M
FON|La Fortuna Arenal Airport|La Fortuna|Alajuela Province|CR|10.4693|-84.5791|M
FOR|Pinto Martins International Airport|Fortaleza|Ceará|BR|-3.7758|-38.5322|L
FPO|Grand Bahama International Airport|Freeport|City of Freeport|BS|26.5580|-78.6956|L
FRD|Friday Harbor Airport|Friday Harbor|Washington|US|48.5237|-123.0246|M
FRL|Forlì-Luigi Ridolfi International Airport|Forlì (FC)|Emilia-Romagna|IT|44.1948|12.0701|M
FRO|Florø Airport|Florø|Vestland|NO|61.5836|5.0247|M
FRS|Mundo Maya International Airport|San Benito|Petén Department|GT|16.9137|-89.8661|M
FRW|Phillip Gaonwe Matante International Airport|Francistown|Francistown (city)|BW|-21.1592|27.4688|L
FSC|Figari Sud-Corse Airport|Figari|Corsica|FR|41.5018|9.0971|L
FSD|Sioux Falls Regional Airport|Sioux Falls|South Dakota|US|43.5855|-96.7412|M
FSM|Fort Smith Regional Airport|Fort Smith|Arkansas|US|35.3366|-94.3674|M
FSP|Saint-Pierre Pointe-Blanche Airport|Saint-Pierre|Saint-Pierre|PM|46.7627|-56.1750|M
FSZ|Mount Fuji Shizuoka Airport|Makinohara / Shimada|Shizuoka Prefecture|JP|34.7950|138.1910|L
FTE|El Calafate - Commander Armando Tola International Airport|El Calafate|Santa Cruz Province|AR|-50.2803|-72.0534|M
FTU|Tôlanaro Airport|Tôlanaro|Toliara|MG|-25.0381|46.9561|M
FTW|Fort Worth Meacham International Airport|Fort Worth|Texas|US|32.8199|-97.3608|M
FUE|Fuerteventura Airport|El Matorral|Canary Islands|ES|28.4527|-13.8638|L
FUG|Fuyang Xiguan Airport|Yingzhou, Fuyang|Anhui Province|CN|32.8822|115.7344|M
FUJ|Fukue Airport|Goto|Nagasaki Prefecture|JP|32.6663|128.8330|M
FUK|Fukuoka Airport|Fukuoka|Fukuoka Prefecture|JP|33.5859|130.4510|L
FUN|Funafuti International Airport|Funafuti|Funafuti|TV|-8.5239|179.1970|M
FUO|Foshan Shadi Airport|Foshan (Nanhai)|Guangdong Province|CN|23.0825|113.0708|M
FWA|Fort Wayne International Airport|Fort Wayne|Indiana|US|40.9789|-85.1945|M
FYJ|Fuyuan Dongji Airport|Fuyuan|Heilongjiang Province|CN|48.1972|134.3630|M
FYN|Fuyun Koktokay Airport|Fuyun|Xinjiang Autonomous Region|CN|46.8042|89.5120|M
FYU|Fort Yukon Airport|Fort Yukon|Alaska|US|66.5717|-145.2500|M
GAJ|Yamagata Airport|Higashine|Yamagata Prefecture|JP|38.4119|140.3710|M
GAL|Edward G. Pitka Sr Airport|Galena|Alaska|US|64.7362|-156.9370|M
GAM|Gambell Airport|Gambell|Alaska|US|63.7677|-171.7333|M
GAN|Gan International Airport|Gan|Addu Atoll|MV|-0.6930|73.1526|L
GAQ|Gao International Airport|Gao|Gao Region|ML|16.2485|-0.0054|M
GAU|Lokpriya Gopinath Bordoloi International Airport|Guwahati|Assam|IN|26.1067|91.5852|L
GAY|Gaya Airport|Gaya|Bihar|IN|24.7443|84.9512|M
GBB|Gabala International Airport|Gabala|Qabala District|AZ|40.8086|47.7254|M
GBE|Sir Seretse Khama International Airport|Gaborone|Gaborone (city)|BW|-24.5552|25.9182|L
GBJ|Marie-Galante Airport|Grand-Bourg||GP|15.8689|-61.2701|M
GCC|Northeast Wyoming Regional Airport|Gillette|Wyoming|US|44.3489|-105.5390|M
GCH|Gachsaran Airport|Gachsaran|Kohgiluyeh and Boyer-Ahmad Province|IR|30.3339|50.8338|M
GCI|Guernsey Airport|Saint Peter Port|Guernsey|GG|49.4350|-2.6020|M
GCK|Garden City Regional Airport|Garden City|Kansas|US|37.9275|-100.7240|M
GCM|Owen Roberts International Airport|George Town|Grand Cayman|KY|19.2928|-81.3577|L
GCN|Grand Canyon National Park Airport|Grand Canyon - Tusayan|Arizona|US|35.9524|-112.1470|M
GDB|Gondia Airport|Gondia|Maharashtra|IN|21.5268|80.2903|M
GDE|Gode Airport|Gode|Somali Region|ET|5.9351|43.5786|M
GDN|Gdańsk Lech Wałęsa Airport|Gdańsk|Pomeranian Voivodeship|PL|54.3776|18.4662|L
GDQ|Gondar Airport|Azezo|Amhara Region|ET|12.5199|37.4340|M
GDT|JAGS McCartney International Airport|Cockburn Town|Grand Turk|TC|21.4445|-71.1423|M
GDV|Dawson Community Airport|Glendive|Montana|US|47.1377|-104.8069|M
GDX|Sokol Airport|Magadan|Magadan Oblast|RU|59.9110|150.7200|M
GDZ|Gelendzhik Airport|Gelendzhik|Krasnodar Krai|RU|44.5821|38.0125|M
GEA|Nouméa Magenta Airport|Nouméa|Province Sud|NC|-22.2577|166.4728|M
GEG|Spokane International Airport|Spokane|Washington|US|47.6199|-117.5340|L
GEL|Santo Ângelo Airport|Santo Ângelo|Rio Grande do Sul|BR|-28.2825|-54.1696|M
GEM|President Obiang Nguema International Airport|Mengomeyén|Wele-Nzas Province|GQ|1.6764|11.0249|M
GEO|Cheddi Jagan International Airport|Georgetown|Demerara-Mahaica|GY|6.4985|-58.2541|L
GER|Rafael Cabrera Airport|Nueva Gerona|Isla de la Juventud (special municipality)|CU|21.8347|-82.7838|M
GES|General Santos International Airport|General Santos|South Cotabato Province|PH|6.0572|125.0962|L
GET|Geraldton Airport|Moonyoonooka|Western Australia|AU|-28.7961|114.7070|M
GEV|Gällivare Airport|Gällivare|Norrbottena län|SE|67.1324|20.8146|M
GFF|Griffith Airport|Griffith|New South Wales|AU|-34.2508|146.0670|M
GFK|Grand Forks International Airport|Grand Forks|North Dakota|US|47.9493|-97.1761|M
GGG|East Texas Regional Airport|Longview|Texas|US|32.3840|-94.7115|M
GGT|Exuma International Airport|Moss Town|Exuma|BS|23.5626|-75.8780|M
GGW|Glasgow Valley County Airport Wokal Field|Glasgow|Montana|US|48.2125|-106.6150|M
GHA|Noumérat - Moufdi Zakaria Airport|El Atteuf|Ghardaïa Province|DZ|32.3841|3.7941|M
GHB|Governor's Harbour Airport|Governor's Harbour|Central Eleuthera|BS|25.2847|-76.3310|M
GHV|Brașov-Ghimbav International Airport|Brașov (Ghimbav)|Braşov County|RO|45.7056|25.5229|L
GIB|Gibraltar Airport|Gibraltar||GI|36.1517|-5.3498|L
GID|Gitega Airport|Gitega|Gitega Province|BI|-3.4172|29.9113|M
GIL|Gilgit Airport|Gilgit|Gilgit-Baltistan|PK|35.9188|74.3336|M
GIS|Gisborne Airport|Gisborne|Gisborne Region|NZ|-38.6633|177.9780|M
GIZ|Jizan Regional Airport / King Abdullah bin Abdulaziz Airport|Jizan|Jlzan Region|SA|16.9011|42.5858|M
GJA|La Laguna Airport|Guanaja|Islas de la Bahía Department|HN|16.4454|-85.9066|M
GJL|Jijel Ferhat Abbas Airport|Tahir|Jijel Province|DZ|36.7941|5.8737|L
GJT|Grand Junction Regional Airport|Grand Junction|Colorado|US|39.1267|-108.5294|M
GKA|Goroka Airport|Goronka|Eastern Highlands Province|PG|-6.0817|145.3920|M
GKN|Gulkana Airport|Gulkana|Alaska|US|62.1559|-145.4547|M
GLA|Glasgow Airport|Glasgow|Scotland|GB|55.8719|-4.4331|L
GLF|Golfito Airport|Golfito|Puntarenas Province|CR|8.6540|-83.1822|M
GLH|Mid Delta Regional Airport|Greenville|Mississippi|US|33.4829|-90.9856|M
GLT|Gladstone Airport|Gladstone|Queensland|AU|-23.8698|151.2254|M
GMA|Gemena Airport|Gemena|Sud-Ubangi Province|CD|3.2354|19.7713|M
GMB|Gambela Airport|Gambela|Gambela Region|ET|8.1288|34.5631|M
GME|Gomel Airport|Gomel|Gomel Region|BY|52.5270|31.0167|M
GMO|Gombe Lawanti International Airport|Gombe|Gombe State|NG|10.2989|10.9000|M
GMP|Seoul Gimpo International Airport|Seoul|Seoul-teukbyeolsi (Seoul Special City)|KR|37.5583|126.7910|L
GMQ|Golog Maqên Airport|Golog (Maqên)|Qinghai Province|CN|34.4181|100.3011|M
GNB|Grenoble Alpes Isère Airport|Grenoble|Auvergne-Rhône-Alpes|FR|45.3629|5.3294|M
GND|Maurice Bishop International Airport|Saint George's|Saint George|GD|12.0040|-61.7853|L
GNJ|Ganja International Airport|Ganja|Ganja (city)|AZ|40.7387|46.3204|L
GNS|Binaka Airport|Gunungsitoli|Sumatera Utara (North Sumatra)|ID|1.1663|97.7052|M
GNV|Gainesville Regional Airport|Gainesville|Florida|US|29.6901|-82.2718|M
GNY|Şanlıurfa GAP Airport|Şanlıurfa|Şanlıurfa Province|TR|37.4457|38.8956|L
GOA|Genoa Cristoforo Colombo Airport|Genova (GE)|Liguria|IT|44.4120|8.8407|L
GOH|Nuuk International Airport|Nuuk|Sermersooq Municipality|GL|64.1911|-51.6791|L
GOI|Goa Dabolim International Airport|Vasco da Gama|Goa|IN|15.3801|73.8333|L
GOJ|Nizhny Novgorod / Strigino International Airport|Nizhny Novgorod|Nizhny Novgorod Oblast|RU|56.2274|43.7852|L
GOM|Goma International Airport|Goma|Nord-Kivu Province|CD|-1.6668|29.2380|L
GOP|Gorakhpur Airport|Gorakhpur|Uttar Pradesh|IN|26.7397|83.4497|M
GOQ|Golmud Airport|Golmud|Qinghai Province|CN|36.4006|94.7861|M
GOT|Göteborg Landvetter Airport|Göteborg|Västra Götalands län|SE|57.6628|12.2798|L
GOU|Garoua International Airport|Garoua|North Region|CM|9.3348|13.3721|L
GOV|Gove Airport|Nhulunbuy|Northern Territory|AU|-12.2694|136.8180|M
GOX|Manohar International Airport|Mopa|Goa|IN|15.7443|73.8606|L
GPA|Patras Araxos Agamemnon Airport|Patras|Western Greece|GR|38.1511|21.4256|M
GPI|Guapi Airport|Guapi|Cauca Department|CO|2.5701|-77.8980|M
GPS|Seymour Galapagos Ecological Airport|Isla Baltra|Galapagos Province|EC|-0.4538|-90.2659|M
GPT|Gulfport Biloxi International Airport|Gulfport|Mississippi|US|30.4056|-89.0698|M
GRB|Austin Straubel International Airport|Green Bay|Wisconsin|US|44.4835|-88.1308|M
GRI|Central Nebraska Regional Airport|Grand Island|Nebraska|US|40.9675|-98.3096|M
GRJ|George Airport|George|Western Cape|ZA|-34.0056|22.3789|L
GRK|Killeen Regional Airport / Robert Gray Army Airfield|Fort Cavazos|Texas|US|31.0672|-97.8289|M
GRO|Girona-Costa Brava Airport|Girona|Catalonia|ES|41.9046|2.7618|L
GRQ|Groningen Airport Eelde|Groningen|Drenthe|NL|53.1191|6.5777|L
GRR|Gerald R. Ford International Airport|Grand Rapids|Michigan|US|42.8808|-85.5228|L
GRV|Akhmat Kadyrov Grozny International Airport|Grozny|Chechen Republic|RU|43.3881|45.6998|L
GRW|Graciosa Airport|Santa Cruz da Graciosa|Autonomous Region of Azores|PT|39.0922|-28.0298|M
GRX|F.G.L. Airport Granada-Jaén Airport|Granada|Andalucía|ES|37.1887|-3.7774|M
GRY|Grímsey Airport|Grímsey/Sandvík|Northeastern Region|IS|66.5458|-18.0173|M
GRZ|Graz Airport|Feldkirchen bei Graz|Styria|AT|46.9911|15.4396|L
GSM|Qeshm International Airport|Qeshm(Dayrestan)|Hormozgan Province|IR|26.7546|55.9024|L
GSO|Piedmont Triad International Airport|Greensboro|North Carolina|US|36.0994|-79.9373|L
GSP|Greenville-Spartanburg International Airport|Greenville/Greer/Spartanburg|South Carolina|US|34.8957|-82.2189|M
GST|Gustavus Airport|Gustavus|Alaska|US|58.4253|-135.7070|M
GSV|Gagarin International Airport|Saratov|Saratov Oblast|RU|51.7128|46.1711|L
GTE|Groote Eylandt Airport|Groote Eylandt|Northern Territory|AU|-13.9724|136.4586|M
GTF|Great Falls International Airport|Great Falls|Montana|US|47.4820|-111.3710|M
GTR|Golden Triangle Regional Airport|Columbus/W Point/Starkville|Mississippi|US|33.4503|-88.5914|M
GUA|La Aurora International Airport|Guatemala City|Guatemala Department|GT|14.5829|-90.5275|L
GUC|Gunnison Crested Butte Regional Airport|Gunnison|Colorado|US|38.5347|-106.9346|M
GUM|Antonio B. Won Pat International Airport|Hagåtña||GU|13.4850|144.7973|L
GUP|Gallup Municipal Airport|Gallup|New Mexico|US|35.5117|-108.7882|M
GUR|Gurney Airport|Gurney|Milne Bay Province|PG|-10.3115|150.3340|M
GUW|Atyrau International Airport|Atyrau|Atyrau Region|KZ|47.1213|51.8203|L
GVR|Coronel Altino Machado Airport|Governador Valadares|Minas Gerais|BR|-18.8959|-41.9829|M
GWD|New Gwadar International Airport|Gurandani|Balochistan|PK|25.2967|62.4988|L
GWL|Gwalior Airport|Gwalior|Madhya Pradesh|IN|26.2933|78.2278|M
GWT|Westerland Sylt Airport|Sylt|Schleswig-Holstein|DE|54.9132|8.3405|M
GXF|Seiyun Hadhramaut International Airport|Seiyun|Hadhramaut Governorate|YE|15.9659|48.7881|L
GXG|Negage Airport|Negage|Uíge Province|AO|-7.7545|15.2877|M
GXH|Gannan Xiahe Airport|Gannan (Xiahe)|Gansu Province|CN|34.8190|102.6223|M
GYA|Guayaramerín Airport|Guayaramerín|El Beni Department|BO|-10.8886|-65.3810|M
GYE|José Joaquín de Olmedo International Airport|Guayaquil|Guayas Province|EC|-2.1574|-79.8836|L
GYM|General José María Yáñez International Airport|Guaymas|Sonora|MX|27.9690|-110.9250|M
GYN|Santa Genoveva International Airport|Goiânia|Goiás|BR|-16.6320|-49.2207|L
GYS|Guangyuan Panlong Airport|Guangyuan (Lizhou)|Sichuan Province|CN|32.3903|105.6946|M
GYU|Guyuan Liupanshan Airport|Guyuan (Yuanzhou)|Ningxia Autonomous Region|CN|36.0789|106.2169|M
GYY|Gary/Chicago International Airport|Gary|Indiana|US|41.6171|-87.4132|M
GZP|Gazipaşa-Alanya Airport|Gazipaşa|Antalya Province|TR|36.2988|32.2970|M
GZT|Gaziantep Oğuzeli International Airport|Gaziantep|Gaziantep Province|TR|36.9472|37.4787|L
HAC|Hachijojima Airport|Hachijojima|Tōkyō Prefecture|JP|33.1148|139.7856|M
HAD|Halmstad Airport|Halmstad|Hallands län|SE|56.6911|12.8202|M
HAH|Prince Said Ibrahim International Airport|Moroni|Grande Comore (Ngazidja)|KM|-11.5337|43.2719|M
HAJ|Hannover Airport|Hannover|Lower Saxony|DE|52.4611|9.6851|L
HAK|Haikou Meilan International Airport|Haikou (Meilan)|Hainan Province|CN|19.9349|110.4590|L
HAQ|Hanimaadhoo International Airport|Haa Dhaalu Atoll|Haa Dhaalu Atoll|MV|6.7432|73.1671|L
HAS|Hail International Airport|Hail|Ha'il Region|SA|27.4379|41.6863|L
HAU|Haugesund Airport, Karmøy|Karmøy|Rogaland|NO|59.3453|5.2084|M
HBA|Hobart International Airport|Hobart (Cambridge)|Tasmania|AU|-42.8370|147.5130|L
HBE|Alexandria International Airport|Alexandria|Alexandria Governorate|EG|30.9325|29.6964|L
HBX|Hubballi Airport|Hubballi|Karnataka|IN|15.3611|75.0821|M
HCJ|Hechi Jinchengjiang Airport|Hechi (Jinchengjiang)|Guangxi Autonomous Region|CN|24.8043|107.7108|M
HCR|Holy Cross Airport|Holy Cross|Alaska|US|62.1883|-159.7750|M
HCZ|Chenzhou Beihu Airport|Chenzhou|Hunan Province|CN|25.7534|112.8454|M
HDF|Heringsdorf Airport|Zirchow|Mecklenburg-Vorpommern|DE|53.8787|14.1523|M
HDG|Handan Airport|Handan|Hebei Province|CN|36.5248|114.4241|M
HDM|Hamadan Airport|Hamadan|Hamadan Province|IR|34.8664|48.5607|M
HDN|Yampa Valley Airport|Hayden|Colorado|US|40.4812|-107.2180|M
HDS|Eastgate Airport / Air Force Base Hoedspruit|Hoedspruit|Limpopo|ZA|-24.3619|31.0529|M
HDY|Hat Yai International Airport|Hat Yai|Songkhla Province|TH|6.9332|100.3930|L
HEA|Herat - Khwaja Abdullah Ansari International Airport|Guzara|Herat Province|AF|34.2100|62.2283|L
HEH|Heho Airport|Heho|Shan State|MM|20.7471|96.7920|M
HEK|Heihe Aihui Airport|Heihe|Heilongjiang Province|CN|50.1716|127.3089|M
HET|Hohhot Baita International Airport|Hohhot|Inner Mongolia Autonomous Region|CN|40.8497|111.8246|L
HFA|Uri Michaeli Haifa International Airport|Haifa|Haifa District|IL|32.8102|35.0437|M
HFE|Hefei Xinqiao International Airport|Hefei|Anhui Province|CN|31.9878|116.9769|L
HFN|Hornafjörður Airport|Höfn|Southern Region|IS|64.2956|-15.2272|M
HFT|Hammerfest Airport|Hammerfest|Finnmark|NO|70.6797|23.6686|M
HGA|Egal International Airport|Hargeisa|Maroodi Jeex|SO|9.5141|44.0835|L
HGH|Hangzhou Xiaoshan International Airport|Hangzhou|Zhejiang Province|CN|30.2361|120.4289|L
HGI|Itanagar Donyi Polo Hollongi Airport|Hollongi|Arunachal Pradesh|IN|26.9668|93.6388|M
HGN|Mae Hong Son Airport|Mae Hong Son|Mae Hong Son Province|TH|19.3013|97.9758|M
HGO|Korhogo Airport|Korhogo|Savanes District|CI|9.3872|-5.5567|M
HGR|Hagerstown Regional Richard A Henson Field|Hagerstown|Maryland|US|39.7088|-77.7280|M
HGU|Mount Hagen Kagamuga Airport|Mount Hagen|Western Highlands Province|PG|-5.8282|144.2994|M
HHH|Hilton Head Airport|Hilton Head Island|South Carolina|US|32.2244|-80.6975|M
HHN|Frankfurt-Hahn Airport|Frankfurt am Main (Lautzenhausen)|Rhineland-Palatinate|DE|49.9464|7.2617|L
HHQ|Hua Hin Airport|Hua Hin|Phetchaburi Province|TH|12.6362|99.9515|M
HHR|Jack Northrop Field Hawthorne Municipal Airport|Hawthorne|California|US|33.9228|-118.3350|M
HIA|Huai'an Lianshui Airport|Huai'an|Jiangsu Province|CN|33.7927|119.1267|L
HIB|Range Regional Airport|Hibbing|Minnesota|US|47.3848|-92.8369|M
HID|Horn Island Airport|Horn|Queensland|AU|-10.5856|142.2928|M
HII|Lake Havasu City Airport|Lake Havasu City|Arizona|US|34.5705|-114.3577|M
HIJ|Hiroshima Airport|Hiroshima|Hiroshima Prefecture|JP|34.4361|132.9190|L
HIN|Sacheon Airport / Sacheon Air Base|Sacheon|Gyeongsangnam-do (South Gyeongsang Province)|KR|35.0886|128.0717|M
HIR|Honiara International Airport|Honiara|Guadalcanal Province|SB|-9.4280|160.0550|L
HJJ|Huaihua Zhijiang Airport|Huaihua|Hunan Province|CN|27.4431|109.7047|M
HJR|Khajuraho Airport|Khajuraho|Madhya Pradesh|IN|24.8172|79.9186|M
HKD|Hakodate Airport|Hakodate|Hokkaidō Prefecture|JP|41.7700|140.8220|L
HKN|Hoskins Airport|Kimbe|West New Britain Province|PG|-5.4638|150.4073|M
HLA|Lanseria International Airport|Johannesburg|Gauteng|ZA|-25.9390|27.9266|L
HLD|Hulunbuir Hailar Airport|Hailar|Inner Mongolia Autonomous Region|CN|49.2086|119.8223|L
HLE|Saint Helena International Airport|Jamestown|Saint Helena|SH|-15.9589|-5.6461|M
HLN|Helena Regional Airport|Helena|Montana|US|46.6068|-111.9830|M
HLP|Halim Perdanakusuma International Airport|Jakarta|Jakarta Raya|ID|-6.2670|106.8903|L
HLZ|Hamilton International Airport|Hamilton|Waikato Region|NZ|-37.8670|175.3320|M
HMA|Khanty Mansiysk Airport|Khanty-Mansiysk|Khanty-Mansi Autonomous Okrug|RU|61.0285|69.0861|M
HMB|Suhaj International Airport|Suhaj|Sohag Governorate|EG|26.3425|31.7430|L
HME|Hassi Messaoud-Oued Irara Krim Belkacem Airport|Hassi Messaoud|Ouargla Province|DZ|31.6730|6.1404|M
HMI|Hami Airport|Hami|Xinjiang Autonomous Region|CN|42.8414|93.6692|M
HMO|General Ignacio L. Pesqueira International Airport|Hermosillo|Sonora|MX|29.0928|-111.0530|L
HNA|Iwate Hanamaki Airport|Hanamaki|Iwate Prefecture|JP|39.4286|141.1350|M
HNM|Hana Airport|Hana|Hawaii|US|20.7956|-156.0140|M
HNS|Haines Airport|Haines|Alaska|US|59.2439|-135.5239|M
HOB|Lea County Regional Airport|Hobbs|New Mexico|US|32.6875|-103.2170|M
HOF|Al-Ahsa International Airport|Hofuf|Ash Sharqiyah Region|SA|25.2853|49.4852|L
HOG|Frank Pais International Airport|Holguin|Holguín Province|CU|20.7851|-76.3155|L
HOI|Hao Airport|Otepa||PF|-18.0748|-140.9460|M
HOM|Homer Airport|Homer|Alaska|US|59.6445|-151.4792|M
HOR|Horta Airport|Horta|Autonomous Region of Azores|PT|38.5199|-28.7159|M
HOT|Memorial Field Airport|Hot Springs|Arkansas|US|34.4788|-93.0963|M
HOU|William P. Hobby Airport|Houston|Texas|US|29.6453|-95.2768|L
HOV|Ørsta-Volda Airport, Hovden|Ørsta|Møre og Romsdal|NO|62.1800|6.0741|M
HPA|Lifuka Island Airport|Lifuka|Ha'apai|TO|-19.7770|-174.3410|M
HPG|Shennongjia Hongping Airport|Shennongjia (Hongping)|Hubei Province|CN|31.6260|110.3400|M
HPH|Cat Bi International Airport|Haiphong (Hai An)|Red River Delta Region|VN|20.8174|106.7243|L
HPN|Westchester County Airport|White Plains|New York|US|41.0670|-73.7076|M
HQL|Tashikuergan Hongqilafu Airport|Tashikuergan|Xinjiang Autonomous Region|CN|37.6613|75.2889|M
HRB|Harbin Taiping International Airport|Harbin|Heilongjiang Province|CN|45.6234|126.2500|L
HRE|Robert Gabriel Mugabe International Airport|Harare|Harare Metropolitan Province|ZW|-17.9318|31.0928|L
HRG|Hurghada International Airport|Hurghada|Red Sea Governorate|EG|27.1768|33.7967|L
HRI|Mattala Rajapaksa International Airport|Mattala|Southern Province|LK|6.2839|81.1242|M
HRL|Valley International Airport|Harlingen|Texas|US|26.2285|-97.6544|M
HRO|Boone County Airport|Harrison|Arkansas|US|36.2615|-93.1547|M
HSA|Hazrat Sultan International Airport|Turkıstan|Turkistan Region|KZ|43.3111|68.5504|L
HSC|Shaoguan Danxia Airport|Shaoguan|Guangdong Province|CN|24.9786|113.4210|M
HSG|Kyushu Saga International Airport|Saga|Saga Prefecture|JP|33.1497|130.3020|L
HSL|Huslia Airport|Huslia|Alaska|US|65.6979|-156.3510|M
HSN|Zhoushan Putuoshan International Airport|Zhoushan|Zhejiang Province|CN|29.9339|122.3623|L
HSR|Rajkot International Airport|Rajkot|Gujarat|IN|22.3788|71.0394|L
HSS|Maharaja Agrasen International Airport|Hisar|Haryana|IN|29.1861|75.7414|L
HSV|Huntsville International Airport|Huntsville|Alabama|US|34.6362|-86.7744|M
HTA|Chita-Kadala International Airport|Chita|Zabaykalsky Krai|RU|52.0248|113.3058|L
HTG|Khatanga Airport|Khatanga|Krasnoyarsk Krai|RU|71.9781|102.4910|M
HTI|Hamilton Island Airport|Hamilton Island|Queensland|AU|-20.3581|148.9520|M
HTN|Hotan Airport|Hotan|Xinjiang Autonomous Region|CN|37.0385|79.8649|M
HTS|Tri-State Airport / Milton J. Ferguson Field|Huntington|West Virginia|US|38.3667|-82.5580|M
HTT|Huatugou Airport|Mengnai|Qinghai Province|CN|38.2016|90.8378|M
HTY|Hatay Airport|Antakya|Hatay Province|TR|36.3608|36.2856|M
HUH|Huahine-Fare Airport|Fare||PF|-16.6871|-151.0216|M
HUI|Phu Bai International Airport|Huế|North Central Region|VN|16.4006|107.7041|L
HUN|Hualien Chiashan Airport|Hualien City|Hualien County|TW|24.0232|121.6180|L
HUO|Holingol Huolinhe Airport|Holingol|Inner Mongolia Autonomous Region|CN|45.4872|119.4072|M
HUU|Alferez Fap David Figueroa Fernandini Airport|Huánuco|Huánuco Region|PE|-9.8788|-76.2048|M
HUX|Bahías de Huatulco International Airport|Huatulco|Oaxaca|MX|15.7754|-96.2605|L
HUY|Humberside Airport|Grimsby, Lincolnshire|England|GB|53.5762|-0.3495|M
HUZ|Huizhou Pingtan Airport|Huizhou (Pingtan)|Guangdong Province|CN|23.0500|114.6000|M
HVB|Hervey Bay Airport|Hervey Bay|Queensland|AU|-25.3201|152.8807|M
HVD|Khovd Airport|Khovd|Khovd Province|MN|47.9541|91.6282|M
HVG|Honningsvåg Airport, Valan|Honningsvåg|Finnmark|NO|71.0097|25.9836|M
HVN|Tweed New Haven Airport|New Haven|Connecticut|US|41.2629|-72.8877|M
HVR|Havre City County Airport|Havre|Montana|US|48.5414|-109.7629|M
HWR|Halwara International Airport|Halwara|Punjab|IN|30.7485|75.6298|L
HXD|Haixi Delingha Airport|Delingha|Qinghai Province|CN|37.1253|97.2687|M
HYA|Cape Cod Gateway Airport|Hyannis|Massachusetts|US|41.6693|-70.2804|M
HYD|Rajiv Gandhi International Airport|Hyderabad|Telangana|IN|17.2313|78.4299|L
HYN|Taizhou Luqiao Airport|Taizhou (Luqiao)|Zhejiang Province|CN|28.5622|121.4290|M
HYS|Hays Regional Airport|Hays|Kansas|US|38.8445|-99.2731|M
HZA|Heze Mudan Airport|Heze (Dingtao)|Shandong Province|CN|35.2130|115.7367|M
HZG|Hanzhong Chenggu Airport|Hanzhong (Chenggu)|Shaanxi Province|CN|33.1335|107.2038|M
HZH|Liping Airport|Liping|Guizhou Province|CN|26.3222|109.1499|M
IAA|Igarka Airport|Igarka|Krasnoyarsk Krai|RU|67.4372|86.6219|M
IAG|Niagara Falls International Airport|Niagara Falls|New York|US|43.1073|-78.9462|M
IAM|Zarzaitine - In Aménas Airport|In Aménas|Illizi Province|DZ|28.0515|9.6429|M
IAN|Bob Baker Memorial Airport|Kiana|Alaska|US|66.9761|-160.4390|M
IAR|Golden Ring Yaroslavl International Airport|Tunoshna|Yaroslavl Oblast|RU|57.5607|40.1574|L
IAS|Iaşi International Airport|Iaşi|Iaşi County|RO|47.1796|27.6214|L
IBA|Ibadan Airport|Ibadan|Oyo State|NG|7.3625|3.9783|M
IBE|Perales Airport|Ibagué|Tolima Department|CO|4.4216|-75.1333|M
IBR|Ibaraki Airport|Omitama|Ibaraki Prefecture|JP|36.1815|140.4144|L
IBZ|Ibiza Airport|Ibiza (Eivissa)|Islas Baleares|ES|38.8729|1.3731|L
ICT|Wichita Dwight D. Eisenhower National Airport|Wichita|Kansas|US|37.6503|-97.4286|M
IDA|Idaho Falls Regional Airport|Idaho Falls|Idaho|US|43.5146|-112.0710|M
IDR|Devi Ahilya Bai Holkar International Airport|Indore|Madhya Pradesh|IN|22.7214|75.8005|L
IEG|Zielona Góra-Babimost Airport|Nowe Kramsko|Lubusz Voivodeship|PL|52.1385|15.7986|M
IFJ|Ísafjörður Airport|Ísafjörður|Westfjords|IS|66.0581|-23.1353|M
IFN|Isfahan Shahid Beheshti International Airport|Isfahan|Isfahan Province|IR|32.7551|51.8839|L
IGA|Inagua Airport|Matthew Town|Inagua|BS|20.9750|-73.6669|M
IGD|Iğdır Airport|Iğdır|Iğdır Province|TR|39.9766|43.8766|M
IGR|Cataratas Del Iguazú International Airport|Puerto Iguazu|Misiones Province|AR|-25.7373|-54.4734|M
IGT|Magas Airport|Sunzha|Republic of Ingushetia|RU|43.3233|45.0126|M
IGU|Cataratas International Airport|Foz do Iguaçu|Paraná|BR|-25.5942|-54.4894|L
IJK|Izhevsk Airport|Izhevsk|Udmurt Republic|RU|56.8345|53.4622|M
IKA|Imam Khomeini International Airport|Tehran|Tehran Province|IR|35.4161|51.1522|L
IKG|Karakol International Airport|Karakol|Issyk Kul Region|KG|42.5081|78.4078|M
IKI|Iki Airport|Iki|Nagasaki Prefecture|JP|33.7490|129.7850|M
IKS|Tiksi Airport|Tiksi|Sakha (Yakutia) Republic|RU|71.6977|128.9030|M
IKT|Irkutsk International Airport|Irkutsk|Irkutsk Oblast|RU|52.2667|104.3956|L
IKU|Issyk-Kul International Airport|Tamchy|Issyk Kul Region|KG|42.5856|76.7012|L
ILD|Lleida-Alguaire Airport|Lleida|Catalonia|ES|41.7282|0.5350|M
ILG|Wilmington Airport|Wilmington|Delaware|US|39.6787|-75.6065|M
ILI|Iliamna Airport|Iliamna|Alaska|US|59.7544|-154.9110|M
ILM|Wilmington International Airport|Wilmington|North Carolina|US|34.2723|-77.9051|M
ILO|Iloilo International Airport|Cabatuan|Iloilo Province|PH|10.8330|122.4934|L
ILP|Île des Pins Airport|Île des Pins|Province Sud|NC|-22.5889|167.4560|M
ILQ|General Jorge Fernandez Maldon Airport|Ilo|Moquegua Region|PE|-17.6950|-71.3440|M
ILR|General Tunde Idiagbon International Airport|Ilorin/Ogbomosho|Kwara State|NG|8.4402|4.4939|L
ILS|Ilopango International Airport|San Salvador|San Salvador Department|SV|13.6995|-89.1199|M
ILY|Islay Airport|Isle of Islay, Argyll and Bute|Scotland|GB|55.6827|-6.2575|M
IMF|Bir Tikendrajit International Airport|Imphal|Manipur|IN|24.7600|93.8967|L
IMP|Prefeito Renato Moreira Airport|Imperatriz|Maranhão|BR|-5.5313|-47.4600|M
IMT|Ford Airport|Kingsford|Michigan|US|45.8191|-88.1146|M
INC|Yinchuan Hedong International Airport|Yinchuan|Ningxia Autonomous Region|CN|38.3228|106.3932|L
IND|Indianapolis International Airport|Indianapolis|Indiana|US|39.7173|-86.2944|L
INH|Inhambane Airport|Inhambane|Inhambane Province|MZ|-23.8764|35.4085|M
INI|Niš Constantine the Great Airport|Niš|Nišava District|RS|43.3365|21.8562|L
INL|Falls International Airport|International Falls|Minnesota|US|48.5662|-93.4031|M
INN|Innsbruck Airport|Innsbruck|Tyrol|AT|47.2602|11.3440|L
INU|Nauru International Airport|Yaren|Yaren|NR|-0.5479|166.9195|M
INV|Inverness Airport|Inverness, Highland|Scotland|GB|57.5425|-4.0475|M
INZ|In Salah Airport|In Salah|In Salah Province|DZ|27.2510|2.5120|M
IOA|Ioannina King Pyrrhus National Airport|Ioannina|Epirus|GR|39.6964|20.8225|M
IOM|Isle of Man Airport|Castletown, Rushen||IM|54.0831|-4.6239|L
IOS|Bahia - Jorge Amado Airport|Ilhéus|Bahia|BR|-14.8159|-39.0335|M
IPC|Mataveri International Airport|Isla De Pascua|Valparaíso Region|CL|-27.1654|-109.4210|L
IPH|Sultan Azlan Shah Airport|Ipoh|Perak|MY|4.5673|101.0916|L
IPI|San Luis Airport|Ipiales|Nariño Department|CO|0.8619|-77.6718|M
IPL|Imperial County Airport|Imperial|California|US|32.8354|-115.5740|M
IPN|Usiminas Airport|Ipatinga|Minas Gerais|BR|-19.4707|-42.4876|M
IPT|Williamsport Regional Airport|Williamsport|Pennsylvania|US|41.2421|-76.9224|M
IQM|Qiemo Yudu Airport|Qiemo|Xinjiang Autonomous Region|CN|38.2345|85.4655|M
IQN|Qingyang Xifeng Airport|Qingyang (Xifeng)|Gansu Province|CN|35.8026|107.5989|M
IQQ|Diego Aracena International Airport|Iquique|Tarapacá Region|CL|-20.5363|-70.1814|L
IQT|Coronel FAP Francisco Secada Vignetta International Airport|Iquitos|Loreto Region|PE|-3.7847|-73.3088|L
IRG|Lockhart River Airport|Lockhart River|Queensland|AU|-12.7869|143.3050|M
IRJ|Capitan V A Almonacid Airport|La Rioja|La Rioja Province|AR|-29.3816|-66.7958|M
IRK|Kirksville Regional Airport|Kirksville|Missouri|US|40.0935|-92.5449|M
IRP|Matari Airport|Isiro|Haut-Uélé Province|CD|2.8276|27.5883|M
ISA|Mount Isa Airport|Mount Isa|Queensland|AU|-20.6664|139.4885|M
ISB|Islamabad International Airport|Attock|Punjab|PK|33.5490|72.8257|L
ISE|Süleyman Demirel International Airport|Isparta|Isparta Province|TR|37.8554|30.3684|M
ISG|New Ishigaki Airport|Ishigaki|Okinawa Prefecture|JP|24.3964|124.2450|M
ISK|Nashik International Airport|Nashik|Maharashtra|IN|20.1191|73.9129|L
ISP|Long Island MacArthur Airport|Islip|New York|US|40.7963|-73.1017|M
ISU|Jalal Talabani International Airport|Sulaymaniyah|As-Sulaymaniyyah Governorate|IQ|35.5605|45.3151|M
ITB|Itaituba Airport|Itaituba|Pará|BR|-4.2421|-56.0007|M
ITH|Ithaca Tompkins Regional Airport|Ithaca|New York|US|42.4910|-76.4584|M
ITM|Osaka Itami International Airport|Osaka|Ōsaka Prefecture|JP|34.7809|135.4408|L
ITO|Hilo International Airport|Hilo|Hawaii|US|19.7214|-155.0454|M
IUE|Niue International Airport|Alofi||NU|-19.0801|-169.9235|M
IVC|Invercargill Airport|Invercargill|Southland Region|NZ|-46.4124|168.3130|M
IVL|Ivalo Airport|Ivalo|Lapland Region|FI|68.6073|27.4053|L
IWA|Ivanovo South Airport|Ivanovo|Ivanovo Oblast|RU|56.9394|40.9408|M
IWJ|Iwami Airport|Masuda|Shimane Prefecture|JP|34.6764|131.7900|M
IWK|Iwakuni Kintaikyo Airport|Iwakuni|Yamaguchi Prefecture|JP|34.1463|132.2472|M
IXA|Agartala - Maharaja Bir Bikram Airport|Agartala|Tripura|IN|23.8870|91.2404|M
IXB|Bagdogra Airport|Siliguri|West Bengal|IN|26.6812|88.3286|L
IXC|Shaheed Bhagat Singh International Airport|Chandigarh|Chandigarh|IN|30.6735|76.7885|L
IXD|Prayagraj Airport|Allahabad|Uttar Pradesh|IN|25.4401|81.7339|M
IXE|Mangaluru International Airport|Mangaluru|Karnataka|IN|12.9547|74.8868|L
IXG|Belagavi Airport|Belgaum|Karnataka|IN|15.8593|74.6183|M
IXI|Lilabari North Lakhimpur Airport|Lilabari|Assam|IN|27.2957|94.0973|M
IXJ|Jammu Airport|Jammu|Jammu and Kashmir|IN|32.6888|74.8382|M
IXK|Keshod Airport|Keshod|Gujarat|IN|21.3171|70.2704|M
IXL|Leh Kushok Bakula Rimpochee Airport|Leh|Ladakh|IN|34.1359|77.5465|M
IXM|Madurai Airport|Madurai|Tamil Nadu|IN|9.8345|78.0934|M
IXP|Pathankot Airport|Pathankot|Punjab|IN|32.2336|75.6344|M
IXR|Birsa Munda Airport|Ranchi|Jharkhand|IN|23.3143|85.3217|M
IXS|Silchar Airport|Silchar|Assam|IN|24.9129|92.9787|M
IXU|Aurangabad Airport|Aurangabad|Maharashtra|IN|19.8629|75.3963|M
IXY|Kandla Airport|Kandla|Gujarat|IN|23.1127|70.1003|M
IXZ|Veer Savarkar International Airport / INS Utkrosh|Port Blair|Andaman and Nicobar Islands|IN|11.6402|92.7290|L
IZA|Presidente Itamar Franco Airport|Juiz de Fora|Minas Gerais|BR|-21.5131|-43.1731|M
IZO|Izumo Enmusubi Airport|Izumo|Shimane Prefecture|JP|35.4136|132.8900|M
IZT|General Antonio Cárdenas Rodríguez National Airport / Ixtepec Air Base|Ixtepec|Oaxaca|MX|16.4460|-95.0937|M
JAC|Jackson Hole Airport|Jackson|Wyoming|US|43.6073|-110.7380|M
JAE|Shumba Airport|Jaén|Cajamarca Region|PE|-5.5925|-78.7740|M
JAF|Jaffna International Airport|Jaffna|Northern Province|LK|9.7923|80.0701|L
JAI|Jaipur International Airport|Jaipur|Rajasthan|IN|26.8242|75.8122|L
JAN|Jackson-Medgar Wiley Evers International Airport|Jackson|Mississippi|US|32.3112|-90.0759|M
JAU|Francisco Carle Airport|Jauja|Junín Region|PE|-11.7831|-75.4734|M
JAV|Ilulissat Airport|Ilulissat|Avannaata Municipality|GL|69.2432|-51.0571|M
JAX|Jacksonville International Airport|Jacksonville|Florida|US|30.4925|-81.6878|L
JBQ|La Isabela International Airport|La Isabela|Distrito Nacional|DO|18.5725|-69.9856|M
JBR|Jonesboro Municipal Airport|Jonesboro|Arkansas|US|35.8317|-90.6464|M
JCL|České Budějovice South Bohemian Airport|České Budějovice|South Bohemian Region|CZ|48.9482|14.4283|L
JDF|Francisco de Assis Airport|Juiz de Fora|Minas Gerais|BR|-21.7915|-43.3861|M
JDH|Jodhpur Airport|Jodhpur|Rajasthan|IN|26.2511|73.0489|M
JDZ|Jingdezhen Luojia Airport|Jingdezhen|Jiangxi Province|CN|29.3386|117.1760|M
JEE|Jérémie Airport|Carrefour Sanon|Grande'Anse Department|HT|18.6631|-74.1703|M
JEG|Aasiaat Airport|Aasiaat|Qeqertalik Municipality|GL|68.7218|-52.7847|M
JER|Jersey Airport|St. Peter||JE|49.2079|-2.1955|M
JGA|Jamnagar Airport|Jamnagar|Gujarat|IN|22.4655|70.0126|M
JGD|Daxing'anling Elunchun Airport|Jiagedaqi|Heilongjiang Province|CN|50.3714|124.1175|M
JGN|Jiayuguan International Airport|Jiayuguan|Gansu Province|CN|39.8591|98.3393|L
JGS|Jinggangshan Airport|Ji'an|Jiangxi Province|CN|26.8569|114.7370|M
JHB|Senai International Airport|Johor Bahru|Johor|MY|1.6413|103.6700|L
JHG|Xishuangbanna Gasa International Airport|Jinghong (Gasa)|Yunnan Province|CN|21.9746|100.7622|L
JHM|Kapalua Airport|Lahaina|Hawaii|US|20.9629|-156.6730|M
JHS|Sisimiut Airport|Sisimiut|Qeqqata Municipality|GL|66.9513|-53.7293|M
JIB|Djibouti-Ambouli Airport|Djibouti City|Djibouti Region|DJ|11.5473|43.1595|L
JIC|Jinchang Jinchuan Airport|Jinchang|Gansu Province|CN|38.5422|102.3483|M
JIJ|Gerad Wilwal International Airport|Jijiga|Somali Region|ET|9.3319|42.9118|L
JIM|Jimma Airport|Jimma|Oromia Region|ET|7.6661|36.8166|M
JIQ|Qianjiang Wulingshan Airport|Qianjiang|Chongqing Municipality|CN|29.5133|108.8311|M
JJD|Comandante Ariston Pessoa Airport|Cruz|Ceará|BR|-2.9064|-40.3573|M
JJN|Quanzhou Jinjiang International Airport|Quanzhou|Fujian Province|CN|24.7959|118.5886|L
JJU|Qaqortoq Airport|Qaqortoq|Kujalleq Municipality|GL|60.7638|-46.0650|M
JKG|Jönköping Airport|Jönköping|Jönköpings län|SE|57.7576|14.0687|M
JKH|Chios Island National Airport|Chios Island|North Aegean|GR|38.3432|26.1406|M
JKR|Janakpur Airport|Janakpur|Madhesh Province|NP|26.7088|85.9224|M
JLN|Joplin Regional Airport|Joplin|Missouri|US|37.1518|-94.4983|M
JLR|Jabalpur Airport|Jabalpur|Madhya Pradesh|IN|23.1778|80.0520|M
JMJ|Lancang Jingmai Airport|Pu'er (Lancang)|Yunnan Province|CN|22.4177|99.7840|M
JMS|Jamestown Regional Airport|Jamestown|North Dakota|US|46.9297|-98.6782|M
JMU|Jiamusi Songjiang International Airport|Jiamusi|Heilongjiang Province|CN|46.8428|130.4643|M
JNG|Jining Da'an Airport|Jining|Shandong Province|CN|35.6474|116.7433|M
JNH|Jiaxing Nanhu Airport|Xiuzhou, Hangzhou|Zhejiang Province|CN|30.6981|120.6631|M
JNU|Juneau International Airport|Juneau|Alaska|US|58.3549|-134.5744|M
JNZ|Jinzhou Bay Airport|Jinzhou (Linghai)|Liaoning Province|CN|40.9360|121.2771|M
JOE|Joensuu Airport|Joensuu|North Karelia Region|FI|62.6588|29.6194|M
JOG|Adisutjipto International Airport|Yogyakarta|Yogyakarta|ID|-7.7882|110.4320|M
JOI|Lauro Carneiro de Loyola Airport|Joinville|Santa Catarina|BR|-26.2245|-48.7974|M
JOL|Jolo Airport|Jolo|Sulu Province|PH|6.0537|121.0110|M
JOS|Yakubu Gowon Airport|Jos|Plateau State|NG|9.6398|8.8691|M
JPA|Presidente Castro Pinto International Airport|João Pessoa|Paraíba|BR|-7.1487|-34.9506|L
JRH|Jorhat Airport|Jorhat|Assam|IN|26.7305|94.1754|M
JRO|Kilimanjaro International Airport|Arusha|Arusha Region|TZ|-3.4270|37.0735|L
JSH|Sitia Airport|Crete Island|Crete|GR|35.2161|26.1013|M
JSI|Skiathos Island National Airport|Skiathos|Thessaly|GR|39.1771|23.5037|M
JSJ|Jiansanjiang Shidi Airport|Jiansanjiang|Heilongjiang Province|CN|47.1082|132.6579|M
JSR|Jessore Airport|Jashore (Jessore)|Khulna Division|BD|23.1838|89.1608|M
JST|John Murtha Johnstown Cambria County Airport|Johnstown|Pennsylvania|US|40.3161|-78.8339|M
JTC|Bauru/Arealva–Moussa Nakhal Tobias State Airport|Bauru|São Paulo|BR|-22.1608|-49.0703|M
JUB|Juba International Airport|Juba|Central Equatoria State|SS|4.8720|31.6011|L
JUJ|Gobernador Horacio Guzman International Airport|San Salvador de Jujuy|Jujuy Province|AR|-24.3928|-65.0978|L
JUL|Inca Manco Capac International Airport|Juliaca|Puno Region|PE|-15.4677|-70.1565|L
JUZ|Quzhou Airport|Quzhou (Kezheng)|Zhejiang Province|CN|28.9661|118.8988|M
JXA|Jixi Xingkaihu Airport|Jixi|Heilongjiang Province|CN|45.2930|131.1930|M
JYV|Jyväskylä Airport|Jyväskylän Maalaiskunta|Central Finland Region|FI|62.3995|25.6783|M
JZH|Jiuzhai Huanglong Airport|Ngawa (Songpan)|Sichuan Province|CN|32.8533|103.6822|M
KAB|Kariba Airport|Kariba|Mashonaland West Province|ZW|-16.5198|28.8850|M
KAC|Qamishli International Airport|Qamishli|Al-Hasakah Governorate|SY|37.0206|41.1914|M
KAD|Kaduna International Airport|Kaduna|Kaduna State|NG|10.6960|7.3201|L
KAI|Kaieteur Airport|Kaieteur Falls|Potaro-Siparuni|GY|5.1773|-59.4890|M
KAJ|Kajaani Airport|Kajaani|Kainuu Region|FI|64.2855|27.6924|M
KAN|Mallam Aminu Kano International Airport|Kano|Kano State|NG|12.0456|8.5236|L
KAO|Kuusamo Airport|Kuusamo|North Ostrobothnia Region|FI|65.9876|29.2394|M
KAT|Kaitaia Airport|Awanui|Northland Region|NZ|-35.0698|173.2871|M
KAW|Kawthoung Airport|Kawthoung|Tanintharyi Region|MM|10.0493|98.5380|M
KBL|Kabul International Airport|Kabul|Kabul Province|AF|34.5659|69.2123|L
KBR|Sultan Ismail Petra Airport|Kota Baharu|Kelantan|MY|6.1669|102.2930|M
KBV|Krabi International Airport|Krabi|Krabi Province|TH|8.0956|98.9890|L
KCH|Kuching International Airport|Kuching|Sarawak|MY|1.4874|110.3529|L
KCM|Kahramanmaraş Airport|Kahramanmaraş|Kahramanmaraş Province|TR|37.5388|36.9535|M
KCT|Koggala Airport|Galle|Southern Province|LK|5.9937|80.3203|M
KCY|Krasnoyarsk Cheremshanka Airport|Krasnoyarsk|Krasnoyarsk Krai|RU|56.1776|92.5459|M
KCZ|Kochi Ryoma Airport|Nankoku|Kōchi Prefecture|JP|33.5452|133.6702|L
KDH|Ahmad Shah Baba International Airport|Kandahar|Kandahar Province|AF|31.5058|65.8480|L
KDL|Kärdla Airport|Kärdla|Hiiu County|EE|58.9908|22.8307|M
KDM|Kaadedhdhoo Airport|Huvadhu Atoll|Gaafu Dhaalu Atoll|MV|0.4881|72.9969|M
KDO|Kadhdhoo Airport|Kadhdhoo|Laamu Atoll|MV|1.8592|73.5219|M
KDU|Skardu International Airport|Skardu|Gilgit-Baltistan|PK|35.3387|75.5386|L
KEJ|Alexei Leonov Kemerovo International Airport|Kemerovo|Kemerovo Oblast|RU|55.2701|86.1072|L
KEM|Kemi-Tornio Airport|Kemi / Tornio|Lapland Region|FI|65.7787|24.5821|M
KEP|Nepalgunj Airport|Nepalgunj|Lumbini Province|NP|28.1036|81.6670|M
KER|Ayatollah Hashemi Rafsanjani International Airport|Kerman|Kerman Province|IR|30.2713|56.9497|L
KET|Kengtung Airport|Kengtung|Shan State|MM|21.3016|99.6360|M
KFS|Kastamonu Airport|Kastamonu|Kastamonu Province|TR|41.3142|33.7958|M
KGA|Kananga Airport|Kananga|Kasaï-Central Province|CD|-5.9001|22.4692|M
KGD|Khrabrovo Airport|Kaliningrad|Kaliningrad Oblast|RU|54.8916|20.5986|L
KGF|Sary-Arka Airport|Karaganda|Karaganda Region|KZ|49.6708|73.3344|L
KGI|Kalgoorlie Boulder Airport|Broadwood|Western Australia|AU|-30.7915|121.4646|M
KGL|Kigali International Airport|Kigali|City of Kigali|RW|-1.9686|30.1395|L
KGP|Kogalym International Airport|Kogalym|Khanty-Mansi Autonomous Okrug|RU|62.1904|74.5338|M
KGS|Kos International Airport "Ippokratis"|Kos Island|South Aegean|GR|36.7945|27.0911|L
KGT|Kangding Airport|Garzê (Kangding)|Sichuan Province|CN|30.1425|101.7387|M
KHG|Kashgar Laining International Airport|Kashgar|Xinjiang Autonomous Region|CN|39.5423|76.0202|L
KHH|Kaohsiung International Airport|Kaohsiung (Xiaogang)|Kaohsiung City|TW|22.5771|120.3500|L
KHI|Jinnah International Airport|Karachi|Sindh|PK|24.9065|67.1608|L
KHK|Khark Airport|Khark|Bushehr Province|IR|29.2605|50.3222|M
KHN|Nanchang Changbei International Airport|Nanchang|Jiangxi Province|CN|28.8648|115.9027|L
KHS|Khasab Airport|Khasab|Musandam Governorate|OM|26.1710|56.2406|M
KHT|Khost International Airport|Khost|Khost Province|AF|33.2846|69.8073|M
KHV|Khabarovsk Novy Airport|Khabarovsk|Khabarovsk Krai|RU|48.5283|135.1886|M
KHX|Savannah Airstrip|Kihihi|Western Region|UG|-0.7165|29.6997|M
KIH|Kish International Airport|Kish Island|Hormozgan Province|IR|26.5254|53.9805|L
KIJ|Niigata Airport|Niigata|Niigata Prefecture|JP|37.9542|139.1122|L
KIK|Kirkuk International Airport|Kirkuk|Kirkuk Governorate|IQ|35.4695|44.3489|L
KIM|Kimberley Airport|Kimberley|Northern Cape|ZA|-28.8054|24.7649|L
KIN|Norman Manley International Airport|Kingston|Kingston Parish|JM|17.9357|-76.7875|L
KIR|Kerry Airport|Farranfore|County Kerry|IE|52.1809|-9.5238|M
KIS|Kisumu International Airport|Kisumu|Kisumu County|KE|-0.0861|34.7289|L
KJA|Krasnoyarsk International Airport|Krasnoyarsk|Krasnoyarsk Krai|RU|56.1757|92.4858|L
KJB|Kurnool Airport|Orvakal|Andhra Pradesh|IN|15.7163|78.1692|M
KJH|Kaili Huangping Airport|Kaili (Huangping)|Guizhou Province|CN|26.9720|107.9880|M
KJI|Burqin Kanas Airport|Burqin|Xinjiang Autonomous Region|CN|48.2223|86.9959|M
KJT|Kertajati International Airport|Kertajati|Jawa Barat (West Java)|ID|-6.6474|108.1656|M
KKC|Khon Kaen Airport|Khon Kaen|Khon Kaen Province|TH|16.4666|102.7840|M
KKE|Kerikeri Airport|Kerikeri|Northland Region|NZ|-35.2591|173.9133|M
KKJ|Kitakyushu Airport|Kitakyushu|Fukuoka Prefecture|JP|33.8459|131.0350|L
KKN|Kirkenes Airport, Høybuktmoen|Kirkenes|Finnmark|NO|69.7258|29.8913|M
KKR|Kaukura Airport|Raitahiti||PF|-15.6633|-146.8850|M
KKS|Kashan Airport|Kashan|Isfahan Province|IR|33.8953|51.5770|M
KKW|Kikwit Airport|Kikwit|Kwilu Province|CD|-5.0358|18.7856|M
KKX|Kikai Airport|Kikai|Kagoshima Prefecture|JP|28.3213|129.9280|M
KLH|Kolhapur Airport|Kolhapur|Maharashtra|IN|16.6647|74.2894|M
KLO|Kalibo International Airport|Kalibo|Aklan Province|PH|11.6794|122.3760|L
KLR|Kalmar Airport|Kalmar|Kalmar län|SE|56.6855|16.2876|M
KLU|Klagenfurt Airport|Klagenfurt am Wörthersee|Carinthia|AT|46.6425|14.3377|L
KLV|Karlovy Vary Airport|Karlovy Vary|Karlovy Vary Region|CZ|50.2030|12.9150|L
KLW|Klawock Airport|Klawock|Alaska|US|55.5792|-133.0760|M
KLX|Kalamata Airport|Kalamata|Peloponnese|GR|37.0683|22.0255|M
KMA|Kerema Airport|Kerema|Gulf Province|PG|-7.9636|145.7710|M
KMC|King Khaled Military City Airport|King Khaled Military City|Ash Sharqiyah Region|SA|27.9009|45.5282|M
KME|Kamembe Airport|Kamembe|Western Province|RW|-2.4622|28.9079|M
KMG|Kunming Changshui International Airport|Kunming|Yunnan Province|CN|25.1103|102.9367|L
KMI|Miyazaki Airport|Miyazaki|Miyazaki Prefecture|JP|31.8772|131.4490|L
KMJ|Kumamoto Airport|Kumamoto|Kumamoto Prefecture|JP|32.8373|130.8550|L
KMQ|Komatsu Airport / JASDF Komatsu Air Base|Kanazawa|Ishikawa Prefecture|JP|36.3934|136.4069|L
KMS|Prempeh I International Airport|Kumasi|Ashanti Region|GH|6.7146|-1.5908|L
KMW|Kostroma Sokerkino Airport|Kostroma|Kostroma Oblast|RU|57.7969|41.0194|M
KND|Kindu Airport|Kindu|Maniema Province|CD|-2.9192|25.9154|M
KNG|Utarom Airport|Kaimana|Papua Barat (West Papua)|ID|-3.6446|133.6951|M
KNH|Kinmen Airport|Shang-I|Kinmen County|TW|24.4279|118.3590|M
KNO|Kualanamu International Airport|Beringin|Sumatera Utara (North Sumatra)|ID|3.6378|98.8706|L
KNQ|Koné Airport|Koné|Province Nord|NC|-21.0536|164.8388|M
KNU|Kanpur Airport|Kanpur|Uttar Pradesh|IN|26.4043|80.4101|M
KNX|East Kimberley Regional (Kununurra) Airport|Kununurra|Western Australia|AU|-15.7781|128.7080|M
KOA|Ellison Onizuka Kona International Airport at Keāhole|Kailua-Kona|Hawaii|US|19.7388|-156.0456|L
KOE|El Tari Airport|Kupang|Nusa Tenggara Timur (East Nusa Tenggara)|ID|-10.1716|123.6710|M
KOI|Kirkwall Airport|Kirkwall, Orkney Islands|Scotland|GB|58.9579|-2.9051|M
KOJ|Kagoshima Airport|Kagoshima|Kagoshima Prefecture|JP|31.8034|130.7190|L
KOK|Kokkola-Pietarsaari Airport|Kokkola / Kruunupyy|Central Ostrobothnia Region|FI|63.7212|23.1431|M
KOP|Nakhon Phanom Airport|Nakhon Phanom|Nakhon Phanom Province|TH|17.3838|104.6430|M
KOS|Sihanouk International Airport|Preah Sihanouk|Preah Sihanouk province|KH|10.5706|103.6321|L
KOV|Kokshetau International Airport|Kokshetau|Akmola Region|KZ|53.3291|69.5946|L
KPO|Pohang Airport (G-815/K-3)|Pohang|Gyeongsangbuk-do (North Gyeongsang Province)|KR|35.9880|129.4204|M
KPW|Keperveem Airport|Keperveem|Chukotka Autonomous Okrug|RU|67.8450|166.1400|M
KQH|Kishangarh Airport Ajmer|Ajmer (Kishangarh)|Rajasthan|IN|26.5910|74.8130|M
KQT|Bokhtar International Airport|Bokhtar|Khatlon Region|TJ|37.8663|68.8645|L
KRF|Kramfors-Sollefteå Höga Kusten Airport|Nyland|Västernorrlands län|SE|63.0486|17.7689|M
KRL|Korla Licheng Airport|Korla|Xinjiang Autonomous Region|CN|41.6150|86.1408|M
KRN|Kiruna Airport|Kiruna|Norrbottena län|SE|67.8220|20.3368|L
KRO|Kurgan Airport|Kurgan|Kurgan Oblast|RU|55.4753|65.4156|M
KRP|Midtjyllands Airport / Air Base Karup|Karup|Central Jutland|DK|56.2971|9.1043|M
KRR|Krasnodar Pashkovsky International Airport|Krasnodar|Krasnodar Krai|RU|45.0345|39.1742|L
KRS|Kristiansand Airport|Kristiansand(Kjevik)|Agder|NO|58.2042|8.0854|L
KRT|Khartoum International Airport|Khartoum|Khartoum State|SD|15.5895|32.5532|L
KRW|Turkmenbaşy International Airport|Turkmenbaşy|Balkan Region|TM|40.0628|53.0051|M
KSA|Kosrae International Airport|Okat|Kosrae State|FM|5.3570|162.9580|L
KSC|Košice International Airport|Košice|Košice Region|SK|48.6631|21.2411|M
KSD|Karlstad Airport|Karlstad|Värmlanda län|SE|59.4447|13.3374|M
KSF|Kassel Airport|Calden|Hesse|DE|51.4184|9.3916|L
KSH|Shahid Ashrafi Esfahani Airport|Kermanshah|Kermanshah Province|IR|34.3459|47.1581|M
KSL|Kassala Airport|Kassala|Kassala State|SD|15.3875|36.3288|M
KSN|Kostanay International Airport|Kostanay|Kostanay Region|KZ|53.2069|63.5503|L
KSU|Kristiansund Airport, Kvernberget|Kvernberget|Møre og Romsdal|NO|63.1118|7.8245|M
KSY|Kars Airport|Kars|Kars Province|TR|40.5622|43.1150|M
KSZ|Kotlas Airport|Kotlas|Arkhangelsk Oblast|RU|61.2358|46.6975|M
KTA|Karratha Airport|Karratha|Western Australia|AU|-20.7122|116.7730|M
KTD|Kitadaito Airport|Kitadaitōjima|Okinawa Prefecture|JP|25.9447|131.3270|M
KTG|Rahadi Osman Airport|Ketapang|Kalimantan Barat (West Kalimantan)|ID|-1.8172|109.9635|M
KTI|Techo International Airport|Phnom Penh (Boeng Khyang)|Kandal province|KH|11.3600|104.9213|L
KTN|Ketchikan International Airport|Ketchikan|Alaska|US|55.3556|-131.7140|M
KTP|Tinson Pen Airport|Tinson Pen|Saint Andrew Parish|JM|17.9886|-76.8238|M
KTT|Kittilä International Airport|Kittilä|Lapland Region|FI|67.7010|24.8468|L
KTW|Katowice Wojciech Korfanty International Airport|Katowice|Silesian Voivodeship|PL|50.4760|19.0807|L
KUA|Kuantan Airport|Kuantan|Pahang|MY|3.7754|103.2090|M
KUF|Kurumoch International Airport|Samara|Samara Oblast|RU|53.5049|50.1643|L
KUH|Kushiro Airport|Kushiro|Hokkaidō Prefecture|JP|43.0410|144.1930|M
KUM|Yakushima Airport|Yakushima|Kagoshima Prefecture|JP|30.3856|130.6590|M
KUN|Kaunas International Airport|Kaunas|Kaunas County|LT|54.9640|24.0858|L
KUO|Kuopio Airport|Kuopio / Siilinjärvi|Northern Savonia Region|FI|63.0071|27.7978|L
KUS|Kulusuk Airport|Kulusuk|Sermersooq Municipality|GL|65.5736|-37.1236|M
KUT|David the Builder Kutaisi International Airport|Kopitnari|Imereti|GE|42.1774|42.4854|L
KUU|Kullu Manali Airport|Bhuntar|Himachal Pradesh|IN|31.8767|77.1544|M
KUV|Gunsan Airport / Gunsan Air Base|Gunsan|Jeonbuk Teukbyeoljachi-do (North Jeolla Special Self-Governing Province)|KR|35.9038|126.6160|M
KVA|Kavala Alexander the Great International Airport|Kavala|Eastern Macedonia and Thrace|GR|40.9133|24.6192|L
KVG|Kavieng Airport|Kavieng|New Ireland Province|PG|-2.5794|150.8080|M
KVO|Morava Airport|Kraljevo|Raška District|RS|43.8175|20.5867|M
KVX|Pobedilovo Airport|Kirov|Kirov Oblast|RU|58.5039|49.3478|M
KWA|Bucholz Army Air Field|Kwajalein|Kwajalein|MH|8.7201|167.7320|M
KWE|Guiyang Longdongbao International Airport|Guiyang (Nanming)|Guizhou Province|CN|26.5418|106.8040|L
KWI|Kuwait International Airport|Kuwait City|Al Farwaniyah Governorate|KW|29.2245|47.9698|L
KWJ|Gwangju Airport|Gwangju|Gwangju-gwangyeoksi (Gwangju Metropolitan City)|KR|35.1232|126.8054|M
KWL|Guilin Liangjiang International Airport|Guilin (Lingui)|Guangxi Autonomous Region|CN|25.2198|110.0396|L
KWM|Kowanyama Airport|Kowanyama|Queensland|AU|-15.4854|141.7526|M
KWZ|Kolwezi Airport|Kolwezi|Lualaba Province|CD|-10.7659|25.5057|M
KXB|Sangia Nibandera Airport|Kolaka|Sulawesi Tenggara (Southeast Sulawesi)|ID|-4.3382|121.5240|M
KXK|Komsomolsk-on-Amur Airport|Komsomolsk-on-Amur|Khabarovsk Krai|RU|50.4090|136.9340|M
KYA|Konya Airport|Konya|Konya Province|TR|37.9790|32.5619|L
KYD|Lanyu Airport|Orchid Island|Taitung County|TW|22.0270|121.5350|M
KYP|Kyaukpyu Airport|Kyaukpyu|Rakhine State|MM|19.4264|93.5348|M
KYS|Kayes Dag Dag Airport|Kayes|Kayes Region|ML|14.4825|-11.3993|M
KYZ|Kyzyl Airport|Kyzyl|Tuva Republic|RU|51.6694|94.4006|M
KZI|Kozani National Airport Filippos|Kozani|Western Macedonia|GR|40.2861|21.8408|M
KZN|Kazan International Airport|Kazan|Republic of Tatarstan|RU|55.6062|49.2787|L
KZO|Korkyt Ata International Airport|Kyzylorda|Kyzylorda Region|KZ|44.7069|65.5925|L
KZR|Zafer Airport|Altıntaş|Kütahya Province|TR|39.1111|30.1304|M
LAD|Quatro de Fevereiro International Airport|Luanda|Luanda Province|AO|-8.8584|13.2312|L
LAE|Nadzab Tomodachi International Airport|Lae|Morobe Province|PG|-6.5680|146.7265|L
LAF|Purdue University Airport|West Lafayette|Indiana|US|40.4129|-86.9394|M
LAJ|Lages Airport|Lages|Santa Catarina|BR|-27.7821|-50.2815|M
LAL|Lakeland Linder International Airport|Lakeland|Florida|US|27.9893|-82.0207|M
LAN|Capital Region International Airport|Lansing|Michigan|US|42.7776|-84.5857|M
LAO|Laoag International Airport|Laoag City|Ilocos Norte Province|PH|18.1751|120.5310|L
LAP|Manuel Márquez de León International Airport|La Paz|Baja California Sur|MX|24.0723|-110.3627|M
LAQ|Al Abraq International Airport|Al Albraq|Al Jabal al Akhdar District|LY|32.7890|21.9549|L
LAR|Laramie Regional Airport|Laramie|Wyoming|US|41.3121|-105.6750|M
LAU|Manda Airport|Lamu|Lamu County|KE|-2.2524|40.9129|M
LAW|Lawton Fort Sill Regional Airport|Lawton|Oklahoma|US|34.5677|-98.4166|M
LBA|Leeds Bradford Airport|Leeds, West Yorkshire|England|GB|53.8659|-1.6606|L
LBB|Lubbock Preston Smith International Airport|Lubbock|Texas|US|33.6636|-101.8230|M
LBC|Lübeck Blankensee Airport|Lübeck|Schleswig-Holstein|DE|53.8054|10.7192|M
LBD|Khujand International Airport|Khujand|Sughd Region|TJ|40.2154|69.6947|L
LBE|Arnold Palmer Regional Airport|Latrobe|Pennsylvania|US|40.2759|-79.4048|M
LBF|North Platte Regional Airport Lee Bird Field|North Platte|Nebraska|US|41.1262|-100.6840|M
LBL|Liberal Mid-America Regional Airport|Liberal|Kansas|US|37.0442|-100.9600|M
LBS|Labasa Airport|Labasa|Northern Division|FJ|-16.4667|179.3400|M
LBU|Labuan Airport|Labuan|Labuan (Federal Territory)|MY|5.3017|115.2483|M
LBV|Libreville Leon M'ba International Airport|Libreville|Estuaire Province|GA|0.4590|9.4121|L
LCE|Golosón International Airport|La Ceiba|Atlántida Department|HN|15.7425|-86.8530|M
LCG|A Coruña Airport|Culleredo|Galicia|ES|43.3021|-8.3773|M
LCH|Lake Charles Regional Airport|Lake Charles|Louisiana|US|30.1261|-93.2233|M
LCJ|Łódź Władysław Reymont Airport|Łódź|Łódź Voivodeship|PL|51.7219|19.3981|L
LCK|Rickenbacker International Airport|Columbus|Ohio|US|39.8138|-82.9278|M
LCX|Liancheng Guanzhishan Airport|Longyan (Liancheng)|Fujian Province|CN|25.6759|116.7459|M
LCY|London City Airport|London|England|GB|51.5053|0.0553|M
LDB|Governor José Richa Airport|Londrina|Paraná|BR|-23.3344|-51.1284|M
LDE|Tarbes-Lourdes-Pyrénées Airport|Tarbes/Lourdes/Pyrénées|Occitanie|FR|43.1787|-0.0064|M
LDS|Yichun Lindu Airport|Yichun|Heilongjiang Province|CN|47.7521|129.0191|M
LDU|Lahad Datu Airport|Lahad Datu|Sabah|MY|5.0324|118.3238|M
LDX|Saint-Laurent-du-Maroni Airport|Saint-Laurent-du-Maroni|Saint-Laurent-du-Maroni|GF|5.4819|-54.0350|M
LDY|City of Derry Airport|Derry, Derry and Strabane|Northern Ireland|GB|55.0428|-7.1611|M
LEA|Learmonth Airport|Exmouth|Western Australia|AU|-22.2352|114.0900|M
LEB|Lebanon Municipal Airport|Lebanon|New Hampshire|US|43.6261|-72.3042|M
LED|Pulkovo Airport|St. Petersburg|Saint Petersburg (city)|RU|59.8003|30.2625|L
LEI|Almería Airport|Almería|Andalucía|ES|36.8439|-2.3701|M
LEJ|Leipzig/Halle Airport|Schkeuditz|Saxony|DE|51.4207|12.2327|L
LEN|León Airport|La Virgen del Camino|Castilla y León|ES|42.5907|-5.6534|M
LET|Alfredo Vásquez Cobo International Airport|Leticia|Amazonas Department|CO|-4.1911|-69.9420|M
LEU|Pirineus - la Seu d'Urgel Airport|La Seu d'Urgell Pyrenees and Andorra|Catalonia|ES|42.3386|1.4092|M
LEX|Blue Grass Airport|Lexington|Kentucky|US|38.0351|-84.6067|M
LFM|Lamerd Airport|Lamerd|Fars Province|IR|27.3727|53.1888|M
LFQ|Linfen Yaodu Airport|Linfen (Yaodu)|Shanxi Province|CN|36.1326|111.6412|M
LFT|Lafayette Regional Airport|Lafayette|Louisiana|US|30.2053|-91.9876|M
LFW|Lomé–Tokoin International Airport|Lomé|Maritime Region|TG|6.1656|1.2545|L
LGB|Long Beach International Airport|Long Beach|California|US|33.8165|-118.1499|L
LGG|Liège Airport|Grâce-Hollogne|Liège Province|BE|50.6386|5.4439|M
LGI|Deadman's Cay Airport|Deadman's Cay|Long Island|BS|23.1790|-75.0936|M
LGK|Langkawi International Airport|Langkawi|Kedah|MY|6.3297|99.7287|L
LHE|Allama Iqbal International Airport|Lahore|Punjab|PK|31.5216|74.4036|L
LHL|Lachin International Airport|Lachin|Lacin District|AZ|39.8838|46.3631|M
LHS|Las Heras Airport|Las Heras|Santa Cruz Province|AR|-46.5385|-68.9653|M
LHW|Lanzhou Zhongchuan International Airport|Lanzhou (Yongdeng)|Gansu Province|CN|36.5152|103.6200|L
LIF|Lifou Airport|Lifou|Province des îles Loyauté|NC|-20.7746|167.2393|M
LIG|Limoges Airport|Limoges/Bellegarde|Nouvelle-Aquitaine|FR|45.8628|1.1794|M
LIH|Lihue Airport|Lihue, Kauai|Hawaii|US|21.9744|-159.3371|L
LIL|Lille Airport|Lesquin|Hauts-de-France|FR|50.5666|3.1024|L
LIN|Milano Linate Airport|Segrate (MI)|Lombardy|IT|45.4451|9.2767|L
LIO|Limón International Airport|Limón|Limón Province|CR|9.9580|-83.0220|M
LIR|Daniel Oduber Quirós International Airport|Liberia|Guanacaste Province|CR|10.5933|-85.5444|L
LIT|Bill & Hillary Clinton National Airport/Adams Field|Little Rock|Arkansas|US|34.7292|-92.2236|M
LIW|Loikaw Airport|Loikaw|Kayah State|MM|19.6915|97.2148|M
LJG|Lijiang Sanyi International Airport|Lijiang|Yunnan Province|CN|26.6775|100.2449|L
LJU|Ljubljana Jože Pučnik Airport|Zgornji Brnik|Cerklje na Gorenjskem Municipality|SI|46.2237|14.4576|L
LKL|Lakselv Airport, Banak|Lakselv|Finnmark|NO|70.0688|24.9735|M
LKN|Leknes Airport|Leknes|Nordland|NO|68.1525|13.6094|M
LKO|Chaudhary Charan Singh International Airport|Lucknow|Uttar Pradesh|IN|26.7606|80.8893|L
LLA|Luleå Airport|Luleå|Norrbottena län|SE|65.5438|22.1220|L
LLF|Yongzhou Lingling Airport|Yongzhou|Hunan Province|CN|26.3387|111.6100|M
LLV|Lüliang Dawu Airport|Lüliang|Shaanxi Province|CN|37.6833|111.1428|M
LLW|Kamuzu International Airport|Lumbadzi|Lilongwe District|MW|-13.7894|33.7810|L
LMM|Valle del Fuerte International Airport|Los Mochis|Sinaloa|MX|25.6855|-109.0812|M
LMN|Limbang Airport|Limbang|Sarawak|MY|4.8083|115.0100|M
LMP|Lampedusa Airport|Lampedusa|Sicily|IT|35.4979|12.6181|M
LNJ|Lincang Boshang Airport|Lincang|Yunnan Province|CN|23.7381|100.0250|M
LNK|Lincoln Airport|Lincoln|Nebraska|US|40.8449|-96.7618|M
LNL|Longnan Chengzhou Airport|Longnan (Cheng)|Gansu Province|CN|33.7899|105.7900|M
LNO|Leonora Airport|Leonora|Western Australia|AU|-28.8781|121.3150|M
LNS|Lancaster Airport|Lancaster|Pennsylvania|US|40.1217|-76.2961|M
LNY|Lanai Airport|Lanai City|Hawaii|US|20.7857|-156.9513|M
LNZ|Linz-Hörsching Airport|Linz|Upper Austria|AT|48.2354|14.1881|L
LOO|Laghouat - Molay Ahmed Medeghri Airport|Laghouat|Laghouat Province|DZ|33.7644|2.9283|M
LOP|Lombok International Airport|Mataram (Pujut, Lombok Tengah)|Nusa Tenggara Barat (West Nusa Tenggara)|ID|-8.7600|116.2782|L
LPA|Gran Canaria Airport|Gran Canaria Island|Canary Islands|ES|27.9319|-15.3866|L
LPB|El Alto International Airport|La Paz / El Alto|La Paz Department|BO|-16.5103|-68.1894|L
LPF|Liupanshui Yuezhao Airport|Liupanshui (Zhongshan)|Guizhou Province|CN|26.6094|104.9790|M
LPI|Linköping City Airport|Linköping|Östergötlands län|SE|58.4049|15.6845|L
LPL|Liverpool John Lennon Airport|Liverpool|England|GB|53.3349|-2.8496|L
LPP|Lappeenranta Airport|Lappeenranta|South Karelia Region|FI|61.0446|28.1447|L
LPQ|Luang Phabang International Airport|Luang Phabang|Louangphabang Province|LA|19.9043|102.1672|L
LRD|Laredo International Airport|Laredo|Texas|US|27.5438|-99.4616|M
LRE|Longreach Airport|Longreach|Queensland|AU|-23.4320|144.2775|M
LRH|La Rochelle Île de Ré Airport|La Rochelle|Nouvelle-Aquitaine|FR|46.1792|-1.1953|M
LRM|Casa De Campo International Airport|La Romana|La Romana Province|DO|18.4522|-68.9111|L
LRR|Lar Airport|Lar|Fars Province|IR|27.6747|54.3833|M
LRU|Las Cruces International Airport|Las Cruces|New Mexico|US|32.2894|-106.9220|M
LSC|La Florida Airport|La Serena-Coquimbo|Coquimbo Region|CL|-29.9162|-71.1995|M
LSE|La Crosse Regional Airport|La Crosse|Wisconsin|US|43.8790|-91.2567|M
LSG|Leshan Airport|Leshan (Wutongqiao)|Sichuan Province|CN|29.4386|103.7492|M
LSH|Lashio Airport|Lashio|Shan State|MM|22.9779|97.7522|M
LSI|Sumburgh Airport|Lerwick, Shetland|Scotland|GB|59.8789|-1.2956|M
LSP|Josefa Camejo International Airport|Paraguaná|Falcón State|VE|11.7808|-70.1515|M
LSR|Alas Leuser Airport|Kutacane|Aceh|ID|3.3915|97.8637|M
LST|Launceston Airport|Launceston (Western Junction)|Tasmania|AU|-41.5449|147.2108|M
LSY|Lismore Airport|Lismore|New South Wales|AU|-28.8307|153.2584|M
LTD|Ghadames Airport|Ghadames|Nalut District|LY|30.1455|9.7021|M
LTI|Altai Airport|Altai|Govi-Altai Province|MN|46.3764|96.2211|M
LTK|Latakia International Airport|Latakia|Latakia Governorate|SY|35.4011|35.9487|M
LTM|Lethem Airport|Lethem|Upper Takutu-Upper Essequibo|GY|3.3728|-59.7894|M
LTN|London Luton Airport|Luton, Luton|England|GB|51.8747|-0.3683|L
LTO|Loreto International Airport|Loreto|Baja California Sur|MX|25.9895|-111.3484|L
LTU|Murod Kond Airport|Latur|Maharashtra|IN|18.4115|76.4647|M
LTX|Cotopaxi International Airport|Latacunga|Cotopaxi Province|EC|-0.9068|-78.6158|M
LUA|Tenzing-Hillary Airport|Lukla|Koshi Province|NP|27.6868|86.7295|M
LUD|Luderitz Airport|Luderitz|ǁKaras Region|NA|-26.6874|15.2429|M
LUG|Lugano Airport|Agno|Ticino|CH|46.0043|8.9106|M
LUK|Cincinnati Municipal Airport Lunken Field|Cincinnati|Ohio|US|39.1024|-84.4189|M
LUM|Dehong Mangshi International Airport|Dehong (Mangshi)|Yunnan Province|CN|24.4011|98.5317|M
LUN|Kenneth Kaunda International Airport|Lusaka|Lusaka Province|ZM|-15.3308|28.4527|L
LUQ|Brigadier Mayor D Cesar Raul Ojeda Airport|San Luis|San Luis Province|AR|-33.2732|-66.3564|M
LUR|Cape Lisburne LRRS Airport|Cape Lisburne|Alaska|US|68.8751|-166.1100|M
LUV|Karel Sadsuitubun Airport|Langgur|Maluku|ID|-5.7603|132.7594|M
LUX|Luxembourg-Findel International Airport|Luxembourg|Luxembourg|LU|49.6268|6.2121|L
LUZ|Lublin Airport|Lublin|Lublin Voivodeship|PL|51.2402|22.7135|L
LVI|Harry Mwanga Nkumbula International Airport|Livingstone|Southern Province|ZM|-17.8215|25.8196|L
LWB|Greenbrier Valley Airport|Lewisburg|West Virginia|US|37.8579|-80.4004|M
LWN|Shirak International Airport|Gyumri|Shirak Province|AM|40.7504|43.8593|L
LWS|Lewiston Nez Perce County Airport|Lewiston|Idaho|US|46.3745|-117.0150|M
LXA|Lhasa Gonggar International Airport|Shannan (Gonggar)|Tibet Autonomous Region|CN|29.2980|90.9120|L
LXR|Luxor International Airport|Luxor|Luxor Governorate|EG|25.6710|32.7064|L
LYA|Luoyang Beijiao Airport|Luoyang (Laocheng)|Henan Province|CN|34.7411|112.3880|L
LYC|Lycksele Airport|Lycksele|Västerbottens län|SE|64.5483|18.7162|M
LYG|Lianyungang Huaguoshan International Airport|Lianyungang|Jiangsu Province|CN|34.4141|119.1790|L
LYH|Lynchburg Regional Airport - Preston Glenn Field|Lynchburg|Virginia|US|37.3267|-79.2004|M
LYI|Linyi Qiyang Airport|Linyi (Hedong)|Shandong Province|CN|35.0529|118.4118|M
LYP|Faisalabad International Airport|Faisalabad|Punjab|PK|31.3649|72.9953|L
LYR|Svalbard Airport, Longyear|Longyearbyen|Svalbard|NO|78.2461|15.4656|M
LZG|Langzhong Gucheng Airport|Nanchong (Langzhong)|Sichuan Province|CN|31.5019|106.0344|M
LZH|Liuzhou Bailian Airport / Bailian Air Base|Liuzhou (Liujiang)|Guangxi Autonomous Region|CN|24.2075|109.3910|M
LZN|Matsu Nangan Airport|Matsu (Nangan)|Lienchiang County|TW|26.1597|119.9584|M
LZO|Luzhou Yunlong Airport|Luzhou (Yunlong)|Sichuan Province|CN|29.0304|105.4684|M
LZY|Nyingchi Mainling Airport|Nyingchi (Mainling)|Tibet Autonomous Region|CN|29.3033|94.3353|M
MAB|João Correa da Rocha Airport|Marabá|Pará|BR|-5.3686|-49.1380|M
MAF|Midland International Air and Space Port|Midland|Texas|US|31.9425|-102.2020|M
MAG|Madang Airport|Madang|Madang Province|PG|-5.2071|145.7890|M
MAH|Menorca Airport|Mahón (Maó)|Islas Baleares|ES|39.8626|4.2187|L
MAJ|Marshall Islands International Airport|Majuro Atoll|Majuro|MH|7.0651|171.2717|L
MAK|Malakal International Airport|Malakal|Upper Nile State|SS|9.5587|31.6519|M
MAM|General Servando Canales International Airport|Matamoros|Tamaulipas|MX|25.7699|-97.5253|M
MAO|Eduardo Gomes International Airport|Manaus|Amazonas|BR|-3.0386|-60.0497|L
MAR|La Chinita International Airport|Maracaibo|Zulia State|VE|10.5575|-71.7293|L
MAS|Momote Airport|Manus Island|Manus Province|PG|-2.0619|147.4240|M
MAZ|Eugenio Maria De Hostos Airport|Mayaguez||PR|18.2557|-67.1485|M
MBA|Moi International Airport|Mombasa|Mombasa County|KE|-4.0348|39.5942|L
MBD|Mmabatho International Airport|Mafeking|North-West|ZA|-25.7984|25.5480|M
MBE|Monbetsu Airport|Monbetsu|Hokkaidō Prefecture|JP|44.3039|143.4040|M
MBI|Songwe Airport|Mbeya|Mbeya Region|TZ|-8.9199|33.2740|M
MBJ|Sangster International Airport|Montego Bay|Saint James Parish|JM|18.5034|-77.9132|L
MBS|MBS International Airport|Freeland|Michigan|US|43.5332|-84.0831|M
MBT|Moises R. Espinosa Airport|Masbate|Masbate Province|PH|12.3697|123.6301|M
MBW|Melbourne Moorabbin Airport|Melbourne|Victoria|AU|-37.9778|145.0998|M
MBX|Maribor Edvard Rusjan Airport|Maribor|Hoče-Slivnica Municipality|SI|46.4799|15.6861|M
MCE|Merced Regional Macready Field|Merced|California|US|37.2847|-120.5140|M
MCG|McGrath Airport|McGrath|Alaska|US|62.9529|-155.6060|M
MCI|Kansas City International Airport|Kansas City|Missouri|US|39.3017|-94.7139|L
MCK|McCook Ben Nelson Regional Airport|McCook|Nebraska|US|40.2078|-100.5928|M
MCN|Middle Georgia Regional Airport|Macon|Georgia|US|32.6928|-83.6492|M
MCP|Macapá - Alberto Alcolumbre International Airport|Macapá|Amapá|BR|0.0507|-51.0722|M
MCT|Muscat International Airport|Muscat/Seeb|Masqat Governorate|OM|23.6002|58.2853|L
MCW|Mason City Municipal Airport|Mason City|Iowa|US|43.1598|-93.3297|M
MCX|Makhachkala Uytash International Airport|Makhachkala|Republic of Dagestan|RU|42.8168|47.6523|L
MCY|Sunshine Coast Airport|Maroochydore|Queensland|AU|-26.5933|153.0832|L
MCZ|Zumbi dos Palmares International Airport|Maceió|Alagoas|BR|-9.5126|-35.7918|L
MDC|Sam Ratulangi International Airport|Manado|Sulawesi Utara (North Sulawesi)|ID|1.5486|124.9262|L
MDG|Mudanjiang Hailang International Airport|Mudanjiang|Heilongjiang Province|CN|44.5252|129.5686|M
MDI|Makurdi Airport|Makurdi|Benue State|NG|7.7039|8.6139|M
MDK|Mbandaka Airport|Mbandaka|Équateur Province|CD|0.0226|18.2887|M
MDL|Mandalay International Airport|Mandalay|Mandalay Region|MM|21.7022|95.9779|L
MDQ|Ástor Piazzola International Airport|Mar del Plata|Buenos Aires Province|AR|-37.9342|-57.5733|M
MDT|Harrisburg International Airport|Harrisburg|Pennsylvania|US|40.1928|-76.7623|M
MDU|Mendi Airport|Mendi|Southern Highlands Province|PG|-6.1477|143.6570|M
MDW|Chicago Midway International Airport|Chicago|Illinois|US|41.7860|-87.7524|L
MDZ|Governor Francisco Gabrielli International Airport|Mendoza|Mendoza Province|AR|-32.8317|-68.7929|L
MEB|Melbourne Essendon Airport|Essendon Fields|Victoria|AU|-37.7281|144.9020|M
MEC|Eloy Alfaro International Airport|Manta|Manabi Province|EC|-0.9461|-80.6788|M
MED|Prince Mohammad Bin Abdulaziz Airport|Medina|Al Madinah Region|SA|24.5534|39.7051|L
MEE|Maré Airport|Maré|Province des îles Loyauté|NC|-21.4824|168.0385|M
MEG|Malanje Airport|Malanje|Malanje Province|AO|-9.5251|16.3124|M
MEH|Mehamn Airport|Mehamn|Finnmark|NO|71.0297|27.8267|M
MEI|Key Field / Meridian Regional Airport|Meridian|Mississippi|US|32.3326|-88.7519|M
MEM|Frederick W. Smith International Airport|Memphis|Tennessee|US|35.0438|-89.9763|L
MEQ|Cut Nyak Dhien Airport|Kuala Pesisir|Aceh|ID|4.0410|96.2533|M
MFE|McAllen Miller International Airport|McAllen|Texas|US|26.1761|-98.2380|M
MFK|Matsu Beigan Airport|Matsu (Beigan)|Lienchiang County|TW|26.2241|120.0027|M
MFM|Macau International Airport|Nossa Senhora do Carmo|Nossa Senhora do Carmo (Taipa)|MO|22.1496|113.5920|L
MFR|Rogue Valley International-Medford Airport|Medford|Oregon|US|42.3742|-122.8730|M
MFU|Mfuwe International Airport|Mfuwe|Eastern Province|ZM|-13.2589|31.9366|L
MGA|Augusto C. Sandino (Managua) International Airport|Managua|Managua Department|NI|12.1415|-86.1682|L
MGB|Mount Gambier Airport|Mount Gambier|South Australia|AU|-37.7444|140.7806|M
MGC|Michigan City Municipal Airport|Michigan City|Indiana|US|41.7033|-86.8212|M
MGF|Regional de Maringá - Sílvio Name Júnior Airport|Maringá|Paraná|BR|-23.4761|-52.0162|M
MGH|Margate Airport|Margate|Kwazulu-Natal|ZA|-30.8574|30.3430|M
MGM|Montgomery Regional (Dannelly Field) Airport|Montgomery|Alabama|US|32.3006|-86.3940|M
MGQ|Aden Adde International Airport|Mogadishu|Banaadir|SO|2.0144|45.3047|L
MGW|Morgantown Municipal Airport Walter L. (Bill) Hart Field|Morgantown|West Virginia|US|39.6433|-79.9176|M
MGZ|Myeik Airport|Mkeik|Tanintharyi Region|MM|12.4398|98.6215|M
MHD|Mashhad International Airport|Mashhad|Razavi Khorasan Province|IR|36.2348|59.6429|L
MHG|Mannheim-City Airport|Mannheim|Baden-Württemberg|DE|49.4731|8.5142|M
MHH|Leonard M. Thompson International Airport|Marsh Harbour|Central Abaco|BS|26.5107|-77.0843|M
MHK|Manhattan Regional Airport|Manhattan|Kansas|US|39.1410|-96.6708|M
MHQ|Mariehamn Airport|Mariehamn|Åland Islands Region|FI|60.1222|19.8982|M
MHT|Manchester-Boston Regional Airport|Manchester|New Hampshire|US|42.9326|-71.4357|M
MHU|Mount Hotham Airport|Mount Hotham|Victoria|AU|-37.0475|147.3340|M
MID|Manuel Crescencio Rejón International Airport|Mérida|Yucatán|MX|20.9305|-89.6455|L
MIG|Mianyang Nanjiao Airport|Mianyang (Fucheng)|Sichuan Province|CN|31.4281|104.7410|M
MII|Frank Miloye Milenkowichi–Marília State Airport|Marília|São Paulo|BR|-22.1969|-49.9265|M
MIM|Merimbula Airport|Merimbula|New South Wales|AU|-36.9086|149.9010|M
MIR|Monastir Habib Bourguiba International Airport|Monastir|Monastir Governorate|TN|35.7581|10.7547|M
MIU|Maiduguri International Airport|Maiduguri|Borno State|NG|11.8542|13.0807|L
MJF|Mosjøen Airport, Kjærstad|Mosjøen|Nordland|NO|65.7840|13.2149|M
MJI|Mitiga International Airport|Tripoli|Tripoli District|LY|32.8918|13.2879|L
MJK|Shark Bay Airport|Denham|Western Australia|AU|-25.8973|113.5758|M
MJM|Mbuji Mayi Airport|Mbuji Mayi|Kasaï-Oriental Province|CD|-6.1212|23.5690|M
MJN|Amborovy Airport|Mahajanga|Mahajanga|MG|-15.6668|46.3512|L
MJT|Mytilene International Airport|Mytilene|North Aegean|GR|39.0574|26.5986|M
MJZ|Mirny Airport|Mirny|Sakha (Yakutia) Republic|RU|62.5347|114.0390|M
MKE|General Mitchell International Airport|Milwaukee|Wisconsin|US|42.9472|-87.8966|L
MKG|Muskegon County Airport|Muskegon|Michigan|US|43.1695|-86.2382|M
MKK|Molokai Airport|Kaunakakai|Hawaii|US|21.1529|-157.0960|M
MKL|McKellar-Sipes Regional Airport|Jackson|Tennessee|US|35.5999|-88.9156|M
MKM|Mukah Airport|Mukah|Sarawak|MY|2.8819|112.0433|M
MKP|Makemo Airport|Makemo||PF|-16.5839|-143.6580|M
MKQ|Mopah International Airport|Merauke|Papua Selatan (South Papua)|ID|-8.5239|140.4197|M
MKU|Makokou Airport|Makokou|Ogooué-Ivindo Province|GA|0.5792|12.8909|M
MKW|Rendani Airport|Manokwari|Papua Barat (West Papua)|ID|-0.8918|134.0490|M
MKY|Mackay Airport|Mackay|Queensland|AU|-21.1708|149.1826|M
MKZ|Malacca International Airport|Malacca|Melaka|MY|2.2656|102.2528|M
MLB|Melbourne Orlando International Airport|Melbourne|Florida|US|28.1020|-80.6411|M
MLE|Velana International Airport|Malé|Malé (capital city)|MV|4.1918|73.5291|L
MLG|Abdul Rachman Saleh Airport|Malang|Jawa Timur (East Java)|ID|-7.9291|112.7142|M
MLI|Quad City International Airport|Moline|Illinois|US|41.4485|-90.5075|M
MLM|General Francisco J. Mujica International Airport|Morelia|Michoacán|MX|19.8499|-101.0250|L
MLN|Melilla Airport|Melilla|Melilla (city)|ES|35.2798|-2.9563|M
MLU|Monroe Regional Airport|Monroe|Louisiana|US|32.5109|-92.0377|M
MLW|Spriggs Payne Airport|Monrovia|Montserrado County|LR|6.2891|-10.7587|M
MLX|Malatya Erhaç Airport|Malatya|Malatya Province|TR|38.4353|38.0910|M
MMB|Memanbetsu Airport|Ōzora|Hokkaidō Prefecture|JP|43.8806|144.1640|M
MMD|Minamidaito Airport|Minamidaito|Okinawa Prefecture|JP|25.8465|131.2630|M
MME|Teesside International Airport|Darlington, Durham|England|GB|54.5092|-1.4294|M
MMH|Mammoth Yosemite Airport|Mammoth Lakes|California|US|37.6254|-118.8431|M
MMJ|Shinshu-Matsumoto Airport|Matsumoto|Nagano Prefecture|JP|36.1668|137.9230|M
MMK|Emperor Nicholas II Murmansk Airport|Murmansk|Murmansk Oblast|RU|68.7817|32.7508|L
MMO|Maio Airport|Vila do Maio|Sotavento Islands|CV|15.1559|-23.2137|M
MMX|Malmö Sturup Airport|Malmö|Skåne län|SE|55.5356|13.3763|L
MMY|Miyako Airport|Miyakojima|Okinawa Prefecture|JP|24.7828|125.2950|M
MNC|Nacala International Airport|Nacala|Nampula Province|MZ|-14.4882|40.7122|M
MNG|Maningrida Airport|Maningrida|Northern Territory|AU|-12.0561|134.2340|M
MNI|John A. Osborne Airport|Gerald's Park|Saint Peter Parish|MS|16.7918|-62.1932|L
MNJ|Mananjary Airport|Mananjary|Fianarantsoa|MG|-21.2018|48.3583|M
MNX|Manicoré Airport|Manicoré|Amazonas|BR|-5.8114|-61.2783|M
MOB|Mobile Regional Airport|Mobile|Alabama|US|30.6912|-88.2428|M
MOC|Mário Ribeiro Airport|Montes Claros|Minas Gerais|BR|-16.7069|-43.8189|M
MOG|Mong Hsat Airport|Mong Hsat|Shan State|MM|20.5168|99.2568|M
MOL|Molde Airport, Årø|Årø|Møre og Romsdal|NO|62.7447|7.2625|M
MOQ|Morondava Airport|Morondava|Toliara|MG|-20.2847|44.3176|M
MOT|Minot International Airport|Minot|North Dakota|US|48.2580|-101.2791|M
MOV|Moranbah Airport|Moranbah|Queensland|AU|-22.0578|148.0770|M
MOZ|Moorea Temae Airport|Moorea-Maiao||PF|-17.4898|-149.7618|M
MPA|Katima Mulilo Airport|Mpacha|Zambezi Region|NA|-17.6343|24.1767|M
MPH|Godofredo P. Ramos Airport|Caticlan|Aklan Province|PH|11.9245|121.9540|M
MPL|Montpellier-Méditerranée Airport|Montpellier/Méditerranée|Occitanie|FR|43.5762|3.9630|L
MPM|Maputo Airport|Maputo|Maputo (city)|MZ|-25.9208|32.5726|L
MPN|Mount Pleasant Airport / RAF Mount Pleasant|Mount Pleasant||FK|-51.8226|-58.4458|M
MPY|Maripasoula Airport|Maripasoula|Saint-Laurent-du-Maroni|GF|3.6559|-54.0394|M
MQF|Magnitogorsk International Airport|Magnitogorsk|Republic of Bashkortostan|RU|53.3920|58.7552|L
MQJ|Moma Airport|Khonuu|Sakha (Yakutia) Republic|RU|66.4509|143.2616|M
MQL|Mildura Airport|Mildura|Victoria|AU|-34.2292|142.0860|M
MQM|Mardin Airport|Mardin|Mardin Province|TR|37.2233|40.6317|M
MQN|Mo i Rana Airport, Røssvoll|Mo i Rana|Nordland|NO|66.3639|14.3014|M
MQP|Kruger Mpumalanga International Airport|Mbombela|Mpumalanga|ZA|-25.3833|31.1053|L
MQS|Mustique Airport|Lovell|Grenadines|VC|12.8879|-61.1802|M
MQT|Marquette Sawyer Regional Airport|Gwinn|Michigan|US|46.3515|-87.3959|M
MQX|Mekele Alula Aba Nega Airport|Mekele|Tigray Region|ET|13.4674|39.5335|M
MRE|Mara Serena Lodge Airstrip|Serena|Narok County|KE|-1.4046|35.0083|M
MRI|Merrill Field|Anchorage|Alaska|US|61.2128|-149.8440|M
MRS|Marseille Provence Airport|Marignane, Bouches-du-Rhône|Provence-Alpes-Côte-d'Azur|FR|43.4381|5.2125|L
MRU|Sir Seewoosagur Ramgoolam International Airport|Plaine Magnien|Grand Port|MU|-20.4302|57.6836|L
MRV|Mineralnye Vody Airport|Mineralnyye Vody|Stavropol Krai|RU|44.2251|43.0819|L
MRX|Mahshahr Airport|Mahshahr|Khuzestan Province|IR|30.5562|49.1519|M
MRY|Monterey Regional Airport|Monterey|California|US|36.5868|-121.8442|M
MRZ|Moree Airport|Moree|New South Wales|AU|-29.4989|149.8450|M
MSJ|Misawa Airport / Misawa Air Base|Misawa|Aomori Prefecture|JP|40.7032|141.3680|M
MSL|Northwest Alabama Regional Airport|Muscle Shoals|Alabama|US|34.7451|-87.6130|M
MSN|Dane County Regional Truax Field|Madison|Wisconsin|US|43.1399|-89.3375|M
MSO|Missoula Montana Airport|Missoula|Montana|US|46.9158|-114.0911|M
MSQ|Minsk National Airport|Minsk|Minsk Region|BY|53.8881|28.0400|L
MSR|Muş Airport|Muş|Muş Province|TR|38.7478|41.6612|M
MSS|Massena International Airport Richards Field|Massena|New York|US|44.9362|-74.8443|M
MST|Maastricht Aachen Airport|Maastricht|Limburg|NL|50.9111|5.7694|L
MSU|Moshoeshoe I International Airport|Maseru(Mazenod)|Maseru District|LS|-29.4563|27.5545|L
MSZ|Welwitschia Mirabilis International Airport|Moçâmedes|Namibe Province|AO|-15.2612|12.1468|M
MTJ|Montrose Regional Airport|Montrose|Colorado|US|38.5098|-107.8940|M
MTR|Los Garzones Airport|Montería|Córdoba Department|CO|8.8237|-75.8258|M
MTT|Minatitlán/Coatzacoalcos International Airport|Cosoleacaque|Veracruz|MX|18.1034|-94.5807|M
MTY|Monterrey International Airport|Monterrey|Nuevo León|MX|25.7785|-100.1070|L
MUA|Munda Airport|Munda|Western Province|SB|-8.3280|157.2630|M
MUB|Maun International Airport|Maun|North West District|BW|-19.9705|23.4314|L
MUE|Waimea Kohala Airport|Waimea (Kamuela)|Hawaii|US|20.0013|-155.6680|M
MUH|Mersa Matruh International Airport|Marsa Matruh|Matruh Governorate|EG|31.3243|27.2223|L
MUN|José Tadeo Monagas International Airport|Maturín|Monagas State|VE|9.7490|-63.1533|M
MUR|Marudi Airport|Marudi|Sarawak|MY|4.1787|114.3303|M
MUX|Multan International Airport|Multan|Punjab|PK|30.2032|71.4191|L
MVB|M'Vengue El Hadj Omar Bongo Ondimba International Airport|Franceville|Haut-Ogooué Province|GA|-1.6562|13.4380|M
MVD|Carrasco General Cesáreo L. Berisso International Airport|Ciudad de la Costa|Canelones Department|UY|-34.8356|-56.0265|L
MVF|Dix-Sept Rosado Airport|Mossoró|Rio Grande do Norte|BR|-5.2019|-37.3643|M
MVP|Fabio Alberto Leon Bentley Airport|Mitú|Vaupés Department|CO|1.2537|-70.2339|M
MVQ|Mogilev Airport|Mogilev|Mogilev Region|BY|53.9549|30.0951|M
MVR|Salak Airport|Maroua|Far North Region|CM|10.4514|14.2574|M
MWA|Veterans Airport of Southern Illinois|Marion|Illinois|US|37.7512|-89.0166|M
MWL|Mineral Wells Regional Airport|Mineral Wells|Texas|US|32.7816|-98.0602|M
MWX|Muan International Airport|Muan (Piseo-ri)|Jeollanam-do (South Jeolla Province)|KR|34.9914|126.3828|L
MWZ|Mwanza International Airport|Mwanza|Mwanza Region|TZ|-2.4466|32.9360|L
MXL|General Rodolfo Sánchez Taboada International Airport|Mexicali|Baja California|MX|32.6306|-115.2428|M
MXV|Mörön Airport|Mörön|Khövsgöl Province|MN|49.6637|100.1000|M
MXX|Mora Airport|Mora|Dalarnas län|SE|60.9579|14.5114|M
MYA|Moruya Airport|Moruya|New South Wales|AU|-35.8978|150.1440|M
MYD|Malindi International Airport|Malindi|Kilifi County|KE|-3.2293|40.1017|M
MYE|Miyakejima Airport|Miyakejima|Tōkyō Prefecture|JP|34.0736|139.5600|M
MYG|Mayaguana Airport|Abraham Bay Settlement|Mayaguana|BS|22.3795|-73.0135|M
MYJ|Matsuyama Airport|Matsuyama|Ehime Prefecture|JP|33.8269|132.7001|L
MYL|McCall Municipal Airport|McCall|Idaho|US|44.8888|-116.1011|M
MYP|Mary International Airport|Mary|Mary Region|TM|37.6235|61.8957|M
MYQ|Mysore Airport|Mysore|Karnataka|IN|12.2298|76.6537|M
MYR|Myrtle Beach International Airport|Myrtle Beach|South Carolina|US|33.6797|-78.9283|L
MYT|Myitkyina Airport|Myitkyina|Kachin State|MM|25.3836|97.3519|M
MYU|Mekoryuk Airport|Mekoryuk|Alaska|US|60.3723|-166.2698|M
MYW|Mtwara Airport|Mtwara|Mtwara Region|TZ|-10.3362|40.1820|M
MYY|Miri Airport|Miri|Sarawak|MY|4.3220|113.9870|M
MZG|Penghu Magong Airport|Huxi|Penghu County|TW|23.5687|119.6280|L
MZH|Amasya Merzifon Airport|Amasya|Amasya Province|TR|40.8294|35.5220|M
MZI|Mopti Airport|Sévaré|Mopti Region|ML|14.5128|-4.0796|M
MZL|La Nubia Airport|Manizales|Caldas Department|CO|5.0296|-75.4647|M
MZO|Sierra Maestra International Airport|Manzanillo|Granma Province|CU|20.2886|-77.0875|M
MZQ|Mkuze Airport|Mkuze|Kwazulu-Natal|ZA|-27.6261|32.0443|M
MZR|Mazar-i-Sharif International Airport|Mazar-i-Sharif|Balkh Province|AF|36.7041|67.2105|L
MZS|Moradabad Airport|Moradabad|Uttar Pradesh|IN|28.8175|78.9219|M
MZT|General Rafael Buelna International Airport|Mazatlàn|Sinaloa|MX|23.1628|-106.2645|L
MZV|Mulu Airport|Mulu|Sarawak|MY|4.0483|114.8050|M
MZW|Mecheria Airport|Mecheria|Naama Province|DZ|33.5359|-0.2424|M
NAA|Narrabri Airport|Narrabri|New South Wales|AU|-30.3192|149.8270|M
NAG|Dr. Babasaheb Ambedkar International Airport|Nagpur|Maharashtra|IN|21.0922|79.0472|L
NAH|Naha Airport|Tabukan Utara, Sangihe Islands|Sulawesi Utara (North Sulawesi)|ID|3.6848|125.5272|M
NAJ|Nakhchivan International Airport|Nakhchivan|Nakhchivan Autonomous Republic|AZ|39.1888|45.4584|L
NAL|Nalchik Airport|Nalchik|Kabardino-Balkar Republic|RU|43.5129|43.6366|M
NAM|Namniwel Airport|Namniwel|Maluku|ID|-3.1432|126.9765|M
NAN|Nadi International Airport|Nadi|Western Division|FJ|-17.7618|177.4378|L
NAQ|Qaanaaq Airport|Qaanaaq|Avannaata Municipality|GL|77.4886|-69.3887|M
NAS|Lynden Pindling International Airport|Nassau|New Providence|BS|25.0390|-77.4662|L
NAT|Rio Grande do Norte/São Gonçalo do Amarante–Governador Aluízio Alves International Airport|Natal|Rio Grande do Norte|BR|-5.7698|-35.3666|L
NAV|Nevşehir Kapadokya Airport|Nevşehir|Nevşehir Province|TR|38.7719|34.5345|L
NBC|Begishevo Airport|Nizhnekamsk|Republic of Tatarstan|RU|55.5647|52.0925|M
NBE|Enfidha - Hammamet International Airport|Enfidha|Sousse Governorate|TN|36.0758|10.4386|M
NBJ|Dr. Antonio Agostinho Neto International Airport|Luanda (Ícolo e Bengo)|Luanda Province|AO|-9.0507|13.4991|L
NBS|Changbaishan Airport|Baishan|Jilin Province|CN|42.0669|127.6022|M
NCA|North Caicos Airport|North Caicos|North Caicos|TC|21.9161|-71.9430|M
NCE|Nice-Côte d'Azur Airport|Nice, Alpes-Maritimes|Provence-Alpes-Côte-d'Azur|FR|43.6584|7.2159|L
NCL|Newcastle International Airport|Newcastle upon Tyne, Tyne and Wear|England|GB|55.0380|-1.6896|L
NCU|Nukus International Airport|Nukus|Republic of Karakalpakstan|UZ|42.4884|59.6233|L
NCY|Annecy Meythet airport|Annecy|Auvergne-Rhône-Alpes|FR|45.9289|6.0987|M
NDB|Nouadhibou International Airport|Nouadhibou|Dakhlet Nouadhibou Region|MR|20.9324|-17.0302|L
NDC|Nanded Airport|Nanded|Maharashtra|IN|19.1833|77.3167|M
NDG|Qiqihar Sanjiazi Airport|Qiqihar|Heilongjiang Province|CN|47.2300|123.9142|L
NDJ|N'Djamena International Airport|N'Djamena|N'Djamena (city)|TD|12.1337|15.0340|L
NDR|Nador Al Aaroui International Airport|Al Aaroui|L'Oriental Region|MA|34.9888|-3.0282|L
NDU|Rundu Airport|Rundu|Kavango East Region|NA|-17.9565|19.7194|M
NEC|Necochea Airport|Necochea|Buenos Aires Province|AR|-38.4907|-58.8163|M
NER|Chulman Airport|Neryungri|Sakha (Yakutia) Republic|RU|56.9139|124.9140|M
NEV|Vance W. Amory International Airport|Charlestown||KN|17.2057|-62.5899|M
NGB|Ningbo Lishe International Airport|Ningbo|Zhejiang Province|CN|29.8267|121.4620|L
NGE|N'Gaoundéré Airport|N'Gaoundéré|Adamaoua Region|CM|7.3570|13.5592|M
NGO|Chubu Centrair International Airport|Tokoname|Aichi Prefecture|JP|34.8584|136.8050|L
NGQ|Ngari Gunsa Airport|Shiquanhe|Tibet Autonomous Region|CN|32.0979|80.0540|M
NGS|Nagasaki Airport|Nagasaki|Nagasaki Prefecture|JP|32.9169|129.9140|L
NHV|Nuku Hiva Airport|Nuku Hiva||PF|-8.7956|-140.2290|M
NIM|Diori Hamani International Airport|Niamey|Niamey Capital District|NE|13.4815|2.1836|L
NJC|Nizhnevartovsk Airport|Nizhnevartovsk|Khanty-Mansi Autonomous Okrug|RU|60.9493|76.4836|L
NJF|Al Najaf International Airport|Najaf|Najaf Governorate|IQ|31.9911|44.4050|L
NKC|Nouakchott–Oumtounsy International Airport|Nouakchott|Nouakchott Region|MR|18.3100|-15.9697|L
NKG|Nanjing Lukou International Airport|Nanjing|Jiangsu Province|CN|31.7350|118.8659|L
NKM|Nagoya Airport / JASDF Komaki Air Base|Nagoya|Aichi Prefecture|JP|35.2558|136.9241|M
NKT|Şırnak Şerafettin Elçi Airport|Şırnak|Şırnak Province|TR|37.3647|42.0582|M
NLA|Simon Mwansa Kapwepwe International Airport|Ndola|Copperbelt Province|ZM|-12.9651|28.5156|L
NLD|Quetzalcóatl International Airport|Nuevo Laredo|Tamaulipas|MX|27.4439|-99.5705|M
NLH|Ninglang Luguhu Airport|Ninglang|Yunnan Province|CN|27.5403|100.7593|M
NLI|Nikolayevsk-na-Amure Airport|Nikolayevsk-na-Amure Airport|Khabarovsk Krai|RU|53.1550|140.6500|M
NLK|Norfolk Island International Airport|Burnt Pine||NF|-29.0418|167.9395|M
NLT|Xinyuan Nalati Airport|Xinyuan|Xinjiang Autonomous Region|CN|43.4318|83.3786|M
NLU|Felipe Ángeles International Airport|Mexico City|México (state)|MX|19.7438|-99.0151|L
NMA|Namangan International Airport|Namangan|Namangan Region|UZ|40.9846|71.5578|L
NMF|Maafaru International Airport|Noonu Atoll|Noonu Atoll|MV|5.8174|73.4684|M
NMI|Navi Mumbai International Airport|Navi Mumbai|Maharashtra|IN|18.9846|73.0653|L
NNG|Nanning Wuxu International Airport|Nanning (Jiangnan)|Guangxi Autonomous Region|CN|22.5981|108.1819|L
NNM|Naryan Mar Airport|Naryan Mar|Nenets Autonomous Okrug|RU|67.6400|53.1219|M
NOB|Nosara Airport|Nicoya|Guanacaste Province|CR|9.9765|-85.6530|M
NOC|Ireland West Airport Knock|Charlestown|County Mayo|IE|53.9104|-8.8170|L
NOJ|Noyabrsk Airport|Noyabrsk|Yamalo-Nenets Autonomous Okrug|RU|63.1833|75.2700|M
NOP|Sinop Airport|Sinop|Sinop Province|TR|42.0183|35.0718|M
NOS|Nosy Be International Airport|Nosy Be|Antsiranana|MG|-13.3121|48.3148|L
NOU|La Tontouta International Airport|Nouméa (La Tontouta)|Province Sud|NC|-22.0146|166.2130|L
NOV|Albano Machado Airport|Huambo|Huambo Province|AO|-12.8089|15.7605|M
NOZ|Spichenkovo Airport|Novokuznetsk|Kemerovo Oblast|RU|53.8114|86.8772|M
NPE|Hawke's Bay Airport|Napier|Hawke's Bay Region|NZ|-39.4658|176.8700|M
NPL|New Plymouth Airport|New Plymouth|Taranaki Region|NZ|-39.0086|174.1790|M
NPO|Nanga Pinoh Airport|Nanga Pinoh-Borneo Island|Kalimantan Barat (West Kalimantan)|ID|-0.3486|111.7462|M
NPT|Newport State Airport|Newport|Rhode Island|US|41.5322|-71.2810|M
NQN|Presidente Perón International Airport|Neuquén|Neuquén Province|AR|-38.9490|-68.1557|L
NQY|Cornwall Airport Newquay|Newquay|England|GB|50.4406|-4.9954|M
NQZ|Nursultan Nazarbayev International Airport|Astana|Astana City|KZ|51.0270|71.4671|L
NRA|Narrandera Airport|Narrandera|New South Wales|AU|-34.7022|146.5120|M
NRK|Norrköping Airport|Norrköping|Östergötlands län|SE|58.5863|16.2506|M
NRN|Weeze (Niederrhein) Airport|Weeze|North Rhine-Westphalia|DE|51.6014|6.1412|L
NRR|José Aponte de la Torre Airport|Ceiba||PR|18.2473|-65.6398|M
NSH|Nowshahr Airport|Nowshahr|Mazandaran Province|IR|36.6643|51.4627|M
NSI|Yaoundé Nsimalen International Airport|Yaoundé|Centre Region|CM|3.7226|11.5533|L
NSK|Alykel International Airport|Norilsk|Krasnoyarsk Krai|RU|69.3080|87.3259|L
NSN|Nelson Airport|Nelson|Nelson Region|NZ|-41.2967|173.2243|M
NST|Nakhon Si Thammarat Airport|Nakhon Si Thammarat|Nakhon Si Thammarat Province|TH|8.5396|99.9447|M
NTE|Nantes Atlantique Airport|Nantes|Pays-de-la-Loire|FR|47.1532|-1.6107|L
NTG|Nantong Xingdong International Airport|Nantong (Tongzhou)|Jiangsu Province|CN|32.0736|120.9801|M
NTL|Newcastle Airport|Williamtown|New South Wales|AU|-32.7961|151.8350|L
NTN|Normanton Airport|Normanton|Queensland|AU|-17.6841|141.0697|M
NTQ|Noto Satoyama Airport|Wajima|Ishikawa Prefecture|JP|37.2931|136.9620|M
NTX|Ranai Airport|Ranai-Natuna Besar Island|Kepulauan Riau (Riau Islands)|ID|3.9087|108.3880|M
NUE|Nuremberg Airport|Nuremberg|Bavaria|DE|49.4987|11.0781|L
NUI|Nuiqsut Airport|Nuiqsut|Alaska|US|70.2100|-151.0060|M
NUM|Neom Bay Airport|Sharma|Tabuk Region|SA|27.9243|35.2936|L
NUX|Novy Urengoy Airport|Novy Urengoy|Yamalo-Nenets Autonomous Okrug|RU|66.0694|76.5203|M
NVA|Benito Salas Airport|Neiva|Huila Department|CO|2.9501|-75.2940|M
NVI|Navoi International Airport|Navoi|Navoiy Region|UZ|40.1176|65.1727|M
NVT|Ministro Victor Konder International Airport|Navegantes|Santa Catarina|BR|-26.8794|-48.6510|L
NWI|Norwich Airport|Norwich, Norfolk|England|GB|52.6758|1.2828|M
NYA|Nyagan Airport|Nyagan|Khanty-Mansi Autonomous Okrug|RU|62.1100|65.6150|M
NYI|Sunyani Airport|Sunyani|Bono Region|GH|7.3618|-2.3288|M
NYK|Nanyuki Civil Airport|Gathiuru|Nyeri County|KE|-0.0624|37.0413|M
NYM|Nadym Airport|Nadym|Yamalo-Nenets Autonomous Okrug|RU|65.4809|72.6989|M
NYO|Stockholm Skavsta Airport|Nyköping|Södermanlands län|SE|58.7897|16.9115|L
NYT|Nay Pyi Taw International Airport|Naypyitaw|Mandalay Region|MM|19.6235|96.2010|L
NZC|Maria Reiche Neuman Airport|Nazca|Ica Region|PE|-14.8540|-74.9615|M
NZH|Manzhouli Xijiao Airport|Manzhouli|Inner Mongolia Autonomous Region|CN|49.5667|117.3300|M
NZL|Zhalantun Genghis Khan Airport|Zhalantun|Inner Mongolia Autonomous Region|CN|47.8659|122.7687|M
OAJ|Albert J Ellis Airport|Richlands|North Carolina|US|34.8292|-77.6121|M
OAK|Oakland San Francisco Bay Airport|Oakland|California|US|37.7201|-122.2212|L
OAX|Xoxocotlán International Airport|Oaxaca|Oaxaca|MX|16.9988|-96.7261|L
OBO|Tokachi-Obihiro Airport|Obihiro|Hokkaidō Prefecture|JP|42.7333|143.2170|M
OCC|Francisco De Orellana Airport|Coca|Orellana Province|EC|-0.4629|-76.9868|M
OCE|Ocean City Municipal Airport|Ocean City|Maryland|US|38.3104|-75.1240|M
OCJ|Ian Fleming International Airport|Boscobel|Saint Mary Parish|JM|18.4041|-76.9698|M
OCS|Corisco International Airport|Corisco Island|Litoral Province|GQ|0.9109|9.3303|L
ODB|Córdoba Airport|Córdoba|Andalucía|ES|37.8420|-4.8489|M
ODE|Odense Hans Christian Andersen Airport|Odense|South Denmark|DK|55.4753|10.3272|L
OEC|Oecusse Route of the Sandalwood International Airport|Oecussi-Ambeno|Oecussi|TL|-9.1984|124.3379|L
OER|Örnsköldsvik Airport|Örnsköldsvik|Västernorrlands län|SE|63.4083|18.9900|M
OGD|Ogden Hinckley Airport|Ogden|Utah|US|41.1959|-112.0120|M
OGG|Kahului International Airport|Kahului|Hawaii|US|20.8963|-156.4318|L
OGL|Eugene F. Correia International Airport|Ogle|Demerara-Mahaica|GY|6.8059|-58.1077|M
OGN|Yonaguni Airport|Yonaguni|Okinawa Prefecture|JP|24.4673|122.9798|M
OGS|Ogdensburg International Airport|Ogdensburg|New York|US|44.6819|-75.4655|M
OGU|Ordu–Giresun Airport|Ordu|Ordu Province|TR|40.9669|38.0860|M
OGX|Ain Beida Airport|Ouargla|Ouargla Province|DZ|31.9172|5.4128|M
OGZ|Vladikavkaz Beslan International Airport|Beslan|Republic of North Ossetia-Alania|RU|43.2051|44.6066|M
OHD|Ohrid St. Paul the Apostle Airport|Ohrid|Southwestern Statistical Region|MK|41.1800|20.7423|L
OHE|Mohe Gulian Airport|Mohe|Heilongjiang Province|CN|52.9169|122.4228|M
OHO|Okhotsk Airport|Okhotsk|Khabarovsk Krai|RU|59.4101|143.0565|M
OHS|Suhar International Airport|Suhar|Al Batinah Governorate|OM|24.3860|56.6254|L
OIM|Oshima Airport|Izu Oshima|Tōkyō Prefecture|JP|34.7820|139.3600|M
OIR|Okushiri Airport|Okushiri Island|Hokkaidō Prefecture|JP|42.0717|139.4330|M
OIT|Oita Airport|Oita|Ōita Prefecture|JP|33.4794|131.7370|M
OKA|Naha International Airport|Naha|Okinawa Prefecture|JP|26.1924|127.6398|L
OKC|OKC Will Rogers World Airport|Oklahoma City|Oklahoma|US|35.3934|-97.5982|L
OKD|Sapporo Okadama Airport|Sapporo|Hokkaidō Prefecture|JP|43.1174|141.3813|M
OKE|Okinoerabu Airport|Wadomari|Kagoshima Prefecture|JP|27.4316|128.7056|M
OKI|Oki Global Geopark Airport|Okinoshima|Shimane Prefecture|JP|36.1784|133.3236|M
OKJ|Okayama Momotaro Airport|Okayama|Okayama Prefecture|JP|34.7569|133.8550|L
OKL|Oksibil Airport|Oksibil|Papua Pegunungan (Highland Papua)|ID|-4.9071|140.6277|M
OLA|Ørland Airport|Ørland|Trøndelag|NO|63.6989|9.6040|M
OLB|Olbia Costa Smeralda Airport|Olbia (SS)|Sardinia|IT|40.8990|9.5185|L
OLF|L M Clayton Airport|Wolf Point|Montana|US|48.0945|-105.5750|M
OLM|Olympia Regional Airport|Olympia|Washington|US|46.9694|-122.9030|M
OLZ|Olyokminsk Airport|Olyokminsk|Sakha (Yakutia) Republic|RU|60.4018|120.4761|M
OMA|Eppley Airfield|Omaha|Nebraska|US|41.3032|-95.8941|L
OMD|Oranjemund Airport|Oranjemund|ǁKaras Region|NA|-28.5853|16.4464|M
OME|Nome Airport|Nome|Alaska|US|64.5122|-165.4450|M
OMH|Urmia Airport|Urmia|West Azerbaijan Province|IR|37.6681|45.0687|M
OMN|Zomin Airport|Zomin|Jizzakh Region|UZ|40.0140|68.4110|M
OMO|Mostar International Airport|Mostar|Federation of Bosnia and Herzegovina|BA|43.2825|17.8461|L
OMR|Oradea International Airport|Oradea|Bihor County|RO|47.0253|21.9025|L
OMS|Omsk Central Airport|Omsk|Omsk Oblast|RU|54.9631|73.3124|L
OND|Ondangwa Airport|Ondangwa|Oshana Region|NA|-17.8782|15.9526|M
ONJ|Odate Noshiro Airport|Kitaakita|Akita Prefecture|JP|40.1919|140.3710|M
ONQ|Zonguldak Çaycuma Airport|Zonguldak|Zonguldak Province|TR|41.5064|32.0886|M
ONT|Ontario International Airport|Ontario|California|US|34.0560|-117.6010|L
ONX|Enrique Adolfo Jimenez Airport|Colón|Colón Province|PA|9.3566|-79.8674|M
OOL|Gold Coast Airport|Gold Coast|Queensland|AU|-28.1660|153.5066|L
OOM|Cooma Snowy Mountains Airport|Cooma|New South Wales|AU|-36.3004|148.9724|M
OPF|Miami-Opa Locka Executive Airport|Miami|Florida|US|25.9070|-80.2784|M
OPU|Balimo Airport|Balimo|Western Province|PG|-8.0500|142.9330|M
ORB|Örebro Airport|Örebro|Örebro län|SE|59.2237|15.0380|M
ORF|Norfolk International Airport|Norfolk|Virginia|US|36.8953|-76.2010|L
ORH|Worcester Regional Airport|Worcester|Massachusetts|US|42.2673|-71.8757|M
ORK|Cork International Airport|Cork|County Cork|IE|51.8413|-8.4911|L
ORN|Oran Es-Sénia (Ahmed Ben Bella) International Airport|Es-Sénia|Oran Province|DZ|35.6206|-0.6225|L
ORT|Northway Airport|Northway|Alaska|US|62.9613|-141.9290|M
ORU|Juan Mendoza International Airport|Oruro|Oruro Department|BO|-17.9562|-67.0758|L
OSD|Åre Östersund Airport|Östersund|Jämtlande län|SE|63.1935|14.5042|M
OSI|Osijek Airport|Osijek(Klisa)|Osijek-Baranja County|HR|45.4624|18.8113|M
OSR|Leoš Janáček Airport Ostrava|Mošnov|Moravian-Silesian Region|CZ|49.6963|18.1111|L
OSS|Osh International Airport|Osh|Osh Region|KG|40.6090|72.7933|L
OST|Ostend-Bruges International Airport|Oostende|West Flanders Province|BE|51.1998|2.8747|L
OSW|Orsk Airport|Orsk|Orenburg Oblast|RU|51.0725|58.5956|M
OTH|Southwest Oregon Regional Airport|North Bend|Oregon|US|43.4171|-124.2460|M
OTZ|Ralph Wien Memorial Airport|Kotzebue|Alaska|US|66.8847|-162.5990|M
OUA|Ouagadougou Thomas Sankara International Airport|Ouagadougou|Kadiogo Province|BF|12.3532|-1.5124|L
OUD|Oujda Angads Airport|Ahl Angad|L'Oriental Region|MA|34.7896|-1.9260|L
OUL|Oulu Airport|Oulu / Oulunsalo|North Ostrobothnia Region|FI|64.9301|25.3546|L
OUZ|Tazadit Airport|Zouérate|Tiris Zemmour Region|MR|22.7573|-12.4822|M
OVB|Novosibirsk Tolmachevo Airport|Novosibirsk|Novosibirsk Oblast|RU|55.0198|82.6187|L
OVD|Asturias Airport|Ranón|Asturias|ES|43.5636|-6.0346|L
OVS|Sovetskiy Airport|Sovetskiy|Khanty-Mansi Autonomous Okrug|RU|61.3266|63.6019|M
OWB|Owensboro Daviess County Airport|Owensboro|Kentucky|US|37.7401|-87.1668|M
OXB|Osvaldo Vieira International Airport|Bissau|Bissau Autonomous Sector|GW|11.8943|-15.6536|L
OYE|Oyem Airport|Oyem|Woleu-Ntem Province|GA|1.5431|11.5814|M
OZC|Labo Airport|Ozamiz|Misamis Occidental Province|PH|8.1785|123.8420|M
OZG|Zagora Airport|Zagora|Drâa-Tafilalet Region|MA|30.2658|-5.8608|L
OZZ|Ouarzazate International Airport|Ouarzazate|Drâa-Tafilalet Region|MA|30.9391|-6.9094|L
PAB|Bilaspur Airport|Bilaspur|Chhattisgarh|IN|21.9884|82.1110|M
PAC|Marcos A. Gelabert International Airport|Albrook|Panamá Province|PA|8.9733|-79.5556|M
PAD|Paderborn Lippstadt Airport|Büren|North Rhine-Westphalia|DE|51.6125|8.6175|L
PAE|Seattle Paine Field International Airport|Everett|Washington|US|47.9063|-122.2820|M
PAG|Pagadian Airport|Pagadian|Zamboanga del Sur Province|PH|7.8256|123.4596|M
PAH|Barkley Regional Airport|Paducah|Kentucky|US|37.0608|-88.7738|M
PAP|Toussaint Louverture International Airport|Port-au-Prince|Ouest Department|HT|18.5800|-72.2926|L
PAT|Jay Prakash Narayan Airport|Patna|Bihar|IN|25.5913|85.0880|M
PAV|Paulo Afonso Airport|Paulo Afonso|Bahia|BR|-9.4009|-38.2506|M
PAZ|El Tajín National Airport|Poza Rica|Veracruz|MX|20.6027|-97.4608|M
PBC|Hermanos Serdán International Airport|Puebla|Puebla|MX|19.1585|-98.3716|L
PBD|Porbandar Airport|Porbandar|Gujarat|IN|21.6495|69.6564|M
PBG|Plattsburgh International Airport|Plattsburgh|New York|US|44.6509|-73.4681|M
PBH|Paro International Airport|Paro|Paro District|BT|27.4032|89.4246|L
PBM|Johan Adolf Pengel International Airport|Paramaribo|Para|SR|5.4528|-55.1878|L
PBO|Paraburdoo Airport|Paraburdoo|Western Australia|AU|-23.1711|117.7450|M
PBR|Puerto Barrios Airport|Puerto Barrios|Izabal Department|GT|15.7309|-88.5838|M
PBU|Putao Airport|Putao|Kachin State|MM|27.3299|97.4263|M
PCL|Cap FAP David Abenzur Rengifo International Airport|Pucallpa|Ucayali Region|PE|-8.3781|-74.5745|L
PCP|Principe Airport|São Tomé & Príncipe|Autonomous Region of Principe|ST|1.6612|7.4111|M
PCR|German Olano Airport|Puerto Carreño|Vichada Department|CO|6.1847|-67.4932|M
PDA|Obando Cesar Gaviria Trujillo Airport|Puerto Inírida|Guainía Department|CO|3.8535|-67.9062|M
PDG|Minangkabau International Airport|Padang (Katapiang)|Sumatera Barat (West Sumatra)|ID|-0.7860|100.2804|L
PDK|DeKalb Peachtree Airport|Atlanta|Georgia|US|33.8763|-84.3021|M
PDL|João Paulo II Airport|Ponta Delgada|Autonomous Region of Azores|PT|37.7412|-25.6979|L
PDO|Pendopo Airport|Talang Gudang-Sumatra Island|Sumatera Selatan (South Sumatra)|ID|-3.2861|103.8800|M
PDP|Capitan Corbeta CA Curbelo International Airport|Punta del Este|Maldonado Department|UY|-34.8551|-55.0943|M
PDS|Piedras Negras International Airport|Piedras Negras|Coahuila|MX|28.6279|-100.5352|M
PDT|Eastern Oregon Regional Airport at Pendleton|Pendleton|Oregon|US|45.6951|-118.8410|M
PDV|Plovdiv International Airport|Plovdiv|Plovdiv Province|BG|42.0678|24.8508|L
PED|Pardubice Airport|Pardubice|Pardubice Region|CZ|50.0150|15.7398|L
PEE|Perm International Airport|Perm|Perm Krai|RU|57.9145|56.0212|L
PEG|Perugia San Francesco d'Assisi – Umbria International Airport|Perugia (PG)|Umbria|IT|43.0959|12.5132|L
PEI|Matecaña International Airport|Pereira|Risaralda Department|CO|4.8127|-75.7395|M
PEM|Padre Aldamiz International Airport|Puerto Maldonado|Madre de Dios Region|PE|-12.6136|-69.2286|M
PEN|Penang International Airport|Penang|Penang|MY|5.2963|100.2762|L
PES|Petrozavodsk Airport|Petrozavodsk|Republic of Karelia|RU|61.8852|34.1547|M
PET|João Simões Lopes Neto International Airport|Pelotas|Rio Grande do Sul|BR|-31.7172|-52.3278|M
PEV|Pécs-Pogány International Airport|Pécs|Baranya County|HU|45.9889|18.2420|L
PEW|Bacha Khan International Airport|Peshawar|Khyber Pakhtunkhwa|PK|33.9939|71.5146|L
PEX|Pechora Airport|Pechora|Komi Republic|RU|65.1211|57.1308|M
PEZ|Penza Airport|Penza|Penza Oblast|RU|53.1106|45.0211|M
PFB|Lauro Kurtz Airport|Passo Fundo|Rio Grande do Sul|BR|-28.2440|-52.3278|M
PFO|Paphos International Airport|Paphos|Paphos District|CY|34.7180|32.4857|L
PGA|Page Municipal Airport|Page|Arizona|US|36.9242|-111.4477|M
PGD|Punta Gorda Airport|Punta Gorda|Florida|US|26.9202|-81.9905|M
PGF|Perpignan-Rivesaltes (Llabanère) Airport|Perpignan/Rivesaltes|Occitanie|FR|42.7404|2.8707|M
PGH|Pantnagar Airport|Pantnagar|Uttar Pradesh|IN|29.0334|79.4737|M
PGK|Depati Amir Airport|Pangkal Pinang|Bangka Belitung|ID|-2.1622|106.1390|M
PGU|Persian Gulf International Airport|Khiyaroo|Bushehr Province|IR|27.3796|52.7377|M
PGV|Pitt-Greenville Airport|Greenville|North Carolina|US|35.6355|-77.3843|M
PGZ|Ponta Grossa Airport - Comandante Antonio Amilton Beraldo|Ponta Grossa|Paraná|BR|-25.1845|-50.1438|M
PHB|Parnaíba - Prefeito Doutor João Silva Filho International Airport|Parnaíba|Piauí|BR|-2.8937|-41.7320|M
PHC|Port Harcourt International Airport|Port Harcourt|Rivers State|NG|5.0155|6.9496|L
PHE|Port Hedland International Airport|Port Hedland|Western Australia|AU|-20.3828|118.6298|L
PHF|Newport News Williamsburg International Airport|Newport News|Virginia|US|37.1319|-76.4930|M
PHG|Port Harcourt City Airport / Port Harcourt Air Force Base|Port Harcourt|Rivers State|NG|4.8461|7.0214|M
PHH|Pokhara International Airport|Pokhara|Gandaki Province|NP|28.1838|84.0147|L
PHS|Phitsanulok Airport|Phitsanulok|Phitsanulok Province|TH|16.7829|100.2790|M
PHW|Hendrik Van Eck Airport|Phalaborwa|Limpopo|ZA|-23.9372|31.1554|M
PIA|General Wayne A. Downing Peoria International Airport|Peoria|Illinois|US|40.6638|-89.6926|M
PIB|Hattiesburg Laurel Regional Airport|Moselle|Mississippi|US|31.4671|-89.3371|M
PIE|St. Petersburg Clearwater International Airport|Pinellas Park|Florida|US|27.9102|-82.6874|L
PIH|Pocatello Regional Airport|Pocatello|Idaho|US|42.9098|-112.5960|M
PIK|Glasgow Prestwick Airport|Prestwick, South Ayrshire|Scotland|GB|55.5015|-4.5772|L
PIR|Pierre Regional Airport|Pierre|South Dakota|US|44.3827|-100.2860|M
PIS|Poitiers-Biard Airport|Poitiers/Biard|Nouvelle-Aquitaine|FR|46.5877|0.3067|M
PIT|Pittsburgh International Airport|Pittsburgh|Pennsylvania|US|40.4915|-80.2329|L
PIU|PAF Captain Guillermo Concha Iberico International Airport|Piura|Piura Region|PE|-5.2058|-80.6164|M
PIX|Pico Airport|Pico Island|Autonomous Region of Azores|PT|38.5543|-28.4413|M
PIZ|Point Lay LRRS Airport|Point Lay|Alaska|US|69.7329|-163.0050|M
PJM|Puerto Jimenez Airport|Puerto Jimenez|Puntarenas Province|CR|8.5333|-83.3000|M
PKB|Mid Ohio Valley Regional Airport|Parkersburg (Williamstown)|West Virginia|US|39.3451|-81.4392|M
PKC|Yelizovo Airport|Petropavlovsk-Kamchatsky|Kamchatka Krai|RU|53.1687|158.4511|L
PKE|Parkes Airport|Parkes|New South Wales|AU|-33.1314|148.2390|M
PKR|Pokhara Domestic Airport|Pokhara|Gandaki Province|NP|28.2006|83.9812|M
PKU|Sultan Syarif Kasim II International Airport / Roesmin Nurjadin AFB|Pekanbaru|Riau|ID|0.4586|101.4443|M
PKV|Princess Olga Pskov International Airport|Pskov|Pskov Oblast|RU|57.7813|28.3938|M
PKX|Beijing Daxing International Airport|Beijing|Beijing Municipality|CN|39.5013|116.4140|L
PKY|Tjilik Riwut Airport|Palangkaraya|Kalimantan Tengah (Central Kalimantan)|ID|-2.2271|113.9434|M
PKZ|Pakse International Airport|Pakse|Champasak Province|LA|15.1340|105.7799|L
PLJ|Placencia Airport|Placencia|Stann Creek District|BZ|16.5370|-88.3615|M
PLM|Sultan Mahmud Badaruddin II Airport|Palembang|Sumatera Selatan (South Sumatra)|ID|-2.8977|104.6981|M
PLN|Pellston Regional Airport of Emmet County Airport|Pellston|Michigan|US|45.5709|-84.7967|M
PLO|Port Lincoln Airport|Port Lincoln|South Australia|AU|-34.6053|135.8800|M
PLQ|Palanga International Airport|Palanga|Klaipėda County|LT|55.9732|21.0939|L
PLS|Providenciales International Airport|Providenciales|Providenciales|TC|21.7737|-72.2683|L
PLW|Mutiara - SIS Al-Jufrie Airport|Palu|Sulawesi Tengah (Central Sulawesi)|ID|-0.9165|119.9086|M
PLX|Semei International Airport|Semey|Abai Region|KZ|50.3513|80.2344|L
PLZ|Chief Dawid Stuurman International Airport|Gqeberha (Port Elizabeth)|Eastern Cape|ZA|-33.9897|25.6174|L
PMC|El Tepual International Airport|Puerto Montt|Los Lagos Region|CL|-41.4431|-73.0941|L
PMF|Parma Airport|Parma (PR)|Emilia-Romagna|IT|44.8264|10.2971|M
PMG|Ponta Porã Airport|Ponta Porã|Mato Grosso do Sul|BR|-22.5496|-55.7026|M
PMO|Falcone–Borsellino Airport|Palermo|Sicily|IT|38.1760|13.0910|L
PMQ|Perito Moreno Jalil Hamer Airport|Perito Moreno|Santa Cruz Province|AR|-46.5379|-70.9787|M
PMR|Palmerston North Airport|Palmerston North|Manawatu-Wanganui Region|NZ|-40.3206|175.6170|M
PMV|Del Caribe Santiago Mariño International Airport|Isla Margarita|Nueva Esparta State|VE|10.9126|-63.9666|L
PMW|Brigadeiro Lysias Rodrigues Airport|Palmas|Tocantins|BR|-10.2915|-48.3570|M
PMY|El Tehuelche Airport|Puerto Madryn|Chubut Province|AR|-42.7592|-65.1027|M
PNA|Pamplona Airport|Pamplona|Navarra|ES|42.7700|-1.6463|M
PNI|Pohnpei International Airport|Pohnpei Island|Pohnpei State|FM|6.9851|158.2099|M
PNK|Supadio International Airport|Pontianak|Kalimantan Barat (West Kalimantan)|ID|-0.1523|109.4045|L
PNL|Pantelleria Airport|Pantelleria (TP)|Sicily|IT|36.8165|11.9689|M
PNP|Girua Airport|Popondetta|Northern Province|PG|-8.8045|148.3090|M
PNQ|Pune International Airport|Pune|Maharashtra|IN|18.5821|73.9197|L
PNR|Antonio Agostinho-Neto International Airport|Pointe Noire|Kouilou Department|CG|-4.8160|11.8866|L
PNS|Pensacola International Airport|Pensacola|Florida|US|30.4727|-87.1866|L
PNT|Lieutenant Julio Gallardo Airport|Puerto Natales|Magallanes Region|CL|-51.6707|-72.5291|M
PNY|Pondicherry Airport|Puducherry (Pondicherry)|Pondicherry|IN|11.9680|79.8120|M
PNZ|Senador Nilo Coelho Airport|Petrolina|Pernambuco|BR|-9.3624|-40.5691|M
POA|Porto Alegre-Salgado Filho International Airport|Porto Alegre|Rio Grande do Sul|BR|-29.9940|-51.1675|L
POG|Port Gentil International Airport|Port Gentil|Ogooué-Maritime Province|GA|-0.7117|8.7544|L
POL|Pemba Airport|Pemba|Cabo Delgado Province|MZ|-12.9933|40.5249|M
POM|Port Moresby Jacksons International Airport|Port Moresby|National Capital District (Port Moresby)|PG|-9.4434|147.2200|L
POP|Gregorio Luperon International Airport|Puerto Plata|Puerto Plata Province|DO|19.7579|-70.5700|M
POR|Pori Airport|Pori|Satakunta Region|FI|61.4617|21.8000|M
POS|Piarco International Airport|Port of Spain|Tunapuna-Piarco|TT|10.5953|-61.3376|L
POZ|Poznań-Ławica Airport|Poznań|Greater Poland Voivodeship|PL|52.4216|16.8234|L
PPB|Presidente Prudente Airport|Presidente Prudente|São Paulo|BR|-22.1751|-51.4246|M
PPG|Pago Pago International Airport|Pago Pago|Western District|AS|-14.3310|-170.7100|L
PPK|Petropavl International Airport|Petropavl|North Kazakhstan Region|KZ|54.7756|69.1874|L
PPN|Guillermo León Valencia Airport|Popayán|Cauca Department|CO|2.4544|-76.6093|M
PPP|Proserpine Whitsunday Coast Airport|Proserpine|Queensland|AU|-20.4944|148.5536|M
PPS|Puerto Princesa International Airport / PAF Antonio Bautista Air Base|Puerto Princesa|Palawan Province|PH|9.7420|118.7591|L
PPT|Fa'a'ā International Airport|Papeete||PF|-17.5535|-149.6069|L
PQC|Phú Quốc International Airport|Phu Quoc Island|Southwest Region|VN|10.1698|103.9935|L
PQI|Presque Isle International Airport|Presque Isle|Maine|US|46.6890|-68.0448|M
PQQ|Port Macquarie Airport|Port Macquarie|New South Wales|AU|-31.4358|152.8630|M
PRA|General Urquiza Airport|Parana|Entre Ríos Province|AR|-31.7948|-60.4804|M
PRC|Prescott Regional Airport - Ernest A. Love Field|Prescott|Arizona|US|34.6535|-112.4199|M
PRI|Praslin Island Airport|Praslin Island|Grand' Anse (Praslin)|SC|-4.3193|55.6916|M
PRM|Portimão Airport|Portimão|Faro District|PT|37.1493|-8.5840|M
PRN|Priština Adem Jashari International Airport|Prishtina|Pristina District|XK|42.5728|21.0358|L
PSA|Pisa International Airport|Pisa (PI)|Tuscany|IT|43.6839|10.3927|L
PSC|Tri Cities Airport|Pasco|Washington|US|46.2647|-119.1190|M
PSD|Port Said International Airport|Port Said|Port Said Governorate|EG|31.2793|32.2406|L
PSE|Mercedita International Airport|Ponce||PR|18.0083|-66.5630|M
PSG|Petersburg James A Johnson Airport|Petersburg|Alaska|US|56.8017|-132.9450|M
PSM|Portsmouth International Airport at Pease|Portsmouth|New Hampshire|US|43.0779|-70.8233|M
PSO|Antonio Nariño Airport|Chachagüí|Nariño Department|CO|1.3967|-77.2909|M
PSP|Palm Springs International Airport|Palm Springs|California|US|33.8297|-116.5070|L
PSR|Abruzzo Airport|Pescara|Abruzzi|IT|42.4311|14.1830|L
PSS|Libertador Gral D Jose De San Martin Airport|Posadas|Misiones Province|AR|-27.3858|-55.9707|M
PSU|Pangsuma Airport|Putussibau-Borneo Island|Kalimantan Barat (West Kalimantan)|ID|0.8346|112.9402|M
PSZ|Capitán Av. Salvador Ogaya G. airport|Puerto Suárez|Santa Cruz Department|BO|-18.9753|-57.8206|M
PTG|Polokwane International Airport|Polokwane|Limpopo|ZA|-23.8453|29.4586|L
PTH|Port Heiden Airport|Port Heiden|Alaska|US|56.9579|-158.6302|M
PTP|Maryse Condé International Airport|Pointe-à-Pitre||GP|16.2654|-61.5328|L
PTU|Platinum Airport|Platinum|Alaska|US|59.0177|-161.8279|M
PUB|Pueblo Memorial Airport|Pueblo|Colorado|US|38.2891|-104.4970|M
PUD|Puerto Deseado Airport|Puerto Deseado|Santa Cruz Province|AR|-47.7353|-65.9041|M
PUF|Pau Pyrénées Airport|Pau/Pyrénées (Uzein)|Nouvelle-Aquitaine|FR|43.3800|-0.4186|M
PUQ|President Carlos Ibáñez International Airport|Punta Arenas|Magallanes Region|CL|-53.0026|-70.8546|L
PUS|Gimhae International Airport|Busan|Busan-gwangyeoksi (Busan Metropolitan City)|KR|35.1795|128.9380|L
PUU|Tres De Mayo Airport|Puerto Asís|Putumayo Department|CO|0.5052|-76.5008|M
PUW|Pullman-Moscow Regional Airport|Pullman|Washington|US|46.7416|-117.1116|M
PUY|Pula Airport|Pula|Istria County|HR|44.8935|13.9222|L
PUZ|Puerto Cabezas Airport|Puerto Cabezas|North Caribbean Coast Autonomous Region|NI|14.0472|-83.3867|M
PVA|El Embrujo Airport|Providencia|San Andrés, Providencia y Santa Catalina Department|CO|13.3575|-81.3580|M
PVD|Rhode Island T. F. Green International Airport|Providence/Warwick|Rhode Island|US|41.7250|-71.4257|L
PVH|Governador Jorge Teixeira de Oliveira International Airport|Porto Velho|Rondônia|BR|-8.7085|-63.9023|L
PVK|Aktion National Airport|Preveza|Epirus|GR|38.9255|20.7653|M
PVR|Puerto Vallarta International Airport|Puerto Vallarta|Jalisco|MX|20.6799|-105.2544|L
PVU|Provo Municipal Airport|Provo|Utah|US|40.2189|-111.7224|M
PWE|Pevek Airport|Apapelgino|Chukotka Autonomous Okrug|RU|69.7833|170.5970|M
PWM|Portland International Jetport|Portland|Maine|US|43.6462|-70.3093|L
PWQ|Pavlodar International Airport|Pavlodar|Pavlodar Region|KZ|52.1950|77.0731|L
PXM|Puerto Escondido International Airport|Puerto Escondido|Oaxaca|MX|15.8768|-97.0891|M
PXO|Porto Santo Airport|Vila Baleira|Autonomous Region of Madeira|PT|33.0734|-16.3500|M
PXR|Surin Airport|Surin|Surin Province|TH|14.8683|103.4980|M
PXU|Pleiku Airport|Pleiku|Central Highlands Region|VN|14.0045|108.0170|M
PYJ|Polyarny Airport|Yakutia|Sakha (Yakutia) Republic|RU|66.4004|112.0300|M
PYK|Payam International Airport|Karaj|Alborz Province|IR|35.7761|50.8267|L
PZB|Pietermaritzburg Airport|Pietermaritzburg|Kwazulu-Natal|ZA|-29.6490|30.3987|M
PZH|Zhob Airport|Fort Sandeman|Balochistan|PK|31.3584|69.4636|M
PZI|Panzhihua Bao'anying Airport|Panzhihua (Renhe)|Sichuan Province|CN|26.5400|101.7985|M
PZO|General Manuel Carlos Piar International Airport|Guyana City|Bolívar State|VE|8.2885|-62.7604|L
PZU|Port Sudan New International Airport|Port Sudan|Red Sea State|SD|19.4346|37.2341|L
QBC|Bella Coola Airport|Bella Coola|British Columbia|CA|52.3875|-126.5960|M
QOW|Sam Mbakwe International Cargo Airport|Owerri|Imo State|NG|5.4271|7.2060|M
QRO|Querétaro Intercontinental Airport|Querétaro|Querétaro|MX|20.6188|-100.1864|L
QRW|Warri Airport|Okpe|Delta State|NG|5.5982|5.8187|M
QSF|Ain Arnat Airport|Sétif|Sétif Province|DZ|36.1785|5.3299|M
QSR|Salerno Costa d'Amalfi Airport|Salerno|Campania|IT|40.6204|14.9113|M
QSZ|Shache Airport|Shache|Xinjiang Autonomous Region|CN|38.2454|77.0561|M
QUO|Akwa Ibom International Airport|Uyo|Akwa Ibom State|NG|4.8725|8.0930|M
RAB|Tokua Airport|Kokopo|East New Britain Province|PG|-4.3405|152.3800|M
RAE|Arar Domestic Airport|Arar|The Northern Border Region|SA|30.9066|41.1382|M
RAH|Rafha Domestic Airport|Rafha|The Northern Border Region|SA|29.6264|43.4906|M
RAI|Nelson Mandela International Airport|Praia|Sotavento Islands|CV|14.9411|-23.4847|L
RAO|Leite Lopes Airport|Ribeirão Preto|São Paulo|BR|-21.1343|-47.7741|M
RAP|Rapid City Regional Airport|Rapid City|South Dakota|US|44.0453|-103.0570|M
RAR|Rarotonga International Airport|Avarua||CK|-21.2027|-159.8060|L
RAS|Sardar-e-Jangal Airport|Rasht|Gilan Province|IR|37.3233|49.6178|M
RBA|Rabat-Salé Airport|Rabat|Rabat-Salé-Kénitra Region|MA|34.0515|-6.7515|L
RBR|Rio Branco-Plácido de Castro International Airport|Rio Branco|Acre|BR|-9.8690|-67.8940|L
RBY|Ruby Airport|Ruby|Alaska|US|64.7272|-155.4700|M
RCB|Richards Bay Airport|Richards Bay|Kwazulu-Natal|ZA|-28.7410|32.0921|M
RCH|Almirante Padilla Airport|Riohacha|La Guajira Department|CO|11.5262|-72.9260|M
RDD|Redding Municipal Airport|Redding|California|US|40.5090|-122.2930|M
RDM|Roberts Field|Redmond|Oregon|US|44.2541|-121.1500|M
RDO|Warsaw Radom Airport|Radom|Masovian Voivodeship|PL|51.3894|21.2147|M
RDP|Kazi Nazrul Islam Airport|Durgapur|West Bengal|IN|23.6225|87.2430|M
RDU|Raleigh-Durham International Airport|Raleigh/Durham|North Carolina|US|35.8787|-78.7873|L
RDZ|Rodez–Aveyron Airport|Rodez/Marcillac|Occitanie|FR|44.4079|2.4827|M
REC|Recife/Guararapes - Gilberto Freyre International Airport|Recife|Pernambuco|BR|-8.1275|-34.9230|L
REG|Reggio Calabria Airport|Reggio Calabria|Calabria|IT|38.0712|15.6516|M
REL|Almirante Marco Andres Zar Airport|Rawson|Chubut Province|AR|-43.2105|-65.2703|M
REN|Orenburg Central Airport|Orenburg|Orenburg Oblast|RU|51.7927|55.4572|M
RER|Retalhuleu Airport|Retalhuleu|Retalhuleu Department|GT|14.5214|-91.6970|M
RES|Resistencia International Airport|Resistencia|Chaco Province|AR|-27.4499|-59.0561|L
REU|Reus Airport|Reus|Catalonia|ES|41.1475|1.1684|L
REW|Rewa Airport, Chorhata, REWA|Rewa|Madhya Pradesh|IN|24.5034|81.2203|M
REX|General Lucio Blanco International Airport|Reynosa|Tamaulipas|MX|26.0089|-98.2285|M
RFD|Chicago Rockford International Airport|Chicago/Rockford|Illinois|US|42.1954|-89.0972|M
RFP|Raiatea Airport|Uturoa||PF|-16.7229|-151.4660|M
RGA|Gobernador Ramón Trejo Noel International Airport|Rio Grande|Tierra del Fuego Province|AR|-53.7777|-67.7494|M
RGL|Piloto Civil Norberto Fernández International Airport|Rio Gallegos|Santa Cruz Province|AR|-51.6088|-69.3089|L
RGN|Yangon International Airport|Yangon|Yangon Region|MM|16.9073|96.1332|L
RGO|Orang (Chongjin) Airport|Hoemun-ri|North Hamgyong Province|KP|41.4285|129.6476|M
RHD|Termas de Río Hondo international Airport|Termas de Río Hondo|Santiago del Estero Province|AR|-27.4966|-64.9360|M
RHI|Rhinelander Oneida County Airport|Rhinelander|Wisconsin|US|45.6312|-89.4675|M
RHO|Rhodes International Airport "Diagoras"|Rhodes|South Aegean|GR|36.4054|28.0862|L
RIA|Santa Maria Airport|Santa Maria|Rio Grande do Sul|BR|-29.7114|-53.6882|M
RIB|Capitán Av. Selin Zeitun Lopez Airport|Riberalta|El Beni Department|BO|-11.0094|-66.0755|M
RIC|Richmond International Airport|Richmond|Virginia|US|37.5052|-77.3197|L
RIS|Rishiri Airport|Rishiri|Hokkaidō Prefecture|JP|45.2420|141.1860|M
RIW|Central Wyoming Regional Airport|Riverton|Wyoming|US|43.0642|-108.4600|M
RIY|Riyan International Airport|Mukalla(Riyan)|Hadhramaut Governorate|YE|14.6622|49.3753|L
RIZ|Rizhao Shanzihe Airport|Rizhao (Donggang)|Shandong Province|CN|35.4050|119.3244|M
RJA|Rajahmundry Airport|Madhurapudi|Andhra Pradesh|IN|17.1058|81.8132|M
RJH|Shah Makhdum Airport|Rajshahi|Rajshahi Division|BD|24.4372|88.6165|M
RJK|Rijeka Airport|Rijeka(Omišalj)|Primorje-Gorski Kotar County|HR|45.2164|14.5709|L
RJL|Logroño-Agoncillo Airport|Logroño|La Rioja|ES|42.4610|-2.3222|M
RJN|Rafsanjan Airport|Rafsanjan|Kerman Province|IR|30.2983|56.0490|M
RKD|Knox County Regional Airport|Rockland|Maine|US|44.0601|-69.0992|M
RKE|Copenhagen Roskilde Airport|Roskilde|Zealand|DK|55.5856|12.1314|M
RKS|Southwest Wyoming Regional Airport|Rock Springs|Wyoming|US|41.5942|-109.0650|M
RKT|Ras Al Khaimah International Airport|Ras Al Khaimah|Ras al-Khaimah Emirate|AE|25.6135|55.9388|L
RKV|Reykjavík Domestic Airport|Reykjavík|Capital Region|IS|64.1287|-21.9376|M
RKZ|Xigaze Peace Airport / Shigatse Air Base|Xigazê (Samzhubzê)|Tibet Autonomous Region|CN|29.3509|89.2992|L
RLG|Rostock-Laage Airport|Laage|Mecklenburg-Vorpommern|DE|53.9182|12.2783|M
RLK|Bayannur Tianjitai Airport|Bayannur|Inner Mongolia Autonomous Region|CN|40.9264|107.7409|M
RMA|Roma Airport|Roma|Queensland|AU|-26.5450|148.7750|M
RMF|Marsa Alam International Airport|Marsa Alam|Red Sea Governorate|EG|25.5555|34.5924|L
RMI|Federico Fellini International Airport|Rimini (RN)|Emilia-Romagna|IT|44.0200|12.6122|L
RML|Colombo Ratmalana International Airport|Colombo|Western Province|LK|6.8216|79.8859|L
RMO|Chişinău International Airport|Chişinău|Chişinău (city)|MD|46.9277|28.9317|L
RMQ|Taichung International Airport / Ching Chuang Kang Air Base|Taichung (Qingshui)|Taichung City|TW|24.2647|120.6210|L
RMU|Region of Murcia International Airport|Corvera|Murcia (region)|ES|37.8029|-1.1249|L
RMZ|Tobolsk Remezov Airport|Tobolsk|Tyumen Oblast|RU|58.0597|68.3480|M
RNB|Ronneby Airport|Ronneby|Blekinge län|SE|56.2667|15.2650|M
RNJ|Yoron Airport|Yoron|Kagoshima Prefecture|JP|27.0438|128.4016|M
RNN|Bornholm Airport|Rønne|Capital Region|DK|55.0633|14.7596|M
RNO|Reno Tahoe International Airport|Reno|Nevada|US|39.4991|-119.7680|L
RNS|Rennes-Saint-Jacques Airport|Saint-Jacques-de-la-Lande, Ille-et-Vilaine|Brittany|FR|48.0695|-1.7348|M
ROA|Roanoke–Blacksburg Regional Airport|Roanoke|Virginia|US|37.3255|-79.9754|M
ROB|Roberts International Airport|Monrovia|Margibi County|LR|6.2338|-10.3623|L
ROC|Frederick Douglass Greater Rochester International Airport|Rochester|New York|US|43.1189|-77.6724|L
ROI|Roi Et Airport|Roi Et|Roi Et Province|TH|16.1168|103.7740|M
ROK|Rockhampton Airport|Rockhampton|Queensland|AU|-23.3800|150.4754|M
ROO|Maestro Marinho Franco Airport|Rondonópolis|Mato Grosso|BR|-16.5843|-54.7248|M
ROP|Rota International Airport|Rota Island||MP|14.1733|145.2411|L
ROR|Roman Tmetuchl International Airport|Babelthuap Island|Airai|PW|7.3670|134.5441|L
ROS|Rosario Islas Malvinas International Airport|Rosario|Santa Fe Province|AR|-32.9036|-60.7850|L
ROT|Rotorua Regional Airport|Rotorua|Bay of Plenty Region|NZ|-38.1092|176.3170|M
ROW|Roswell Air Center Airport|Roswell|New Mexico|US|33.3016|-104.5310|M
RPR|Swami Vivekananda Airport|Raipur|Chhattisgarh|IN|21.1804|81.7388|M
RQA|Ruoqiang Loulan Airport|Ruoqiang Town|Xinjiang Autonomous Region|CN|38.9747|88.0083|M
RRG|Sir Charles Gaetan Duval Airport|Port Mathurin|Rodrigues Island|MU|-19.7577|63.3610|M
RRS|Røros Airport|Røros|Trøndelag|NO|62.5784|11.3423|M
RSA|Santa Rosa Airport|Santa Rosa|La Pampa Province|AR|-36.5883|-64.2757|M
RSD|Rock Sound International Airport|Rock Sound|South Eleuthera|BS|24.8916|-76.1776|M
RSI|Red Sea International Airport|Hanak|Tabuk Region|SA|25.6280|37.0889|L
RST|Rochester International Airport|Rochester|Minnesota|US|43.9083|-92.5000|M
RSU|Yeosu Airport|Yeosu|Jeollanam-do (South Jeolla Province)|KR|34.8423|127.6170|M
RSW|Southwest Florida International Airport|Fort Myers|Florida|US|26.5347|-81.7528|L
RTB|Juan Manuel Gálvez International Airport|Coxen Hole|Islas de la Bahía Department|HN|16.3168|-86.5230|L
RTM|Rotterdam The Hague Airport|Rotterdam|Zuid-Holland|NL|51.9569|4.4372|L
RUA|Arua Airport|Arua|Northern Region|UG|3.0492|30.9117|M
RUN|Roland Garros Airport|Sainte-Marie|Saint-Denis Arrondissement|RE|-20.8901|55.5189|L
RUT|Rutland - Southern Vermont Regional Airport|Rutland|Vermont|US|43.5294|-72.9496|M
RVK|Rørvik Airport, Ryum|Rørvik|Trøndelag|NO|64.8383|11.1461|M
RVN|Rovaniemi Airport|Rovaniemi|Lapland Region|FI|66.5633|25.8298|L
RVY|Pres. Gral. Óscar D. Gestido Binational Airport|Rivera/Santana do Livramento|Rivera Department|UY|-30.9746|-55.4762|M
RXS|Roxas Airport|Roxas City|Capiz Province|PH|11.5977|122.7520|M
RYK|Shaikh Zaid Airport|Rahim Yar Khan|Punjab|PK|28.3839|70.2796|M
RZE|Rzeszów-Jasionka Airport|Jasionka|Subcarpathian Voivodeship|PL|50.1098|22.0242|L
RZR|Ramsar Airport|Ramsar|Mazandaran Province|IR|36.9070|50.6873|M
RZV|Rize–Artvin Airport|Rize|Rize Province|TR|41.1798|40.8488|M
SAB|Juancho E. Yrausquin Airport|Zion's Hill|Saba|BQ|17.6453|-63.2205|M
SAF|Santa Fe Municipal Airport|Santa Fe|New Mexico|US|35.6171|-106.0890|M
SAG|Shirdi International Airport|Kakadi|Maharashtra|IN|19.6892|74.3737|L
SAH|Sanaa International Airport|Sanaa|Sanaa Municipality|YE|15.4763|44.2197|L
SAI|Siem Reap-Angkor International Airport|Siem Reap|Siem Reap province|KH|13.3697|104.2238|L
SAL|El Salvador International Airport Saint Óscar Arnulfo Romero y Galdámez|San Salvador (San Luis Talpa)|La Paz Department|SV|13.4445|-89.0558|L
SAP|Ramón Villeda Morales International Airport|San Pedro Sula|Cortés Department|HN|15.4526|-87.9236|L
SAQ|San Andros Airport|Andros Island|North Andros|BS|25.0538|-78.0490|M
SAT|San Antonio International Airport|San Antonio|Texas|US|29.5337|-98.4698|L
SAV|Savannah Hilton Head International Airport|Savannah|Georgia|US|32.1266|-81.2000|L
SBA|Santa Barbara Municipal Airport|Santa Barbara|California|US|34.4262|-119.8400|M
SBD|San Bernardino International Airport|San Bernardino|California|US|34.0967|-117.2366|L
SBH|St. Jean Airport|Gustavia||BL|17.9044|-62.8433|M
SBN|South Bend International Airport|South Bend|Indiana|US|41.7083|-86.3169|M
SBP|San Luis County Regional Airport|San Luis Obispo|California|US|35.2368|-120.6420|M
SBT|Sabetta International Airport|Sabetta|Yamalo-Nenets Autonomous Okrug|RU|71.2192|72.0522|M
SBW|Sibu Airport|Sibu|Sarawak|MY|2.2616|111.9850|M
SBY|Salisbury Ocean City Wicomico Regional Airport|Salisbury|Maryland|US|38.3405|-75.5103|M
SBZ|Sibiu International Airport|Sibiu|Sibiu County|RO|45.7858|24.0867|L
SCC|Deadhorse Airport|Deadhorse|Alaska|US|70.1947|-148.4650|M
SCE|State College Regional Airport|State College|Pennsylvania|US|40.8494|-77.8485|M
SCK|Stockton Metropolitan Airport|Stockton|California|US|37.8933|-121.2381|M
SCN|Saarbrücken Airport|Saarbrücken|Saarland|DE|49.2145|7.1097|M
SCO|Aktau International Airport|Aktau|Mangystau Region|KZ|43.8601|51.0909|L
SCQ|Santiago-Rosalía de Castro Airport|Santiago de Compostela|Galicia|ES|42.8963|-8.4151|L
SCR|Scandinavian Mountains Airport|Malung-Sälen|Dalarnas län|SE|61.1651|12.8335|L
SCT|Socotra Airport|Mori|Socotra Archipelago Governorate|YE|12.6321|53.9062|M
SCU|Antonio Maceo International Airport|Santiago|Santiago de Cuba Province|CU|19.9747|-75.8355|L
SCV|Suceava Ștefan cel Mare International Airport|Suceava|Suceava County|RO|47.6875|26.3541|L
SCW|Syktyvkar Airport|Syktyvkar|Komi Republic|RU|61.6470|50.8451|M
SDD|Lubango Mukanka International Airport|Lubango|Huíla Province|AO|-14.9248|13.5767|M
SDE|Vicecomodoro Angel D. La Paz Aragonés Airport|Santiago del Estero|Santiago del Estero Province|AR|-27.7656|-64.3100|M
SDF|Louisville Muhammad Ali International Airport|Louisville|Kentucky|US|38.1706|-85.7351|L
SDJ|Sendai Airport|Natori|Miyagi Prefecture|JP|38.1397|140.9170|L
SDK|Sandakan Airport|Sandakan|Sabah|MY|5.9009|118.0590|M
SDL|Sundsvall-Härnösand Airport|Sundsvall/ Härnösand|Västernorrlands län|SE|62.5281|17.4439|M
SDP|Sand Point Airport|Sand Point|Alaska|US|55.3139|-160.5221|M
SDQ|Las Américas International Airport|Santo Domingo|Distrito Nacional|DO|18.4297|-69.6689|L
SDR|Seve Ballesteros-Santander Airport|Santander|Cantabria|ES|43.4271|-3.8200|M
SDS|Sado Airport|Sado|Niigata Prefecture|JP|38.0602|138.4140|M
SDU|Santos Dumont Airport|Rio de Janeiro|Rio de Janeiro|BR|-22.9104|-43.1628|L
SDW|Sindhudurg Airport|Chipi|Maharashtra|IN|16.0026|73.5298|M
SDY|Sidney - Richland Regional Airport|Sidney|Montana|US|47.7051|-104.1944|M
SEB|Sabha Airport|Sabha|Sabha District|LY|26.9925|14.4662|M
SEK|Srednekolymsk Airport|Srednekolymsk|Sakha (Yakutia) Republic|RU|67.4805|153.7364|M
SEN|London Southend Airport|Southend-on-Sea, Essex|England|GB|51.5706|0.6936|M
SEZ|Seychelles International Airport|Victoria|Pointe La Rue|SC|-4.6743|55.5218|L
SFA|Sfax Thyna International Airport|Sfax|Sfax Governorate|TN|34.7180|10.6910|M
SFB|Orlando Sanford International Airport|Orlando|Florida|US|28.7743|-81.2346|L
SFG|Grand Case-l'Espérance Airport|Grand Case||MF|18.1001|-63.0474|M
SFJ|Kangerlussuaq International Airport|Kangerlussuaq|Qeqqata Municipality|GL|67.0104|-50.7153|M
SFN|Sauce Viejo Airport|Santa Fe|Santa Fe Province|AR|-31.7117|-60.8117|M
SFS|Subic Bay International Airport / Naval Air Station Cubi Point|Olongapo|Zambales Province|PH|14.7948|120.2719|L
SFT|Skellefteå Airport|Skellefteå|Västerbottens län|SE|64.6248|21.0769|M
SGC|Surgut International Airport|Surgut|Khanty-Mansi Autonomous Okrug|RU|61.3405|73.4058|L
SGD|Sønderborg Airport|Sønderborg|South Denmark|DK|54.9644|9.7917|M
SGF|Springfield Branson National Airport|Springfield|Missouri|US|37.2450|-93.3886|M
SGU|St George Regional Airport|St George|Utah|US|37.0364|-113.5103|M
SHA|Shanghai Hongqiao International Airport|Shanghai (Minhang)|Shanghai Municipality|CN|31.1981|121.3343|L
SHB|Nakashibetsu Airport|Nakashibetsu|Hokkaidō Prefecture|JP|43.5775|144.9600|M
SHD|Shenandoah Valley Regional Airport|Weyers Cave|Virginia|US|38.2638|-78.8964|M
SHE|Shenyang Taoxian International Airport|Shenyang|Liaoning Province|CN|41.6398|123.4837|L
SHI|Shimojishima Airport|Miyakojima|Okinawa Prefecture|JP|24.8267|125.1450|M
SHJ|Sharjah International Airport|Sharjah|Sharjah Emirate|AE|25.3286|55.5172|L
SHL|Shillong Airport|Shillong|Meghalaya|IN|25.7036|91.9787|M
SHM|Nanki Shirahama Airport|Shirahama|Wakayama Prefecture|JP|33.6622|135.3640|M
SHO|King Mswati III International Airport|Mpaka|Lubombo Region|SZ|-26.3586|31.7169|L
SHR|Sheridan County Airport|Sheridan|Wyoming|US|44.7692|-106.9800|M
SHS|Jingzhou Shashi Airport|Jingzhou (Shashi)|Hubei Province|CN|30.2928|112.4485|M
SHV|Shreveport Regional Airport|Shreveport|Louisiana|US|32.4447|-93.8267|M
SHW|Sharurah Domestic Airport|Sharurah|Najran Region|SA|17.4669|47.1214|M
SID|Amílcar Cabral International Airport|Espargos|Barlavento Islands|CV|16.7414|-22.9494|L
SIG|Fernando Luis Ribas Dominicci Airport|San Juan||PR|18.4568|-66.0981|M
SIS|Sishen Airport|Sishen|Northern Cape|ZA|-27.6486|22.9993|M
SIT|Sitka Rocky Gutierrez Airport|Sitka|Alaska|US|57.0471|-135.3620|M
SJC|Mineta San Jose International Airport|San Jose|California|US|37.3625|-121.9292|L
SJD|Los Cabos International Airport|San José del Cabo|Baja California Sur|MX|23.1519|-109.7207|L
SJE|Jorge E. Gonzalez Torres Airport|San José Del Guaviare|Guaviare Department|CO|2.5797|-72.6394|M
SJI|San Jose Airport|San Jose|Occidental Mindoro Province|PH|12.3615|121.0470|M
SJJ|Sarajevo International Airport|Sarajevo|Federation of Bosnia and Herzegovina|BA|43.8246|18.3315|L
SJK|Professor Urbano Ernesto Stumpf Airport|São José Dos Campos|São Paulo|BR|-23.2292|-45.8615|M
SJL|São Gabriel da Cachoeira Airport|São Gabriel da Cachoeira|Amazonas|BR|-0.1484|-66.9855|M
SJP|Prof. Eribelto Manoel Reino State Airport|São José do Rio Preto|São Paulo|BR|-20.8171|-49.4070|M
SJT|San Angelo Regional Mathis Field|San Angelo|Texas|US|31.3577|-100.4960|M
SJU|Luis Munoz Marin International Airport|San Juan||PR|18.4394|-66.0018|L
SJW|Shijiazhuang Zhengding International Airport|Shijiazhuang|Hebei Province|CN|38.2807|114.6970|L
SJZ|São Jorge Airport|Velas|Autonomous Region of Azores|PT|38.6655|-28.1758|M
SKB|Robert L. Bradshaw International Airport|Basseterre||KN|17.3108|-62.7191|L
SKD|Samarkand International Airport|Samarkand|Samarqand Region|UZ|39.7018|66.9815|L
SKN|Stokmarknes Airport, Skagen|Hadsel|Nordland|NO|68.5788|15.0334|M
SKO|Sadiq Abubakar III International Airport|Sokoto|Sokoto State|NG|12.9157|5.2075|L
SKP|Skopje International Airport|Ilinden|Skopje Statistical Region|MK|41.9581|21.6226|L
SKT|Sialkot International Airport|Sialkot|Punjab|PK|32.5359|74.3646|L
SKX|Saransk International Airport|Saransk|Republic of Mordovia|RU|54.1251|45.2123|L
SKZ|Begum Nusrat Bhutto International Airport Sukkur|Sukkur|Sindh|PK|27.7220|68.7917|M
SLA|Martín Miguel de Güemes International Airport|Salta|Salta Province|AR|-24.8560|-65.4862|L
SLD|Sliač Airport|Sliač|Banská Bystrica Region|SK|48.6378|19.1341|M
SLE|Salem-Willamette Valley Airport/McNary Field|Salem|Oregon|US|44.9095|-123.0030|M
SLK|Adirondack Regional Airport|Saranac Lake|New York|US|44.3869|-74.2046|M
SLL|Salalah International Airport|Salalah|Dhofar Governorate|OM|17.0387|54.0913|L
SLM|Salamanca Airport|Salamanca|Castilla y León|ES|40.9521|-5.5020|M
SLN|Salina Municipal Airport|Salina|Kansas|US|38.7910|-97.6522|M
SLP|Ponciano Arriaga International Airport|San Luis Potosí|San Luis Potosí|MX|22.2620|-100.9357|M
SLU|George F. L. Charles Airport|Castries|Castries|LC|14.0202|-60.9929|M
SLW|Plan de Guadalupe International Airport|Saltillo|Coahuila|MX|25.5379|-100.9283|M
SLY|Salekhard Airport|Salekhard|Yamalo-Nenets Autonomous Okrug|RU|66.5908|66.6110|M
SLZ|Marechal Cunha Machado International Airport|São Luís|Maranhão|BR|-2.5864|-44.2350|L
SMA|Santa Maria Airport|Vila do Porto|Autonomous Region of Azores|PT|36.9714|-25.1706|M
SMF|Sacramento International Airport|Sacramento|California|US|38.6954|-121.5910|L
SMI|Samos Airport|Samos Island|North Aegean|GR|37.6900|26.9117|M
SML|Stella Maris Airport|Stella Maris|Long Island|BS|23.5823|-75.2686|M
SMN|Lemhi County Airport|Salmon|Idaho|US|45.1222|-113.8820|M
SMR|Simón Bolívar International Airport|Santa Marta|Magdalena Department|CO|11.1196|-74.2306|M
SMS|Sainte Marie Airport|Vohilava|Toamasina|MG|-17.0939|49.8158|M
SMW|Smara Airport|Smara||EH|26.7320|-11.6837|M
SMX|Santa Maria Public Airport Captain G Allan Hancock Field|Santa Maria|California|US|34.8989|-120.4570|M
SNA|John Wayne Orange County International Airport|Santa Ana|California|US|33.6751|-117.8693|L
SNB|Snake Bay Airport|Milikapiti|Northern Territory|AU|-11.4177|130.6485|M
SNC|General Ulpiano Paez International Airport|Salinas/La Libertad|Santa Elena Province|EC|-2.2101|-80.9851|L
SNE|Preguiça Airport|Preguiça|Barlavento Islands|CV|16.5889|-24.2841|M
SNN|Shannon Airport|Shannon|County Clare|IE|52.7020|-8.9248|L
SNP|St Paul Island Airport|St Paul Island|Alaska|US|57.1663|-170.2226|M
SNU|Abel Santamaria International Airport|Santa Clara|Villa Clara Province|CU|22.4922|-79.9431|L
SNV|Santa Elena de Uairén Airport|Santa Elena de Uairén|Bolívar State|VE|4.5547|-61.1452|M
SNW|Thandwe Airport|Thandwe|Rakhine State|MM|18.4607|94.3001|M
SOB|Hévíz–Balaton Airport|Sármellék|Zala County|HU|46.6864|17.1591|M
SOC|Adisoemarmo International Airport|Surakarta|Jawa Tengah (Central Java)|ID|-7.5160|110.7575|L
SOJ|Sørkjosen Airport|Sørkjosen|Troms|NO|69.7868|20.9594|M
SOM|San Tomé Airport|El Tigre|Anzoátegui State|VE|8.9451|-64.1511|M
SON|Santo Pekoa International Airport|Luganville|Sanma|VU|-15.5050|167.2200|M
SOQ|Domine Eduard Osok Airport|Sorong|Papua Barat (West Papua)|ID|-0.8940|131.2870|M
SOU|Southampton Airport|Southampton|England|GB|50.9503|-1.3568|M
SOW|Show Low Regional Airport|Show Low|Arizona|US|34.2641|-110.0071|M
SPC|La Palma Airport|Sta Cruz de la Palma, La Palma Island|Canary Islands|ES|28.6265|-17.7556|M
SPD|Saidpur Airport|Saidpur|Rajshahi Division|BD|25.7592|88.9089|M
SPI|Abraham Lincoln Capital Airport|Springfield|Illinois|US|39.8441|-89.6779|M
SPN|Saipan International Airport|I Fadang, Saipan||MP|15.1194|145.7288|M
SPP|Menongue Airport|Menongue|Cuando Cubango Province|AO|-14.6576|17.7198|M
SPR|John Greif II Airport|San Pedro|Cayo District|BZ|17.9139|-87.9711|M
SPS|Wichita Falls Municipal Airport / Sheppard Air Force Base|Wichita Falls|Texas|US|33.9888|-98.4919|M
SPU|Split Saint Jerome Airport|Split|Split-Dalmatia County|HR|43.5389|16.2980|L
SPX|Sphinx International Airport|Al Jiza|Giza Governorate|EG|30.1082|30.8957|L
SQD|Shangrao Sanqingshan Airport|Shangrao (Hengfeng)|Jiangxi Province|CN|28.3797|117.9643|M
SQG|Tebelian Airport|Sintang|Kalimantan Barat (West Kalimantan)|ID|-0.0452|111.4580|M
SQJ|Sanming Shaxian Airport|Sanming (Sha)|Fujian Province|CN|26.4263|117.8336|M
SQL|San Carlos Airport|San Carlos|California|US|37.5131|-122.2508|M
SRE|Alcantarí International Airport|Sucre|Chuquisaca Department|BO|-19.2468|-65.1496|L
SRG|Jenderal Ahmad Yani Airport|Semarang|Jawa Tengah (Central Java)|ID|-6.9707|110.3732|L
SRP|Stord Airport, Sørstokken|Leirvik|Vestland|NO|59.7919|5.3408|M
SRQ|Sarasota Bradenton International Airport|Sarasota/Bradenton|Florida|US|27.3946|-82.5544|L
SRT|Soroti Airport|Soroti|Eastern Region|UG|1.7277|33.6228|M
SRY|Sari Dasht-e Naz International Airport|Sari|Mazandaran Province|IR|36.6444|53.1888|M
SRZ|El Trompillo Airport|Santa Cruz|Santa Cruz Department|BO|-17.8116|-63.1715|M
SSA|Deputado Luiz Eduardo Magalhães International Airport|Salvador|Bahia|BR|-12.9086|-38.3225|L
SSG|Malabo International Airport|Malabo|Bioko Norte Province|GQ|3.7553|8.7087|L
SSH|Sharm El Sheikh International Airport|Sharm El Sheikh|South Sinai Governorate|EG|27.9773|34.3947|L
SSJ|Sandnessjøen Airport, Stokka|Alstahaug|Nordland|NO|65.9568|12.4689|M
SST|Santa Teresita Airport|Santa Teresita|Buenos Aires Province|AR|-36.5423|-56.7218|M
SSY|Mbanza Congo Airport|Mbanza Congo|Zaire Province|AO|-6.2699|14.2470|M
STC|Saint Cloud Regional Airport|Saint Cloud|Minnesota|US|45.5466|-94.0599|M
STD|Mayor Buenaventura Vivas International Airport|Santo Domingo|Táchira State|VE|7.5654|-72.0351|M
STG|St George Airport|St George|Alaska|US|56.5773|-169.6638|M
STI|Cibao International Airport|Santiago|Santiago de los Caballeros Province|DO|19.4041|-70.6044|L
STL|St. Louis Lambert International Airport|St Louis|Missouri|US|38.7487|-90.3700|L
STM|Santarém - Maestro Wilson Fonseca International Airport|Santarém|Pará|BR|-2.4224|-54.7931|M
STR|Stuttgart Airport|Stuttgart|Baden-Württemberg|DE|48.6899|9.2220|L
STS|Charles M. Schulz Sonoma County Airport|Santa Rosa|California|US|38.5090|-122.8130|M
STT|Cyril E. King Airport|Charlotte Amalie|Saint Thomas|VI|18.3371|-64.9773|L
STV|Surat International Airport|Surat|Gujarat|IN|21.1155|72.7433|L
STW|Stavropol Shpakovskoye Airport|Stavropol|Stavropol Krai|RU|45.1092|42.1128|M
STX|Henry E. Rohlsen Airport|Christiansted|Saint Croix|VI|17.7014|-64.8026|M
SUB|Juanda International Airport|Surabaya|Jawa Timur (East Java)|ID|-7.3798|112.7870|L
SUF|Lamezia Terme Sant'Eufemia International Airport|Lamezia Terme (CZ)|Calabria|IT|38.9062|16.2460|L
SUG|Surigao Airport|Surigao City|Surigao del Norte Province|PH|9.7558|125.4809|M
SUI|Vladislav Ardzinba Sukhum International Airport|Sukhumi|Autonomous Republic of Abkhazia|GE|42.8582|41.1281|L
SUJ|Satu Mare International Airport|Satu Mare|Satu Mare County|RO|47.7033|22.8857|M
SUN|Friedman Memorial Airport|Hailey|Idaho|US|43.5044|-114.2960|M
SUV|Nausori International Airport|Nausori|Central Division|FJ|-18.0442|178.5615|L
SUX|Sioux Gateway Airport / Brigadier General Bud Day Field|Sioux City|Iowa|US|42.3976|-96.3822|M
SVA|Savoonga Airport|Savoonga|Alaska|US|63.6864|-170.4930|M
SVB|Sambava Airport|Sambava|Antsiranana|MG|-14.2786|50.1747|M
SVC|Grant County Airport|Silver City|New Mexico|US|32.6367|-108.1547|M
SVD|Argyle International Airport|Kingstown|Saint George|VC|13.1597|-61.1488|L
SVG|Stavanger Airport, Sola|Stavanger|Rogaland|NO|58.8767|5.6378|L
SVI|Eduardo Falla Solano Airport|San Vicente Del Caguán|Caquetá Department|CO|2.1522|-74.7663|M
SVJ|Svolvær Airport, Helle|Svolvær|Nordland|NO|68.2433|14.6692|M
SVL|Savonlinna Airport|Savonlinna|Southern Savonia Region|FI|61.9431|28.9451|M
SVX|Koltsovo Airport|Yekaterinburg|Sverdlovsk Oblast|RU|56.7431|60.8027|L
SVZ|Juan Vicente Gómez International Airport|San Antonio del Tachira|Táchira State|VE|7.8408|-72.4399|M
SWA|Jieyang Chaoshan International Airport|Jieyang (Rongcheng)|Guangdong Province|CN|23.5520|116.5033|L
SWF|New York Stewart International Airport|Newburgh|New York|US|41.5042|-74.1089|M
SWO|Stillwater Regional Airport|Stillwater|Oklahoma|US|36.1621|-97.0856|M
SXB|Strasbourg Airport|Strasbourg|Grand Est|FR|48.5383|7.6282|L
SXM|Princess Juliana International Airport|Sint Maarten||SX|18.0410|-63.1089|L
SXR|Srinagar International Airport|Srinagar|Jammu and Kashmir|IN|33.9871|74.7742|L
SYO|Shonai Airport|Shonai|Yamagata Prefecture|JP|38.8122|139.7870|M
SYQ|Tobías Bolaños International Airport|San Jose|San José Province|CR|9.9571|-84.1398|M
SYR|Syracuse Hancock International Airport|Syracuse|New York|US|43.1112|-76.1063|L
SYS|Saskylakh Airport|Saskylakh|Sakha (Yakutia) Republic|RU|71.9279|114.0800|M
SYX|Sanya Phoenix International Airport|Sanya (Tianya)|Hainan Province|CN|18.3029|109.4120|L
SYY|Stornoway Airport|Stornoway, Western Isles|Scotland|GB|58.2156|-6.3311|M
SYZ|Shiraz Shahid Dastghaib International Airport|Shiraz|Fars Province|IR|29.5392|52.5898|L
SZA|Soyo Airport|Soyo|Zaire Province|AO|-6.1411|12.3718|M
SZB|Sultan Abdul Aziz Shah International Airport|Subang|Selangor|MY|3.1306|101.5490|L
SZF|Samsun-Çarşamba Airport|Samsun|Samsun Province|TR|41.2540|36.5675|M
SZG|Salzburg Airport|Salzburg|Salzburg|AT|47.7933|13.0043|L
SZH|Shuozhou Zirun Airport|Shuozhou|Shanxi Province|CN|39.2732|112.6916|M
SZK|Skukuza Airport|Skukuza|Mpumalanga|ZA|-24.9609|31.5886|M
SZX|Shenzhen Bao'an International Airport|Shenzhen|Guangdong Province|CN|22.6395|113.8033|L
SZY|Olsztyn-Mazury Airport|Szymany|Warmian-Masurian Voivodeship|PL|53.4819|20.9377|M
SZZ|Solidarity Szczecin–Goleniów Airport|Szczecin(Glewice)|West Pomeranian Voivodeship|PL|53.5847|14.9022|L
TAB|A.N.R. Robinson International Airport|Scarborough|Tobago|TT|11.1496|-60.8313|L
TAC|Daniel Z. Romualdez Airport|Tacloban City|Leyte Province|PH|11.2278|125.0278|M
TAE|Daegu International Airport|Daegu|Daegu-gwangyeoksi (Daegu Metropolitan City)|KR|35.8944|128.6570|L
TAG|Bohol-Panglao International Airport|Panglao|Bohol Province|PH|9.5730|123.7701|L
TAH|Whitegrass Airport|Tanna Island|Tafea|VU|-19.4551|169.2240|M
TAI|Taiz International Airport|Taiz|Taiz Governorate|YE|13.6860|44.1391|M
TAK|Takamatsu Airport|Takamatsu|Kagawa Prefecture|JP|34.2150|134.0155|L
TAM|General Francisco Javier Mina International Airport|Ciudad Madero|Tamaulipas|MX|22.2926|-97.8671|M
TAO|Qingdao Jiaodong International Airport|Qingdao (Jiaozhou)|Shandong Province|CN|36.3620|120.0882|L
TAP|Tapachula International Airport|Tapachula|Chiapas|MX|14.7945|-92.3699|M
TAT|Poprad-Tatry Airport|Poprad|Prešov Region|SK|49.0710|20.2414|M
TAY|Tartu Airport|Tartu|Tartu County|EE|58.3074|26.6865|M
TAZ|Dashoguz International Airport|Daşoguz|Daşoguz Region|TM|41.7599|59.8361|L
TBB|Dong Tac Airport|Tuy Hoa|South Central Coast Region|VN|13.0496|109.3340|M
TBH|Tugdan Airport|Tablas Island|Romblon Province|PH|12.3110|122.0850|M
TBI|New Bight Airport|Cat Island|Cat Island|BS|24.3153|-75.4523|M
TBJ|Tabarka-Aïn Draham International Airport|Tabarka|Jendouba Governorate|TN|36.9800|8.8769|M
TBN|Waynesville-St. Robert Regional Airport-Forney Field|Fort Leonard Wood|Missouri|US|37.7416|-92.1407|M
TBP|Captain Pedro Canga Rodríguez International Airport|Tumbes|Tumbes Region|PE|-3.5521|-80.3811|M
TBT|Tabatinga International Airport|Tabatinga|Amazonas|BR|-4.2557|-69.9358|M
TBU|Fua'amotu International Airport|Nuku'alofa|Tongatapu|TO|-21.2414|-175.1492|L
TBZ|Tabriz International Airport|Tabriz|East Azerbaijan Province|IR|38.1339|46.2350|L
TCA|Tennant Creek Airport|Tennant Creek|Northern Territory|AU|-19.6344|134.1830|M
TCB|Treasure Cay Airport|Treasure Cay|Central Abaco|BS|26.7453|-77.3913|M
TCO|La Florida Airport|Tumaco|Nariño Department|CO|1.8144|-78.7492|M
TCP|Taba International Airport|Taba|South Sinai Governorate|EG|29.5945|34.7758|M
TCQ|Coronel FAP Carlos Ciriani Santa Rosa International Airport|Tacna|Tacna Region|PE|-18.0533|-70.2758|M
TCZ|Tengchong Tuofeng Airport|Baoshan (Tengchong)|Yunnan Province|CN|24.9381|98.4858|M
TDD|Teniente Av. Jorge Henrich Arauz Airport|Trinidad|El Beni Department|BO|-14.8187|-64.9180|M
TDK|Taldykorgan Airport|Taldykorgan|Jetisu Region|KZ|45.1225|78.4428|M
TDX|Trat Airport|Laem Ngop|Trat Province|TH|12.2746|102.3190|M
TEB|Teterboro Airport|Teterboro|New Jersey|US|40.8501|-74.0608|M
TEE|Cheikh Larbi Tébessi Airport|Tébessi|Tébessa Province|DZ|35.4316|8.1207|M
TEN|Tongren Fenghuang Airport|Tongren (Daxing)|Guizhou Province|CN|27.8833|109.3089|M
TEQ|Tekirdağ Çorlu Airport|Çorlu|Tekirdağ Province|TR|41.1382|27.9191|M
TER|Lajes Airport|Praia da Vitória|Autonomous Region of Azores|PT|38.7618|-27.0908|M
TET|Tete Airport|Tete|Tete Province|MZ|-16.1048|33.6402|L
TEX|Telluride Regional Airport|Telluride|Colorado|US|37.9538|-107.9080|M
TFF|Tefé Airport|Tefé|Amazonas|BR|-3.3829|-64.7241|M
TFN|Tenerife Norte-Ciudad de La Laguna Airport|Tenerife|Canary Islands|ES|28.4828|-16.3417|L
TFS|Tenerife Sur Airport|Tenerife|Canary Islands|ES|28.0445|-16.5725|L
TFU|Chengdu Tianfu International Airport|Chengdu (Jianyang)|Sichuan Province|CN|30.3125|104.4413|L
TGD|Podgorica Airport / Podgorica Golubovci Airbase|Podgorica|Podgorica Municipality|ME|42.3594|19.2519|L
TGG|Sultan Mahmud Airport|Kuala Terengganu|Terengganu|MY|5.3826|103.1030|M
TGJ|Tiga Airport|Tiga|Province des îles Loyauté|NC|-21.0964|167.8038|M
TGM|Târgu Mureş Transilvania International Airport|Recea|Mureş County|RO|46.4677|24.4125|M
TGO|Tongliao Airport|Tongliao|Inner Mongolia Autonomous Region|CN|43.5567|122.2000|M
TGR|Touggourt Sidi Madhi Airport|Touggourt|Touggourt Province|DZ|33.0678|6.0887|M
TGT|Tanga Airport|Tanga|Tanga Region|TZ|-5.0924|39.0712|M
TGU|Toncontín Airport|Tegucigalpa|Francisco Morazán Department|HN|14.0609|-87.2172|M
TGZ|Angel Albino Corzo International Airport|Tuxtla Gutiérrez|Chiapas|MX|16.5616|-93.0257|M
THE|Senador Petrônio Portela Airport|Teresina|Piauí|BR|-5.0602|-42.8237|M
THG|Thangool Airport|Biloela|Queensland|AU|-24.4949|150.5780|M
THL|Tachileik Airport|Tachileik|Shan State|MM|20.4838|99.9354|M
THN|Trollhättan-Vänersborg Airport|Trollhättan|Västra Götalands län|SE|58.3181|12.3450|M
THQ|Tianshui Maijishan Airport|Tianshui (Maiji)|Gansu Province|CN|34.5601|105.8603|M
THR|Mehrabad International Airport|Tehran|Tehran Province|IR|35.6892|51.3144|L
TIA|Tirana International Airport Mother Teresa|Rinas|Durrës County|AL|41.4147|19.7206|L
TIF|Taif International Airport|Taif|Makkah Region|SA|21.4847|40.5441|L
TIH|Tikehau Airport|Tuherahera||PF|-15.1196|-148.2310|M
TIJ|General Abelardo L. Rodriguez International Airport|Tijuana|Baja California|MX|32.5410|-116.9700|L
TIM|Mozes Kilangin Airport|Timika|Papua Tengah (Central Papua)|ID|-4.5298|136.8874|M
TIN|Tindouf Airport|Tindouf|Tindouf Province|DZ|27.7004|-8.1671|M
TIQ|Francisco Manglona Borja / Tinian International Airport|Tinian Island||MP|14.9992|145.6194|M
TIR|Tirupati International Airport|Tirupati|Andhra Pradesh|IN|13.6320|79.5399|L
TIV|Tivat Airport|Tivat|Tivat Municipality|ME|42.4047|18.7233|M
TIW|Tacoma Narrows Airport|Tacoma|Washington|US|47.2674|-122.5773|M
TJA|Capitan Oriel Lea Plaza Airport|Tarija|Tarija Department|BO|-21.5557|-64.7013|M
TJG|Warukin Airport|Tanta-Tabalong|Kalimantan Selatan (South Kalimantan)|ID|-2.2166|115.4360|M
TJH|Konotori Tajima Airport|Toyooka|Hyōgo Prefecture|JP|35.5128|134.7870|M
TJK|Tokat Airport|Tokat|Tokat Province|TR|40.3247|36.3906|M
TJM|Roshchino International Airport|Tyumen|Tyumen Oblast|RU|57.1790|65.3277|L
TJU|Kulob International Airport|Kulob|Khatlon Region|TJ|37.9881|69.8050|L
TKD|Takoradi Airport|Sekondi-Takoradi|Western Region|GH|4.8961|-1.7748|M
TKF|Truckee Tahoe Airport|Truckee|California|US|39.3186|-120.1406|M
TKG|Radin Inten II International Airport|Bandar Lampung|Lampung|ID|-5.2468|105.1825|M
TKK|Chuuk International Airport|Weno Island|Chuuk State|FM|7.4619|151.8430|L
TKN|Tokunoshima Airport|Amagi|Kagoshima Prefecture|JP|27.8364|128.8814|M
TKS|Tokushima Awaodori Airport / JMSDF Tokushima Air Base|Tokushima|Tokushima Prefecture|JP|34.1326|134.6078|L
TKU|Turku Airport|Turku|Southwest Finland Region|FI|60.5141|22.2628|L
TLC|Adolfo López Mateos International Airport|Toluca|México (state)|MX|19.3369|-99.5658|L
TLE|Toliara Airport|Toliara|Toliara|MG|-23.3834|43.7285|M
TLH|Tallahassee International Airport|Tallahassee|Florida|US|30.4012|-84.3543|M
TLM|Zenata – Messali El Hadj Airport|Zenata|Tlemcen Province|DZ|35.0127|-1.4571|L
TLN|Toulon-Hyères Airport|Hyères, Var|Provence-Alpes-Côte-d'Azur|FR|43.0973|6.1460|M
TLQ|Turpan Jiaohe Airport|Turpan|Xinjiang Autonomous Region|CN|43.0308|89.0987|M
TLS|Toulouse-Blagnac Airport|Toulouse/Blagnac|Occitanie|FR|43.6291|1.3638|L
TME|Gustavo Vargas Airport|Tame|Arauca Department|CO|6.4511|-71.7603|M
TMH|Tanah Merah Airport|Tanah Merah|Papua Selatan (South Papua)|ID|-6.0967|140.3035|M
TMJ|Termez Airport|Termez|Surxondaryo Region|UZ|37.2873|67.3119|M
TML|Yakubu Tali International Airport|Tamale|Northern Region|GH|9.5539|-0.8661|L
TMM|Toamasina Ambalamanasy Airport|Toamasina|Toamasina|MG|-18.1135|49.3923|L
TMP|Tampere-Pirkkala Airport|Tampere / Pirkkala|Pirkanmaa Region|FI|61.4141|23.6044|L
TMR|Aguenar – Hadj Bey Akhamok Airport|Tamanrasset|Tamanrasset Province|DZ|22.8110|5.4508|L
TMS|São Tomé International Airport|São Tomé|Água Grande District|ST|0.3782|6.7122|L
TMT|Trombetas Airport|Oriximiná|Pará|BR|-1.4896|-56.3968|M
TMW|Tamworth Airport|Tamworth|New South Wales|AU|-31.0779|150.8455|M
TMX|Timimoun Airport|Timimoun|Timimoun Province|DZ|29.2371|0.2760|M
TNA|Jinan Yaoqiang International Airport|Jinan (Licheng)|Shandong Province|CN|36.8572|117.2160|L
TND|Alberto Delgado Airport|Trinidad|Sancti Spíritus Province|CU|21.7883|-79.9972|M
TNE|New Tanegashima Airport|Tanegashima|Kagoshima Prefecture|JP|30.6051|130.9910|M
TNG|Tangier Ibn Battuta Airport|Tangier|Tanger-Tétouan-Al Hoceïma Region|MA|35.7317|-5.9215|L
TNH|Tonghua Sanyuanpu Airport|Tonghua|Jilin Province|CN|42.0484|125.7340|M
TNJ|Raja Haji Fisabilillah International Airport|Tanjung Pinang-Bintan Island|Kepulauan Riau (Riau Islands)|ID|0.9240|104.5334|M
TNN|Tainan International Airport / Tainan Air Base|Tainan (Rende)|Tainan City|TW|22.9504|120.2060|L
TNR|Ivato International Airport|Antananarivo|Antananarivo|MG|-18.7969|47.4788|L
TOD|Tioman Airport|Tioman Island|Pahang|MY|2.8182|104.1600|M
TOE|Tozeur Nefta International Airport|Tozeur|Tozeur Governorate|TN|33.9397|8.1106|M
TOF|Tomsk Kamov Airport|Tomsk|Tomsk Oblast|RU|56.3803|85.2083|L
TOL|Eugene F. Kranz Toledo Express Airport|Toledo|Ohio|US|41.5868|-83.8078|M
TOM|Tombouktou Airport|Timbuktu|Gao Region|ML|16.7305|-3.0076|L
TOS|Tromsø Airport|Tromsø|Troms|NO|69.6833|18.9189|L
TOU|Touho Airport|Touho|Province Nord|NC|-20.7901|165.2595|M
TOY|Toyama Kitokito Airport|Toyama|Toyama Prefecture|JP|36.6484|137.1874|M
TPA|Tampa International Airport|Tampa|Florida|US|27.9755|-82.5332|L
TPJ|Taplejung Airport|Taplejung|Koshi Province|NP|27.3509|87.6953|M
TPP|Cadete FAP Guillermo Del Castillo Paredes Airport|Tarapoto|San Martín Region|PE|-6.5087|-76.3732|M
TPQ|Amado Nervo National Airport|Tepic|Nayarit|MX|21.4198|-104.8425|M
TPS|Vincenzo Florio Airport Trapani-Birgi|Trapani (TP)|Sicily|IT|37.9114|12.4880|M
TQO|Felipe Carrillo Puerto International Airport Tulum|Tulum|Quintana Roo|MX|20.1721|-87.6603|L
TRA|Tarama Airport|Tarama|Okinawa Prefecture|JP|24.6538|124.6755|M
TRC|Francisco Sarabia Tinoco International Airport|Torreón|Coahuila|MX|25.5623|-103.4046|M
TRD|Trondheim Airport, Værnes|Trondheim|Trøndelag|NO|63.4578|10.9240|L
TRE|Tiree Airport|Balemartine, Argyll and Bute|Scotland|GB|56.4992|-6.8692|M
TRF|Sandefjord Airport, Torp|Sandefjord(Torp)|Vestfold|NO|59.1867|10.2586|L
TRG|Tauranga Airport|Tauranga|Bay of Plenty Region|NZ|-37.6719|176.1960|M
TRI|Tri-Cities Regional TN/VA Airport|Blountville|Tennessee|US|36.4752|-82.4074|M
TRK|Juwata International Airport / Suharnoko Harbani AFB|Tarakan|Kalimantan Utara (North Kalimantan)|ID|3.3251|117.5642|M
TRN|Turin Airport|Caselle Torinese (TO)|Piedmont|IT|45.2008|7.6496|L
TRR|China Bay Airport|Trincomalee|Eastern Province|LK|8.5392|81.1813|M
TRS|Trieste Airport|Ronchi dei Legionari/Trieste|Friuli-Venezia Giulia|IT|45.8279|13.4667|L
TRT|Toraja Airport|Toraja|Sulawesi Selatan (South Sulawesi)|ID|-3.1844|119.9191|M
TRU|Capitán FAP Carlos Martínez de Pinillos International Airport|Trujillo|La Libertad Region|PE|-8.0824|-79.1088|L
TRV|Thiruvananthapuram International Airport|Thiruvananthapuram|Kerala|IN|8.4819|76.9200|L
TRW|Bonriki International Airport|South Tarawa|Gilbert Islands|KI|1.3816|173.1470|L
TRZ|Tiruchirappalli International Airport|Tiruchirappalli|Tamil Nadu|IN|10.7629|78.7177|L
TSA|Taipei Songshan International Airport|Taipei (Songshan)|Taipei City|TW|25.0672|121.5528|L
TSF|Treviso Airport|Treviso (TV)|Veneto|IT|45.6484|12.1944|L
TSJ|Tsushima Airport|Tsushima|Nagasaki Prefecture|JP|34.2849|129.3310|M
TSM|Taos Regional Airport|Taos|New Mexico|US|36.4525|-105.6775|M
TSN|Tianjin Binhai International Airport|Tianjin|Tianjin Municipality|CN|39.1244|117.3460|L
TSR|Timișoara Traian Vuia International Airport|Timişoara|Timiş County|RO|45.8099|21.3379|L
TST|Trang Airport|Trang|Trang Province|TH|7.5087|99.6166|M
TSV|Townsville Airport / RAAF Base Townsville|Townsville|Queensland|AU|-19.2529|146.7665|M
TTA|Tan Tan Airport|Tan Tan|Guelmim-Oued Noun Region|MA|28.4476|-11.1617|M
TTE|Sultan Babullah Airport|Ternate|Maluku Utara (North Maluku)|ID|0.8310|127.3816|M
TTJ|Tottori Sand Dunes Conan Airport|Tottori|Tottori Prefecture|JP|35.5301|134.1650|M
TTN|Trenton Mercer Airport|Ewing Township|New Jersey|US|40.2767|-74.8135|M
TTT|Taitung Airport|Taitung City|Taitung County|TW|22.7549|121.1018|M
TTU|Sania Ramel Airport|Tétouan|Tanger-Tétouan-Al Hoceïma Region|MA|35.5943|-5.3200|L
TUA|Lieutenant Colonel Luis A. Mantilla International Airport|Tulcán|Carchi Province|EC|0.8095|-77.7081|M
TUC|Teniente Benjamín Matienzo International Airport|San Miguel de Tucumán|Tucumán Province|AR|-26.8374|-65.1042|L
TUF|Tours Val de Loire Airport|Tours, Indre-et-Loire|Centre-Val de Loire|FR|47.4322|0.7276|M
TUG|Tuguegarao Airport|Tuguegarao City|Cagayan Province|PH|17.6434|121.7332|M
TUI|Turaif Domestic Airport|Turaif|The Northern Border Region|SA|31.6922|38.7315|M
TUK|Turbat International Airport|Turbat|Balochistan|PK|25.9848|63.0289|L
TUL|Tulsa International Airport|Tulsa|Oklahoma|US|36.1971|-95.8862|L
TUN|Tunis Carthage International Airport|Tunis|Tunis Governorate|TN|36.8510|10.2272|L
TUO|Taupo Airport|Taupo|Waikato Region|NZ|-38.7397|176.0840|M
TUP|Tupelo Regional Airport|Tupelo|Mississippi|US|34.2681|-88.7699|M
TUR|Tucuruí Airport|Tucuruí|Pará|BR|-3.7860|-49.7203|M
TUS|Tucson International Airport|Tucson|Arizona|US|32.1150|-110.9381|L
TUU|Prince Sultan bin Abdulaziz International Airport|Tabuk|Tabuk Region|SA|28.3711|36.6249|L
TVC|Cherry Capital Airport|Traverse City|Michigan|US|44.7414|-85.5822|M
TVF|Thief River Falls Regional Airport|Thief River Falls|Minnesota|US|48.0657|-96.1850|M
TVT|Tashkent-Khumo International Airport|Tashkent|Tashkent Region|UZ|41.3129|69.3955|M
TVY|Dawei Airport|Dawei|Tanintharyi Region|MM|14.1039|98.2036|M
TWF|Joslin Field Magic Valley Regional Airport|Twin Falls|Idaho|US|42.4818|-114.4880|M
TWT|Sanga Sanga Airport|Bongao|Tawi-Tawi Province|PH|5.0482|119.7433|M
TWU|Tawau Airport|Tawau|Sabah|MY|4.3134|118.1215|M
TXE|Rembele Airport|Takengon|Aceh|ID|4.7211|96.8519|M
TXK|Texarkana Regional Airport (Webb Field)|Texarkana|Arkansas|US|33.4537|-93.9910|M
TXN|Huangshan Tunxi International Airport|Huangshan|Anhui Province|CN|29.7333|118.2560|L
TYF|Torsby Airport|Torsby|Värmlanda län|SE|60.1576|12.9913|M
TYL|Captain Victor Montes Arias International Airport|Talara|Piura Region|PE|-4.5766|-81.2541|M
TYN|Taiyuan Wusu International Airport|Taiyuan|Shanxi Province|CN|37.7469|112.6280|L
TYR|Tyler Pounds Regional Airport|Tyler|Texas|US|32.3541|-95.4024|M
TYS|McGhee Tyson Airport|Knoxville/Maryville|Tennessee|US|35.8110|-83.9940|L
TZA|Sir Barry Bowen Municipal Airport|Belize City|Belize District|BZ|17.5172|-88.1958|M
TZL|Tuzla International Airport|Dubrave Gornje|Federation of Bosnia and Herzegovina|BA|44.4599|18.7236|L
TZN|Congo Town Airport|Andros|South Andros|BS|24.1587|-77.5898|M
TZX|Trabzon International Airport|Trabzon|Trabzon Province|TR|40.9951|39.7897|M
UAI|Commander in Chief of FALINTIL, Kay Rala Xanana Gusmão, International Airport|Suai|Cova Lima|TL|-9.3019|125.2863|M
UAQ|Domingo Faustino Sarmiento Airport|San Juan|San Juan Province|AR|-31.5715|-68.4182|M
UAR|Bouarfa Airport|Bouarfa|L'Oriental Region|MA|32.5143|-1.9831|M
UBA|Mário de Almeida Franco Airport|Uberaba|Minas Gerais|BR|-19.7650|-47.9648|M
UBJ|Yamaguchi Ube Airport|Ube|Yamaguchi Prefecture|JP|33.9300|131.2790|M
UBN|Ulaanbaatar Chinggis Khaan International Airport|Ulaanbaatar (Sergelen)|Töv Province|MN|47.6469|106.8198|L
UBP|Ubon Ratchathani Airport|Ubon Ratchathani|Ubon Ratchathani Province|TH|15.2513|104.8700|M
UCB|Ulanqab Jining Airport|Ulanqab|Inner Mongolia Autonomous Region|CN|41.1303|113.1073|M
UCT|Ukhta Airport|Ukhta|Komi Republic|RU|63.5669|53.8047|M
UDI|Ten. Cel. Aviador César Bombonato Airport|Uberlândia|Minas Gerais|BR|-18.8836|-48.2259|M
UDR|Maharana Pratap Airport|Udaipur|Rajasthan|IN|24.6177|73.8961|M
UEL|Quelimane Airport|Quelimane|Zambezia Province|MZ|-17.8555|36.8691|M
UEO|Kumejima Airport|Kumejima|Okinawa Prefecture|JP|26.3634|126.7138|M
UET|Quetta International Airport|Quetta|Balochistan|PK|30.2514|66.9378|L
UFA|Ufa International Airport|Ufa|Republic of Bashkortostan|RU|54.5575|55.8744|L
UGA|Bulgan Airport|Bulgan|Bulgan Province|MN|48.8550|103.4760|M
UGC|Urgench International Airport|Urgench|Xorazm Region|UZ|41.5827|60.6434|L
UGU|Bilorai Airport|Bilogai|Papua Tengah (Central Papua)|ID|-3.7395|137.0312|M
UIB|El Caraño Airport|Quibdó|Chocó Department|CO|5.6908|-76.6412|M
UIH|Phu Cat Airport|Quy Nohn|South Central Coast Region|VN|13.9550|109.0420|M
UIN|Quincy Regional Airport Baldwin Field|Quincy|Illinois|US|39.9427|-91.1946|M
UIO|Mariscal Sucre International Airport|Quito|Pichincha Province|EC|-0.1254|-78.3543|L
UKB|Kobe Airport|Kobe|Hyōgo Prefecture|JP|34.6328|135.2240|L
UKE|Utkela Airport|Bhawanipatna|Odisha|IN|20.0978|83.1833|M
UKK|Oskemen International Airport|Ust-Kamenogorsk (Oskemen)|East Kazakhstan Region|KZ|50.0350|82.4961|L
UKX|Ust-Kut Airport|Ust-Kut|Irkutsk Oblast|RU|56.8567|105.7300|M
ULG|Ölgii Mongolei International Airport|Ölgii|Bayan-Ölgii Province|MN|48.9933|89.9225|M
ULH|Al-Ula International Airport|Al-Ula|Al Madinah Region|SA|26.4836|38.1170|L
ULK|Lensk Airport|Lensk|Sakha (Yakutia) Republic|RU|60.7236|114.8253|M
ULO|Ulaangom Airport|Ulaangom|Uvs Province|MN|50.0666|91.9383|M
ULU|Gulu Airport|Gulu|Northern Region|UG|2.8056|32.2718|M
ULV|Ulyanovsk Baratayevka Airport|Ulyanovsk|Ulyanovsk Oblast|RU|54.2702|48.2256|M
ULY|Ulyanovsk Vostochny Airport|Cherdakly|Ulyanovsk Oblast|RU|54.4010|48.8027|M
UME|Umeå Airport|Umeå|Västerbottens län|SE|63.7918|20.2828|L
UNI|Union Island International Airport|Union Island|Grenadines|VC|12.6001|-61.4119|M
UNK|Unalakleet Airport|Unalakleet|Alaska|US|63.8884|-160.7990|M
UNN|Ranong Airport|Ranong|Ranong Province|TH|9.7776|98.5855|M
UPG|Sultan Hasanuddin International Airport|Makassar|Sulawesi Selatan (South Sulawesi)|ID|-5.0755|119.5537|L
UPN|Uruapan - Licenciado y General Ignacio Lopez Rayon International Airport|Uruapan|Michoacán|MX|19.3967|-102.0390|M
URA|Manshuk Mametova International Airport|Uralsk|West Kazakhstan Region|KZ|51.1520|51.5437|L
URC|Ürümqi Tianshan International Airport|Ürümqi|Xinjiang Autonomous Region|CN|43.9136|87.4794|L
URE|Kuressaare Airport|Kuressaare|Saare County|EE|58.2299|22.5095|M
URG|Rubem Berta Airport|Uruguaiana|Rio Grande do Sul|BR|-29.7822|-57.0382|M
URJ|Uray Airport|Uray|Khanty-Mansi Autonomous Okrug|RU|60.1033|64.8267|M
URT|Surat Thani Airport|Surat Thani|Surat Thani Province|TH|9.1326|99.1356|M
URY|Gurayat Domestic Airport|Gurayat|Al Jawf Region|SA|31.4124|37.2789|M
USA|Concord-Padgett Regional Airport|Concord|North Carolina|US|35.3878|-80.7091|M
USH|Ushuaia - Malvinas Argentinas International Airport|Ushuaia|Tierra del Fuego Province|AR|-54.8433|-68.2958|M
USK|Usinsk Airport|Usinsk|Komi Republic|RU|66.0047|57.3672|M
USM|Samui International Airport|Na Thon (Ko Samui Island)|Surat Thani Province|TH|9.5478|100.0620|L
USN|Ulsan Airport|Ulsan|Ulsan-gwangyeoksi (Ulsan Metropolitan City)|KR|35.5935|129.3520|M
USR|Ust-Nera Airport|Ust-Nera|Sakha (Yakutia) Republic|RU|64.5500|143.1150|M
UST|Northeast Florida Regional Airport|St Augustine|Florida|US|29.9592|-81.3398|M
USU|Francisco B. Reyes (Busuanga) Airport|Coron|Palawan Province|PH|12.1219|120.1008|M
UTH|Udon Thani International Airport|Udon Thani|Udon Thani Province|TH|17.3862|102.7886|L
UTN|Upington Airport|Upington|Northern Cape|ZA|-28.4002|21.2636|M
UTO|Indian Mountain LRRS Airport|Utopia Creek|Alaska|US|65.9928|-153.7040|M
UTP|U-Tapao–Rayong–Pattaya International Airport|Rayong|Rayong Province|TH|12.6799|101.0050|L
UTT|K. D. Matanzima Airport|Mthatha|Eastern Cape|ZA|-31.5464|28.6734|M
UUA|Bugulma Airport|Bugulma|Republic of Tatarstan|RU|54.6412|52.8002|M
UUD|Baikal International Airport|Ulan Ude|Republic of Buryat|RU|51.8086|107.4397|L
UUS|Yuzhno-Sakhalinsk International Airport|Yuzhno-Sakhalinsk|Sakhalin Oblast|RU|46.8855|142.7175|L
UVE|Ouvéa Airport|Ouvéa|Province des îles Loyauté|NC|-20.6409|166.5730|M
UVF|Hewanorra International Airport|Vieux Fort|Vieux Fort|LC|13.7332|-60.9526|L
UYL|Nyala Airport|Nyala|South Darfur State|SD|12.0535|24.9562|M
UYN|Yulin Yuyang Airport|Yulin|Shaanxi Province|CN|38.3597|109.5909|M
UYU|Joya Andina International Airport|Quijarro|Potosí Department|BO|-20.4413|-66.8576|L
VAA|Vaasa Airport|Vaasa|Ostrobothnia Region|FI|63.0502|21.7625|L
VAI|Vanimo Airport|Vanimo|Sandaun Province|PG|-2.6926|141.3028|M
VAM|Villa International Airport Maamigili|Maamigili|Alif Dhaal Atoll|MV|3.4718|72.8326|M
VAN|Van Ferit Melen Airport|Van|Van Province|TR|38.4682|43.3323|M
VAQ|Vanavara Airport|Vanavara|Krasnoyarsk Krai|RU|60.3562|102.3096|M
VAR|Varna Airport|Varna|Varna Province|BG|43.2321|27.8251|L
VAS|Sivas Nuri Demirağ Airport|Sivas|Sivas Province|TR|39.8138|36.9035|M
VAV|Vava'u International Airport|Vava'u Island|Vava'u|TO|-18.5853|-173.9620|L
VAW|Vardø Airport, Svartnes|Vardø|Finnmark|NO|70.3554|31.0449|M
VBS|Brescia Gabriele d'Annunzio Airport|Montichiari (BS)|Lombardy|IT|45.4289|10.3306|M
VBY|Visby Airport|Visby|Gotlands län|SE|57.6628|18.3462|L
VCA|Can Tho International Airport|Can Tho|Southwest Region|VN|10.0834|105.7094|L
VCP|Viracopos International Airport|Campinas|São Paulo|BR|-23.0074|-47.1345|L
VCS|Con Dao Airport|Con Dao|Southeast Region|VN|8.7318|106.6330|M
VCT|Victoria Regional Airport|Victoria|Texas|US|28.8526|-96.9185|M
VDC|Glauber de Andrade Rocha Airport|Vitória da Conquista|Bahia|BR|-14.9079|-40.9148|M
VDE|El Hierro Airport|El Hierro Island|Canary Islands|ES|27.8148|-17.8871|M
VDH|Dong Hoi Airport|Dong Hoi|North Central Region|VN|17.5150|106.5906|M
VDM|Gobernador Castello Airport|Viedma / Carmen de Patagones|Río Negro Province|AR|-40.8692|-63.0004|M
VDO|Van Don International Airport|Van Don|Northeast Region|VN|21.1207|107.4154|M
VDS|Vadsø Airport|Vadsø|Finnmark|NO|70.0653|29.8447|M
VDZ|Valdez Pioneer Field|Valdez|Alaska|US|61.1327|-146.2466|M
VEL|Vernal Regional Airport|Vernal|Utah|US|40.4362|-109.5117|M
VEO|Severo-Yeniseysk Airport|Severo-Yeniseysk|Krasnoyarsk Krai|RU|60.3733|93.0117|M
VER|General Heriberto Jara International Airport|Veracruz|Veracruz|MX|19.1396|-96.1886|L
VFA|Victoria Falls International Airport|Victoria Falls|Matabeleland North Province|ZW|-18.0974|25.8369|L
VGA|Vijayawada International Airport|Vijayawada|Andhra Pradesh|IN|16.5300|80.8049|L
VGO|Vigo Airport|Vigo|Galicia|ES|42.2318|-8.6268|M
VHM|Vilhelmina South Lapland Airport|Vilhelmina|Västerbottens län|SE|64.5791|16.8336|M
VIG|Juan Pablo Pérez Alfonso Airport|El Vigía|Mérida State|VE|8.6241|-71.6727|M
VII|Vinh Airport|Vinh|North Central Region|VN|18.7376|105.6710|M
VIJ|Virgin Gorda Airport|Spanish Town||VG|18.4466|-64.4279|M
VIL|Dakhla Airport|Dakhla||EH|23.7183|-15.9320|L
VIT|Vitoria Airport|Alava|Basque Country|ES|42.8828|-2.7245|M
VIX|Eurico de Aguiar Salles International Airport|Vitória|Espírito Santo|BR|-20.2580|-40.2850|L
VKG|Rach Gia Airport|Rach Gia|Southwest Region|VN|9.9580|105.1324|M
VKO|Vnukovo International Airport|Moscow|Moscow (city)|RU|55.5915|37.2615|L
VKT|Vorkuta Airport|Vorkuta|Komi Republic|RU|67.4886|63.9931|M
VLC|Valencia Airport|Valencia|Valencia (community)|ES|39.4892|-0.4810|L
VLD|Valdosta Regional Airport|Valdosta|Georgia|US|30.7825|-83.2767|M
VLI|Bauerfield International Airport|Port Vila|Shefa|VU|-17.6993|168.3200|L
VLL|Valladolid Airport|Valladolid|Castilla y León|ES|41.7061|-4.8519|M
VLN|Arturo Michelena International Airport|Valencia|Carabobo State|VE|10.1497|-67.9284|L
VLV|Dr. Antonio Nicolás Briceño Airport|Valera|Trujillo State|VE|9.3405|-70.5841|M
VMU|Baimuru Airport|Baimuru|Gulf Province|PG|-7.4970|144.8218|M
VNS|Lal Bahadur Shastri International Airport|Varanasi|Uttar Pradesh|IN|25.4522|82.8625|L
VNX|Vilankulo Airport|Vilanculo|Inhambane Province|MZ|-22.0184|35.3133|M
VOG|Volgograd International Airport|Volgograd|Volgograd Oblast|RU|48.7813|44.3392|L
VOL|Nea Anchialos National Airport|Nea Anchialos|Thessaly|GR|39.2196|22.7943|M
VOZ|Voronezh International Airport|Voronezh|Voronezh Oblast|RU|51.8143|39.2309|M
VPE|Ngjiva Pereira Airport|Ngiva|Cunene Province|AO|-17.0435|15.6838|M
VPN|Vopnafjörður Airport|Vopnafjörður|Eastern Region|IS|65.7206|-14.8506|M
VPS|Destin-Fort Walton Beach Airport|Valparaiso|Florida|US|30.4813|-86.5158|M
VPY|Chimoio Airport|Chimoio|Manica Province|MZ|-19.1513|33.4290|M
VQS|Antonio Rivera Rodriguez Airport|Vieques||PR|18.1348|-65.4936|M
VRA|Juan Gualberto Gomez International Airport|Matanzas|Matanzas Province|CU|23.0344|-81.4353|L
VRB|Vero Beach Regional Airport|Vero Beach|Florida|US|27.6556|-80.4179|M
VRC|Virac Airport|Virac|Catanduanes Province|PH|13.5764|124.2060|M
VRL|Vila Real Airport|Vila Real|Vila Real District|PT|41.2743|-7.7205|M
VRN|Verona Villafranca Valerio Catullo Airport|Caselle (VR)|Veneto|IT|45.3950|10.8873|L
VSA|Carlos Rovirosa Pérez International Airport|Villahermosa|Tabasco|MX|17.9943|-92.8182|L
VSE|Aerodromo Goncalves Lobato (Viseu Airport)|Viseu|Viseu District|PT|40.7255|-7.8890|M
VST|Stockholm Västerås Airport|Stockholm / Västerås|Västmanlanda län|SE|59.5894|16.6336|L
VTE|Wattay International Airport|Vientiane|Vientiane Prefecture|LA|17.9851|102.5667|L
VTU|Hermanos Ameijeiras Airport|Las Tunas|Las Tunas Province|CU|20.9876|-76.9358|M
VTZ|Alluri Sitarama Raju International Airport (Vizag)|Visakhapatnam|Andhra Pradesh|IN|17.9715|83.5036|L
VUP|Alfonso López Pumarejo Airport|Valledupar|César Department|CO|10.4350|-73.2495|M
VUS|Velikiy Ustyug Airport|Velikiy Ustyug|Vologda Oblast|RU|60.7883|46.2600|M
VVC|Vanguardia Airport|Villavicencio|Meta Department|CO|4.1679|-73.6138|M
VVI|Viru Viru International Airport|Santa Cruz|Santa Cruz Department|BO|-17.6448|-63.1354|L
VVO|Vladivostok International Airport|Artyom|Primorsky Krai|RU|43.3963|132.1482|L
VVZ|Illizi Takhamalt Airport|Illizi|Illizi Province|DZ|26.7235|8.6227|M
VXC|Lichinga Airport|Lichinga|Niassa Province|MZ|-13.2740|35.2663|M
VXE|Cesaria Evora International Airport|São Pedro|Barlavento Islands|CV|16.8334|-25.0553|L
VXO|Växjö Kronoberg Airport|Växjö|Kronoberge län|SE|56.9291|14.7280|M
VYI|Vilyuisk Airport|Vilyuisk|Sakha (Yakutia) Republic|RU|63.7567|121.6933|M
WAE|Wadi Al Dawasir Domestic Airport|Wadi Al Dawasir|Riyadh Region|SA|20.5043|45.1996|M
WAG|Wanganui Airport|Wanganui|Manawatu-Wanganui Region|NZ|-39.9635|175.0244|M
WBM|Wapenamanda Airport|Wapenamanda|Enga Province|PG|-5.6353|143.8922|M
WDH|Hosea Kutako International Airport|Windhoek|Khomas Region|NA|-22.4799|17.4709|L
WDS|Shiyan Wudangshan Airport|Shiyan (Maojian)|Hubei Province|CN|32.5929|110.9063|M
WEF|Weifang Nanyuan Airport|Weifang (Kuiwen)|Shandong Province|CN|36.6467|119.1190|M
WEH|Weihai Dashuibo Airport|Weihai|Shandong Province|CN|37.1871|122.2290|M
WEI|Weipa Airport|Weipa|Queensland|AU|-12.6775|141.9226|M
WGA|Wagga Wagga Airport|Forest Hill|New South Wales|AU|-35.1635|147.4683|M
WGN|Shaoyang Wugang Airport|Shaoyang (Wugang)|Hunan Province|CN|26.8061|110.6410|M
WHA|Wuhu Xuanzhou Airport|Wuhu|Anhui Province|CN|31.1045|118.6669|M
WHK|Whakatāne Airport|Whakatāne|Bay of Plenty Region|NZ|-37.9222|176.9170|M
WIC|Wick John O'Groats Airport|Wick|Scotland|GB|58.4589|-3.0931|M
WIL|Nairobi Wilson Airport|Nairobi|Nairobi City County|KE|-1.3217|36.8148|M
WJR|Wajir Airport|Wajir|Wajir County|KE|1.7332|40.0916|M
WJU|Wonju Airport / Hoengseong Air Base (K-38/K-46)|Wonju|Gangwon Teukbyeoljachi-do (Gangwon Special Self-Governing Province)|KR|37.4371|127.9601|M
WKA|Wanaka Airport|Wanaka|Otago Region|NZ|-44.7221|169.2463|M
WKJ|Wakkanai Airport|Wakkanai|Hokkaidō Prefecture|JP|45.4042|141.8010|M
WKK|Aleknagik / New Airport|Aleknagik|Alaska|US|59.2826|-158.6180|M
WLG|Wellington International Airport|Wellington|Wellington Region|NZ|-41.3268|174.8069|L
WLS|Hihifo Airport|Wallis Island||WF|-13.2394|-176.1986|L
WMI|Warsaw Modlin Airport|Nowy Dwór Mazowiecki|Masovian Voivodeship|PL|52.4511|20.6518|L
WMN|Maroantsetra Airport|Maroantsetra|Toamasina|MG|-15.4377|49.6891|M
WMT|Zunyi Maotai Airport|Zunyi|Guizhou Province|CN|27.9618|106.4354|M
WMX|Wamena Airport|Wamena|Papua Pegunungan (Highland Papua)|ID|-4.0973|138.9524|M
WNI|Matahora Airport|Wangi-wangi Island|Sulawesi Tenggara (Southeast Sulawesi)|ID|-5.2921|123.6362|M
WNP|Naga Airport|Naga|Camarines Sur Province|PH|13.5849|123.2700|M
WNR|Windorah Airport|Windorah|Queensland|AU|-25.4106|142.6684|M
WNS|Shaheed Benazirabad Airport|Nawabashah|Sindh|PK|26.2194|68.3901|M
WNZ|Wenzhou Longwan International Airport|Wenzhou (Longwan)|Zhejiang Province|CN|27.9106|120.8535|L
WOS|Wonsan Kalma Airport|Wonsan|Kangwon Province|KP|39.1652|127.4879|M
WRE|Whangarei Airport|Whangarei|Northland Region|NZ|-35.7693|174.3637|M
WRG|Wrangell Airport|Wrangell|Alaska|US|56.4843|-132.3700|M
WRO|Copernicus Wrocław Airport|Wrocław|Lower Silesian Voivodeship|PL|51.1037|16.8821|L
WST|Westerly State Airport|Westerly|Rhode Island|US|41.3496|-71.8034|M
WSZ|Westport Airport|Westport|West Coast Region|NZ|-41.7371|171.5790|M
WTB|Toowoomba Wellcamp Airport|Toowoomba|Queensland|AU|-27.5583|151.7933|L
WUA|Wuhai Airport|Wuhai|Inner Mongolia Autonomous Region|CN|39.7934|106.7993|M
WUH|Wuhan Tianhe International Airport|Wuhan (Huangpi)|Hubei Province|CN|30.7748|114.2137|L
WUS|Nanping Wuyishan Airport|Wuyishan|Fujian Province|CN|27.7019|118.0010|M
WUU|Wau Airport|Wau|Western Bahr el Ghazal State|SS|7.7258|27.9750|M
WUX|Sunan Shuofang International Airport|Wuxi|Jiangsu Province|CN|31.4970|120.4304|L
WUZ|Wuzhou Xijiang Airport|Tangbu|Guangxi Autonomous Region|CN|23.4032|111.0933|M
WVB|Walvis Bay International Airport|Walvis Bay(Rooikop)|Erongo Region|NA|-22.9793|14.6471|L
WWK|Wewak International Airport|Wewak|East Sepik Province|PG|-3.5838|143.6690|M
WYA|Whyalla Airport|Whyalla|South Australia|AU|-33.0589|137.5140|M
WYS|Yellowstone Airport|West Yellowstone|Montana|US|44.6884|-111.1180|M
XAI|Xinyang Minggang Airport|Xinyang|Henan Province|CN|32.5408|114.0791|M
XAP|Serafin Enoss Bertaso Airport|Chapecó|Santa Catarina|BR|-27.1342|-52.6566|M
XBJ|Birjand International Airport|Birjand|South Khorasan Province|IR|32.8965|59.2813|L
XCH|Christmas Island International Airport|Flying Fish Cove||CX|-10.4504|105.6911|M
XCR|Chalons Vatry airport|Chalons en Champagne|Grand Est|FR|48.7733|4.2061|M
XFN|Xiangyang Liuji Airport|Xiangyang (Xiangzhou)|Hubei Province|CN|32.1522|112.2917|M
XIC|Xichang Qingshan Airport|Liangshan (Xichang)|Sichuan Province|CN|27.9891|102.1840|M
XIL|Xilinhot Airport|Xilinhot|Inner Mongolia Autonomous Region|CN|43.9156|115.9640|M
XIY|Xi'an Xianyang International Airport|Xi'an|Shaanxi Province|CN|34.4422|108.7624|L
XKS|Kasabonika Airport|Kasabonika|Ontario|CA|53.5247|-88.6428|M
XMN|Xiamen Gaoqi International Airport|Xiamen|Fujian Province|CN|24.5439|118.1275|L
XMS|Coronel E Carvajal Airport|Macas|Morona-Santiago Province|EC|-2.2992|-78.1208|M
XNA|Northwest Arkansas National Airport|Fayetteville/Springdale/Rogers|Arkansas|US|36.2819|-94.3068|M
XNN|Xining Caojiabao International Airport|Haidong (Huzhu Tu Autonomous County)|Qinghai Province|CN|36.5277|102.0402|L
XPL|Palmerola International Airport|Palmerola|Comayagua Department|HN|14.3824|-87.6212|L
XQP|Quepos Managua Airport|Quepos|Puntarenas Province|CR|9.4432|-84.1298|M
XQU|Qualicum Beach Airport|Qualicum Beach|British Columbia|CA|49.3375|-124.3931|M
XRY|Jerez Airport|Jerez de la Frontera|Andalucía|ES|36.7446|-6.0601|M
XSC|South Caicos Airport|South Caicos|South Caicos|TC|21.5157|-71.5285|M
XSP|Seletar Airport|Seletar|North East|SG|1.4156|103.8667|M
XTG|Thargomindah Airport|Thargomindah|Queensland|AU|-27.9864|143.8121|M
XUZ|Xuzhou Guanyin International Airport|Xuzhou|Jiangsu Province|CN|34.0591|117.5553|M
XWA|Williston Basin International Airport|Williston|North Dakota|US|48.2609|-103.7512|M
YAA|Anahim Lake Airport|Anahim Lake|British Columbia|CA|52.4515|-125.3038|M
YAG|Fort Frances Municipal Airport|Fort Frances|Ontario|CA|48.6557|-93.4435|M
YAK|Yakutat Airport|Yakutat|Alaska|US|59.5087|-139.6604|M
YAM|Sault Ste Marie Airport|Sault Ste Marie|Ontario|CA|46.4832|-84.5085|M
YAP|Yap International Airport|Yap Island|Yap State|FM|9.4989|138.0830|L
YAY|St. Anthony Airport|St. Anthony|Newfoundland and Labrador|CA|51.3919|-56.0832|M
YAZ|Tofino / Long Beach Airport|Tofino|British Columbia|CA|49.0798|-125.7756|M
YBC|Baie-Comeau Airport|Baie-Comeau|Quebec|CA|49.1325|-68.2044|M
YBG|Saguenay-Bagotville Airport|Saguenay|Quebec|CA|48.3301|-70.9920|M
YBK|Baker Lake Airport|Baker Lake|Nunavut|CA|64.2989|-96.0778|M
YBL|Campbell River Airport|Campbell River|British Columbia|CA|49.9508|-125.2710|M
YBP|Yibin Wuliangye Airport|Yibin (Cuiping)|Sichuan Province|CN|28.8584|104.5262|M
YBR|Brandon Municipal Airport|Brandon|Manitoba|CA|49.9100|-99.9519|M
YBX|Lourdes-de-Blanc-Sablon Airport|Blanc-Sablon|Quebec|CA|51.4436|-57.1853|M
YBY|Bonnyville Airport|Bonnyville|Alberta|CA|54.3042|-110.7440|M
YCB|Cambridge Bay Airport|Cambridge Bay|Nunavut|CA|69.1081|-105.1380|M
YCD|Nanaimo Airport|Nanaimo|British Columbia|CA|49.0550|-123.8699|M
YCG|Castlegar/West Kootenay Regional Airport|Castlegar|British Columbia|CA|49.2964|-117.6320|M
YCM|Niagara District Airport|Niagara-on-the-Lake|Ontario|CA|43.1916|-79.1717|M
YCU|Yuncheng Yanhu International Airport|Yuncheng (Yanhu)|Shaanxi Province|CN|35.1178|111.0340|L
YDA|Dawson City Airport|Dawson City|Yukon|CA|64.0431|-139.1280|M
YDF|Deer Lake Airport|Deer Lake|Newfoundland and Labrador|CA|49.2082|-57.3961|M
YDN|Dauphin Barker Airport|Dauphin|Manitoba|CA|51.1008|-100.0520|M
YEG|Edmonton International Airport|Edmonton|Alberta|CA|53.3097|-113.5800|L
YEI|Bursa Yenişehir Airport|Yenişehir|Bursa Province|TR|40.2552|29.5626|M
YEV|Inuvik Mike Zubko Airport|Inuvik|Northwest Territories|CA|68.3042|-133.4830|M
YFB|Iqaluit Airport|Iqaluit|Nunavut|CA|63.7564|-68.5558|M
YFC|Fredericton International Airport|Fredericton|New Brunswick|CA|45.8687|-66.5299|M
YFS|Fort Simpson Airport|Fort Simpson|Northwest Territories|CA|61.7602|-121.2370|M
YGJ|Yonago Kitaro Airport / JASDF Miho Air Base|Yonago|Tottori Prefecture|JP|35.4922|133.2360|M
YGL|La Grande Rivière Airport|La Grande Rivière|Quebec|CA|53.6253|-77.7042|M
YGP|Michel-Pouliot Gaspé Airport|Gaspé|Quebec|CA|48.7749|-64.4819|M
YGR|Îles-de-la-Madeleine Airport|Les Îles-de-la-Madeleine|Quebec|CA|47.4252|-61.7786|M
YGV|Havre-Saint-Pierre Airport|Havre-Saint-Pierre|Quebec|CA|50.2819|-63.6114|M
YGW|Kuujjuarapik Airport|Kuujjuarapik|Quebec|CA|55.2819|-77.7653|M
YHM|John C. Munro Hamilton International Airport|Hamilton|Ontario|CA|43.1713|-79.9294|L
YHU|Montréal / Saint-Hubert Metropolitan Airport|Montréal|Quebec|CA|45.5175|-73.4169|M
YHY|Hay River / Merlyn Carter Airport|Hay River|Northwest Territories|CA|60.8397|-115.7830|M
YHZ|Halifax / Stanfield International Airport|Halifax|Nova Scotia|CA|44.8808|-63.5086|L
YIA|Yogyakarta International Airport|Yogyakarta|Yogyakarta|ID|-7.9053|110.0573|L
YIC|Yichun Mingyueshan Airport|Yichun|Jiangxi Province|CN|27.8025|114.3062|M
YIE|Arxan Yi'ershi Airport|Arxan|Inner Mongolia Autonomous Region|CN|47.3106|119.9117|M
YIF|St Augustin Airport|St-Augustin|Quebec|CA|51.2117|-58.6583|M
YIH|Yichang Sanxia Airport|Yichang (Xiaoting)|Hubei Province|CN|30.5541|111.4826|M
YIN|Ili Yining International Airport|Ili (Yining / Ghulja)|Xinjiang Autonomous Region|CN|43.9558|81.3303|M
YIV|Island Lake Airport|Island Lake|Manitoba|CA|53.8572|-94.6536|M
YIW|Yiwu Airport|Yiwu/Jinhua|Zhejiang Province|CN|29.3421|120.0312|L
YKA|Kamloops John Moose Fulton Field Regional Airport|Kamloops|British Columbia|CA|50.7030|-120.4486|M
YKF|Region of Waterloo International Airport|Breslau|Ontario|CA|43.4608|-80.3786|M
YKH|Yingkou Lanqi Airport|Yingkou (Laobian)|Liaoning Province|CN|40.5425|122.3586|M
YKL|Schefferville Airport|Schefferville|Quebec|CA|54.8053|-66.8053|M
YKM|Yakima Air Terminal McAllister Field|Yakima|Washington|US|46.5682|-120.5440|M
YKO|Hakkari Yüksekova Airport|Hakkari|Hakkâri Province|TR|37.5497|44.2381|M
YKS|Platon Oyunsky Yakutsk International Airport|Yakutsk|Sakha (Yakutia) Republic|RU|62.0933|129.7710|L
YLK|Barrie-Lake Simcoe Regional Airport|Barrie|Ontario|CA|44.4851|-79.5547|M
YLL|Lloydminster Airport|Lloydminster|Alberta|CA|53.3092|-110.0730|M
YLW|Kelowna International Airport|Kelowna|British Columbia|CA|49.9561|-119.3780|L
YLX|Yulin Fumian Airport|Yulin|Guangxi Autonomous Region|CN|22.4330|110.1200|M
YMM|Fort McMurray International Airport|Fort McMurray|Alberta|CA|56.6533|-111.2220|M
YMO|Moosonee Airport|Moosonee|Ontario|CA|51.2911|-80.6078|M
YMS|Moises Benzaquen Rengifo Airport|Yurimaguas|Loreto Region|PE|-5.8938|-76.1182|M
YMT|Chapais Airport|Chibougamau|Quebec|CA|49.7719|-74.5281|M
YMX|Montreal Mirabel International Airport|Montréal|Quebec|CA|45.6795|-74.0387|M
YNA|Natashquan Airport|Natashquan|Quebec|CA|50.1901|-61.7890|M
YNB|Prince Abdulmohsen Bin Abdulaziz International Airport|Yanbu|Al Madinah Region|SA|24.1442|38.0634|L
YND|Ottawa / Gatineau Airport|Gatineau|Quebec|CA|45.5217|-75.5636|M
YNJ|Yanji Chaoyangchuan Airport|Yanji|Jilin Province|CN|42.8828|129.4510|M
YNL|Points North Landing Airport|Points North Landing|Saskatchewan|CA|58.2767|-104.0820|M
YNT|Yantai Penglai International Airport|Yantai|Shandong Province|CN|37.6597|120.9781|L
YNY|Yangyang International Airport|Gonghang-ro|Gangwon Teukbyeoljachi-do (Gangwon Special Self-Governing Province)|KR|38.0605|128.6698|L
YNZ|Yancheng Nanyang International Airport|Yancheng (Tinghu)|Jiangsu Province|CN|33.4283|120.2054|L
YOJ|High Level Airport|High Level|Alberta|CA|58.6214|-117.1650|M
YOL|Yola Airport|Yola|Adamawa State|NG|9.2576|12.4304|M
YOW|Ottawa Macdonald-Cartier International Airport|Ottawa|Ontario|CA|45.3225|-75.6692|L
YPA|Prince Albert Glass Field|Prince Albert|Saskatchewan|CA|53.2142|-105.6730|M
YPE|Peace River Airport|Peace River|Alberta|CA|56.2269|-117.4470|M
YPL|Pickle Lake Airport|Pickle Lake|Ontario|CA|51.4464|-90.2142|M
YPN|Port-Menier Airport|Port-Menier|Quebec|CA|49.8364|-64.2886|M
YPQ|Peterborough Regional Airport|Peterborough|Ontario|CA|44.2323|-78.3621|M
YPR|Prince Rupert Airport|Prince Rupert|British Columbia|CA|54.2861|-130.4450|M
YPW|Powell River Airport|Powell River|British Columbia|CA|49.8342|-124.5000|M
YPX|Puvirnituq Airport|Puvirnituq|Quebec|CA|60.0506|-77.2869|M
YPY|Fort Chipewyan Airport|Fort Chipewyan|Alberta|CA|58.7672|-111.1170|M
YPZ|Burns Lake Airport|Burns Lake|British Columbia|CA|54.3764|-125.9510|M
YQA|Muskoka Airport|Gravenhurst|Ontario|CA|44.9754|-79.3065|M
YQB|Quebec Jean Lesage International Airport|Quebec|Quebec|CA|46.7911|-71.3933|L
YQD|The Pas Airport|The Pas|Manitoba|CA|53.9714|-101.0910|M
YQG|Windsor International Airport|Windsor|Ontario|CA|42.2756|-82.9556|L
YQH|Watson Lake Airport|Watson Lake|Yukon|CA|60.1168|-128.8220|M
YQK|Kenora Airport|Kenora|Ontario|CA|49.7883|-94.3631|M
YQL|Lethbridge County Airport|Lethbridge|Alberta|CA|49.6303|-112.8000|M
YQM|Greater Moncton Roméo LeBlanc International Airport|Moncton|New Brunswick|CA|46.1132|-64.6772|M
YQN|Nakina Airport|Nakina|Ontario|CA|50.1828|-86.6964|M
YQQ|Comox Valley International Airport / CFB Comox|Comox|British Columbia|CA|49.7108|-124.8870|M
YQR|Regina International Airport|Regina|Saskatchewan|CA|50.4319|-104.6609|M
YQT|Thunder Bay International Airport|Thunder Bay|Ontario|CA|48.3719|-89.3239|M
YQU|Grande Prairie Airport|Grande Prairie|Alberta|CA|55.1797|-118.8850|M
YQX|Gander International Airport|Gander|Newfoundland and Labrador|CA|48.9363|-54.5677|M
YQY|Sydney / J.A. Douglas McCurdy Airport|Sydney|Nova Scotia|CA|46.1611|-60.0498|M
YQZ|Quesnel Airport|Quesnel|British Columbia|CA|53.0261|-122.5100|M
YRB|Resolute Bay Airport|Resolute Bay|Nunavut|CA|74.7169|-94.9694|M
YRJ|Roberval Airport|Roberval|Quebec|CA|48.5197|-72.2657|M
YRL|Red Lake Airport|Red Lake|Ontario|CA|51.0669|-93.7931|M
YRO|Ottawa / Rockcliffe Airport|Ottawa|Ontario|CA|45.4605|-75.6440|M
YRT|Rankin Inlet Airport|Rankin Inlet|Nunavut|CA|62.8114|-92.1158|M
YSB|Sudbury Airport|Sudbury|Ontario|CA|46.6250|-80.7989|M
YSF|Stony Rapids Airport|Stony Rapids|Saskatchewan|CA|59.2503|-105.8410|M
YSJ|Saint John Airport|Saint John|New Brunswick|CA|45.3161|-65.8903|M
YSM|Fort Smith Airport|Fort Smith|Northwest Territories|CA|60.0203|-111.9620|M
YSQ|Songyuan Chaganhu Airport|Qian Gorlos Mongol Autonomous County|Jilin Province|CN|44.9311|124.5521|M
YTH|Thompson Airport|Thompson|Manitoba|CA|55.8011|-97.8642|M
YTS|Timmins/Victor M. Power|Timmins|Ontario|CA|48.5697|-81.3767|M
YTY|Yangzhou Taizhou Airport|Yangzhou|Jiangsu Province|CN|32.5634|119.7198|M
YTZ|Billy Bishop Toronto City Airport|Toronto|Ontario|CA|43.6279|-79.3955|M
YUM|Yuma International Airport / Marine Corps Air Station Yuma|Yuma|Arizona|US|32.6509|-114.6094|M
YUS|Yushu Batang Airport|Yushu (Batang)|Qinghai Province|CN|32.8364|97.0364|M
YUX|Hall Beach Airport|Sanirajak|Nunavut|CA|68.7761|-81.2425|M
YUY|Rouyn Noranda Airport|Rouyn-Noranda|Quebec|CA|48.2061|-78.8356|M
YVB|Bonaventure Airport|Bonaventure|Quebec|CA|48.0711|-65.4603|M
YVC|La Ronge Airport|La Ronge|Saskatchewan|CA|55.1514|-105.2620|M
YVO|Val-d'Or Airport|Val-d'Or|Quebec|CA|48.0533|-77.7828|M
YVP|Kuujjuaq Airport|Kuujjuaq|Quebec|CA|58.0961|-68.4269|M
YVQ|Norman Wells Airport|Norman Wells|Northwest Territories|CA|65.2816|-126.7980|M
YVV|Wiarton Airport|Wiarton|Ontario|CA|44.7458|-81.1072|M
YWG|Winnipeg / James Armstrong Richardson International Airport|Winnipeg|Manitoba|CA|49.9100|-97.2399|L
YWK|Wabush Airport|Wabush|Newfoundland and Labrador|CA|52.9219|-66.8644|M
YWL|Williams Lake Airport|Williams Lake|British Columbia|CA|52.1831|-122.0540|M
YXC|Cranbrook/Canadian Rockies International Airport|Cranbrook|British Columbia|CA|49.6108|-115.7820|M
YXE|Saskatoon John G. Diefenbaker International Airport|Saskatoon|Saskatchewan|CA|52.1707|-106.7008|L
YXH|Medicine Hat Regional Airport|Medicine Hat|Alberta|CA|50.0189|-110.7210|M
YXJ|Fort St John / North Peace Regional Airport|Fort Saint John|British Columbia|CA|56.2381|-120.7400|M
YXL|Sioux Lookout Airport|Sioux Lookout|Ontario|CA|50.1139|-91.9053|M
YXS|Prince George (International) Airport|Prince George|British Columbia|CA|53.8843|-122.6666|M
YXT|Northwest Regional Airport Terrace-Kitimat|Terrace|British Columbia|CA|54.4685|-128.5760|M
YXU|London International Airport|London|Ontario|CA|43.0328|-81.1490|M
YXX|Abbotsford International Airport|Abbotsford|British Columbia|CA|49.0253|-122.3610|M
YXY|Whitehorse / Erik Nielsen International Airport|Whitehorse|Yukon|CA|60.7085|-135.0657|M
YYA|Yueyang Sanhe Airport|Yueyang (Yueyanglou)|Hunan Province|CN|29.3117|113.2816|M
YYB|North Bay Jack Garland Airport|North Bay|Ontario|CA|46.3636|-79.4228|M
YYD|Smithers Airport|Smithers|British Columbia|CA|54.8247|-127.1830|M
YYE|Fort Nelson Airport|Fort Nelson|British Columbia|CA|58.8364|-122.5970|M
YYF|Penticton Airport|Penticton|British Columbia|CA|49.4631|-119.6020|M
YYG|Charlottetown Airport|Charlottetown|Prince Edward Island|CA|46.2889|-63.1252|M
YYJ|Victoria International Airport|Victoria|British Columbia|CA|48.6472|-123.4278|L
YYL|Lynn Lake Airport|Lynn Lake|Manitoba|CA|56.8639|-101.0760|M
YYQ|Churchill Airport|Churchill|Manitoba|CA|58.7392|-94.0650|M
YYR|Goose Bay Airport|Goose Bay|Newfoundland and Labrador|CA|53.3192|-60.4258|M
YYT|St. John's International Airport|St. John's|Newfoundland and Labrador|CA|47.6186|-52.7519|L
YYY|Mont Joli Airport|Mont-Joli|Quebec|CA|48.6086|-68.2081|M
YZF|Yellowknife International Airport|Yellowknife|Northwest Territories|CA|62.4628|-114.4400|M
YZP|Sandspit Airport|Sandspit|British Columbia|CA|53.2543|-131.8140|M
YZS|Coral Harbour Airport|Coral Harbour|Nunavut|CA|64.1933|-83.3594|M
YZT|Port Hardy Airport|Port Hardy|British Columbia|CA|50.6806|-127.3670|M
YZU|Whitecourt Airport|Whitecourt|Alberta|CA|54.1439|-115.7870|M
YZV|Sept-Îles Airport|Sept-Îles|Quebec|CA|50.2233|-66.2656|M
YZY|Zhangye Ganzhou Airport|Zhangye (Ganzhou)|Gansu Province|CN|38.8019|100.6750|M
ZAD|Zadar Airport|Zadar|Zadar County|HR|44.0970|15.3536|L
ZAH|Zahedan International Airport|Zahedan|Sistan and Baluchestan Province|IR|29.4757|60.9062|L
ZAL|Pichoy Airport|Valdivia|Los Ríos Region|CL|-39.6500|-73.0861|M
ZAM|Zamboanga International Airport|Zamboanga|Zamboanga City|PH|6.9224|122.0600|L
ZAT|Zhaotong Zhaoyang Airport|Zhaotong|Yunnan Province|CN|27.2058|103.6915|M
ZAZ|Zaragoza Airport|Zaragoza|Aragón|ES|41.6662|-1.0415|L
ZBF|Bathurst Airport|South Tetagouche|New Brunswick|CA|47.6297|-65.7389|M
ZBR|Chabahar Konarak International Airport|Konarak|Sistan and Baluchestan Province|IR|25.4432|60.3822|M
ZCL|General Leobardo C. Ruiz International Airport|Zacatecas|Zacatecas|MX|22.8949|-102.6872|M
ZCO|La Araucanía International Airport|Temuco|Araucanía Region|CL|-38.9259|-72.6515|L
ZEL|Bella Bella (Campbell Island) Airport|Bella Bella|British Columbia|CA|52.1850|-128.1570|M
ZHA|Zhanjiang Wuchuan International Airport|Zhanjiang|Guangdong Province|CN|21.4817|110.5903|L
ZHY|Zhongwei Shapotou Airport|Zhongwei (Shapotou)|Ningxia Autonomous Region|CN|37.5731|105.1545|M
ZIA|Zhukovsky International Airport|Moscow|Moscow Oblast|RU|55.5533|38.1500|L
ZIG|Ziguinchor Airport|Ziguinchor|Ziguinchor Region|SN|12.5556|-16.2833|M
ZIH|Ixtapa-Zihuatanejo International Airport|Ixtapa|Guerrero|MX|17.6018|-101.4606|L
ZIX|Zhigansk Airport|Zhigansk|Sakha (Yakutia) Republic|RU|66.7965|123.3610|M
ZKP|Zyryanka Airport|Zyryanka|Sakha (Yakutia) Republic|RU|65.7485|150.8889|M
ZLO|Playa de Oro International Airport|Manzanillo|Colima|MX|19.1448|-104.5590|M
ZMT|Masset Airport|Masset|British Columbia|CA|54.0275|-132.1250|M
ZND|Zinder Airport|Zinder|Zinder Region|NE|13.7790|8.9838|M
ZNE|Newman Airport|Newman|Western Australia|AU|-23.4178|119.8030|M
ZOS|Cañal Bajo Carlos Hott Siebert Airport|Osorno|Los Lagos Region|CL|-40.6112|-73.0610|M
ZQN|Queenstown Airport|Queenstown|Otago Region|NZ|-45.0192|168.7464|L
ZQZ|Zhangjiakou Ningyuan Airport|Zhangjiakou|Hebei Province|CN|40.7387|114.9334|M
ZSA|San Salvador International Airport|San Salvador|San Salvador|BS|24.0630|-74.5232|L
ZSE|Saint-Pierre Pierrefonds Airport|Saint-Pierre|Saint-Pierre Arrondissement|RE|-21.3194|55.4225|L
ZSJ|Sandy Lake Airport|Sandy Lake|Ontario|CA|53.0642|-93.3444|M
ZTH|Zakynthos International Airport "Dionysios Solomos"|Zakynthos|Ionian Islands|GR|37.7509|20.8843|L
ZUH|Zhuhai Jinwan Airport|Zhuhai (Jinwan)|Guangdong Province|CN|22.0064|113.3760|L
ZYI|Zunyi Xinzhou Airport|Zunyi|Guizhou Province|CN|27.8107|107.2472|M
ZYL|Osmany International Airport|Sylhet|Sylhet Division|BD|24.9640|91.8647|L
`;

/** Scheduled-service airports beyond AIRPORTS, for code lookups and the airport picker. */
export const MORE_AIRPORTS: Airport[] = ROWS.trim().split('\n').map((row) => {
    const [code, name, city, region, country, lat, lon] = row.split('|');
    return { code, name, city, country: COUNTRIES[country] ?? country, lat: Number(lat), lon: Number(lon),
        ...(region ? { region } : {}) };
});
